// @ts-nocheck
// AUTO-GENERATED by scripts/generate-real-exam-translations.ts — do not edit by hand.
import type { MultilingualQuestion } from '../types/multilingualQuestion';

export const realExamMultilingual: MultilingualQuestion[] = [
  {
    "id": "real-2024-03-15-q1",
    "text": {
      "en": "You are driving at 50 km/h in a built-up area. A child runs onto the road from between parked cars. What should you do?",
      "nl": "Je rijdt met 50 km/u in een bebouwde kom. Tussen geparkeerde auto's door rent er een kind de weg op. Wat moet je doen?",
      "ar": "أنت تقود بسرعة 50 كم/ساعة في منطقة مأهولة. طفل يركض على الطريق من بين السيارات المتوقفة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q1o1",
        "text": {
          "en": "Brake immediately",
          "nl": "Onmiddellijk remmen",
          "ar": "الفرامل على الفور"
        }
      },
      {
        "id": "real-2024-03-15-q1o2",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      },
      {
        "id": "real-2024-03-15-q1o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q1o1",
    "explanation": {
      "en": "Immediate braking is required when a child has entered the roadway unexpectedly, as this poses an immediate collision risk.",
      "nl": "Onmiddellijk remmen is vereist wanneer een kind onverwacht de rijbaan is binnengekomen, omdat dit een onmiddellijk aanrijdingsgevaar oplevert.",
      "ar": "الكبح الفوري مطلوب عندما يدخل الطفل الطريق بشكل غير متوقع، لأن هذا يشكل خطر تصادم فوري."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2024-03-15-q2",
    "text": {
      "en": "At an unmarked intersection, you approach from the left. A car approaches from the right. Who has priority?",
      "nl": "Op een ongemarkeerd kruispunt nadert u van links. Van rechts nadert een auto. Wie heeft voorrang?",
      "ar": "عند تقاطع غير محدد، تقترب من اليسار. سيارة تقترب من اليمين. من له الأولوية ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q2o1",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      },
      {
        "id": "real-2024-03-15-q2o2",
        "text": {
          "en": "The car from the right has priority",
          "nl": "De auto van rechts heeft voorrang",
          "ar": "السيارة من اليمين لها الأولوية"
        }
      },
      {
        "id": "real-2024-03-15-q2o3",
        "text": {
          "en": "Neither has priority",
          "nl": "Geen van beide heeft prioriteit",
          "ar": "لا يتمتع أي منهما بالأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q2o2",
    "explanation": {
      "en": "At unmarked intersections, traffic from the right has priority.",
      "nl": "Op ongemarkeerde kruispunten heeft verkeer van rechts voorrang.",
      "ar": "عند التقاطعات غير المميزة، تكون الأولوية لحركة المرور من اليمين."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2024-03-15-q3",
    "text": {
      "en": "You are driving on a motorway at 100 km/h. The speed limit changes to 80 km/h due to roadworks. What should you do?",
      "nl": "U rijdt op een snelweg met 100 km/u. De snelheidslimiet verandert naar 80 km/u als gevolg van wegwerkzaamheden. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع بسرعة 100 كم/ساعة. يتغير الحد الأقصى للسرعة إلى 80 كم/ساعة بسبب أعمال الطرق. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q3o1",
        "text": {
          "en": "Gradually reduce speed to 80 km/h",
          "nl": "Verminder geleidelijk de snelheid tot 80 km/u",
          "ar": "قلل السرعة تدريجيًا إلى 80 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q3o2",
        "text": {
          "en": "Brake hard to reach 80 km/h quickly",
          "nl": "Rem hard om snel 80 km/u te bereiken",
          "ar": "الفرامل بقوة للوصول إلى 80 كم/ساعة بسرعة"
        }
      },
      {
        "id": "real-2024-03-15-q3o3",
        "text": {
          "en": "Continue at 100 km/h until you see the roadworks",
          "nl": "Ga verder met 100 km/u tot je de wegwerkzaamheden ziet",
          "ar": "استمر بسرعة 100 كم/ساعة حتى ترى أعمال الطرق"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q3o1",
    "explanation": {
      "en": "Speed limits must be obeyed immediately when the sign is visible, but braking should be gradual for safety. When you see a lower speed limit sign for roadworks, reduce speed gradually to the new limit.",
      "nl": "Snelheidslimieten moeten onmiddellijk worden nageleefd wanneer het bord zichtbaar is, maar voor de veiligheid moet het remmen geleidelijk gebeuren. Wanneer u een bord met een lagere snelheidslimiet ziet voor wegwerkzaamheden, verlaagt u de snelheid geleidelijk tot de nieuwe limiet.",
      "ar": "يجب الالتزام بحدود السرعة على الفور عندما تكون اللافتة مرئية، ولكن يجب أن يكون الكبح تدريجيًا من أجل السلامة. عندما ترى علامة حد سرعة أقل لأعمال الطرق، قلل السرعة تدريجيًا إلى الحد الجديد."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q4",
    "text": {
      "en": "You are approaching a roundabout. A cyclist is already on the roundabout. What should you do?",
      "nl": "U nadert een rotonde. Er staat al een fietser op de rotonde. Wat moet je doen?",
      "ar": "أنت تقترب من دوار. راكب دراجة موجود بالفعل على الدوار. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q4o1",
        "text": {
          "en": "Give way to the cyclist",
          "nl": "Maak plaats voor de fietser",
          "ar": "إفساح الطريق لراكب الدراجة"
        }
      },
      {
        "id": "real-2024-03-15-q4o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2024-03-15-q4o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q4o1",
    "explanation": {
      "en": "Cyclists already on the roundabout have priority and must be given way to. You must stop and wait for the cyclist to pass before entering the roundabout.",
      "nl": "Fietsers die al op de rotonde staan hebben voorrang en moeten voorrang krijgen. Je moet stoppen en wachten tot de fietser voorbij is voordat je de rotonde opgaat.",
      "ar": "يتمتع راكبو الدراجات الموجودون بالفعل في الدوار بالأولوية ويجب إفساح المجال لهم. يجب عليك التوقف والانتظار حتى يمر راكب الدراجة قبل الدخول إلى الدوار."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2024-03-15-q5",
    "text": {
      "en": "You are driving in a residential area. The speed limit is 30 km/h. A child is playing near the road. What should you do?",
      "nl": "Je rijdt in een woonwijk. De maximumsnelheid is 30 km/u. Een kind speelt in de buurt van de weg. Wat moet je doen?",
      "ar": "أنت تقود في منطقة سكنية. الحد الأقصى للسرعة هو 30 كم/ساعة. طفل يلعب بالقرب من الطريق. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q5o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2024-03-15-q5o2",
        "text": {
          "en": "Continue at 30 km/h",
          "nl": "Ga verder met 30 km/u",
          "ar": "استمر بسرعة 30 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q5o3",
        "text": {
          "en": "Sound your horn to warn the child",
          "nl": "Klink op je claxon om het kind te waarschuwen",
          "ar": "أطلق بوقك لتحذير الطفل"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q5o1",
    "explanation": {
      "en": "Extra caution is required when children are present near the road, even below the speed limit.",
      "nl": "Extra voorzichtigheid is geboden wanneer kinderen in de buurt van de weg aanwezig zijn, zelfs onder de snelheidslimiet.",
      "ar": "يجب توخي الحذر الشديد عند وجود الأطفال بالقرب من الطريق، حتى أقل من الحد الأقصى للسرعة."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2024-03-15-q6",
    "text": {
      "en": "You are driving on a motorway at 100 km/h. It starts raining heavily. What should you do?",
      "nl": "U rijdt op een snelweg met 100 km/u. Het begint hevig te regenen. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع بسرعة 100 كم/ساعة. يبدأ هطول الأمطار بغزارة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q6o1",
        "text": {
          "en": "Reduce speed and increase following distance",
          "nl": "Verlaag de snelheid en verhoog de volgafstand",
          "ar": "تقليل السرعة وزيادة المسافة التالية"
        }
      },
      {
        "id": "real-2024-03-15-q6o2",
        "text": {
          "en": "Continue at 100 km/h",
          "nl": "Ga verder met 100 km/u",
          "ar": "تابع بسرعة 100 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q6o3",
        "text": {
          "en": "Stop on the hard shoulder",
          "nl": "Stop op de harde schouder",
          "ar": "توقف على الأكتاف الصلبة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q6o1",
    "explanation": {
      "en": "In heavy rain, you must reduce speed and increase following distance to account for reduced visibility and longer stopping distances. The standard motorway speed limit is 100 km/h, and it should be reduced further in adverse weather.",
      "nl": "Bij hevige regenbuien moet je de snelheid verminderen en de volgafstand vergroten om rekening te houden met verminderd zicht en langere remafstanden. De standaardsnelheidslimiet op de snelweg is 100 km/u en moet bij slecht weer verder worden verlaagd.",
      "ar": "في حالة هطول الأمطار الغزيرة، يجب عليك تقليل السرعة وزيادة المسافة التالية لمراعاة انخفاض الرؤية ومسافات التوقف الأطول. الحد الأقصى للسرعة القياسية للطريق السريع هو 100 كم/ساعة، ويجب تقليله أكثر في الأحوال الجوية السيئة."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2024-03-15-q7",
    "text": {
      "en": "You are approaching a traffic light. The light is yellow. What should you do?",
      "nl": "Je nadert een stoplicht. Het lampje is geel. Wat moet je doen?",
      "ar": "أنت تقترب من إشارة مرور. الضوء أصفر. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q7o1",
        "text": {
          "en": "Stop if it is safe to do so",
          "nl": "Stop als het veilig is om dit te doen",
          "ar": "توقف إذا كان من الآمن القيام بذلك"
        }
      },
      {
        "id": "real-2024-03-15-q7o2",
        "text": {
          "en": "Accelerate to pass through",
          "nl": "Versnellen om door te geven",
          "ar": "الإسراع في المرور"
        }
      },
      {
        "id": "real-2024-03-15-q7o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q7o1",
    "explanation": {
      "en": "Yellow lights mean stop if it is safe to do so, otherwise continue with caution.",
      "nl": "Gele lampjes betekenen stoppen als het veilig is om dit te doen, anders gaat u voorzichtig verder.",
      "ar": "تعني الأضواء الصفراء التوقف إذا كان ذلك آمنًا، وإلا فتابع بحذر."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2024-03-15-q8",
    "text": {
      "en": "You are driving in a built-up area. The speed limit is 50 km/h. You see a school zone sign. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. De maximumsnelheid is 50 km/u. Je ziet een schoolzonebord. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مأهولة. الحد الأقصى للسرعة هو 50 كم/ساعة. ترى لافتة منطقة المدرسة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q8o1",
        "text": {
          "en": "Reduce speed to 30 km/h",
          "nl": "Snelheid terugbrengen naar 30 km/u",
          "ar": "قلل السرعة إلى 30 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q8o2",
        "text": {
          "en": "Continue at 50 km/h",
          "nl": "Ga verder met 50 km/u",
          "ar": "استمر بسرعة 50 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q8o3",
        "text": {
          "en": "Stop completely",
          "nl": "Volledig stoppen",
          "ar": "التوقف تماما"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q8o3",
    "explanation": {
      "en": "School zones require reducing speed to 30 km/h for child safety.",
      "nl": "Schoolzones vereisen het verlagen van de snelheid tot 30 km/u voor de veiligheid van kinderen.",
      "ar": "تتطلب المناطق المدرسية تقليل السرعة إلى 30 كم/ساعة لسلامة الأطفال."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q9",
    "text": {
      "en": "You are driving on a motorway. You want to overtake a truck. What should you do?",
      "nl": "U rijdt op een snelweg. Je wilt een vrachtwagen inhalen. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. تريد تجاوز شاحنة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q9o1",
        "text": {
          "en": "Check mirrors and blind spots, then overtake",
          "nl": "Spiegels en dode hoeken controleren en dan inhalen",
          "ar": "تحقق من المرايا والبقع العمياء، ثم تجاوز"
        }
      },
      {
        "id": "real-2024-03-15-q9o2",
        "text": {
          "en": "Overtake immediately",
          "nl": "Onmiddellijk inhalen",
          "ar": "التجاوز على الفور"
        }
      },
      {
        "id": "real-2024-03-15-q9o3",
        "text": {
          "en": "Stay behind the truck",
          "nl": "Blijf achter de vrachtwagen",
          "ar": "ابقى خلف الشاحنه"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q9o1",
    "explanation": {
      "en": "Before overtaking, always check mirrors and blind spots for safety.",
      "nl": "Controleer voor het inhalen altijd de spiegels en dode hoeken op veiligheid.",
      "ar": "قبل التجاوز، تحقق دائمًا من المرايا والبقع العمياء للتأكد من سلامتها."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2024-03-15-q10",
    "text": {
      "en": "You are driving in a residential area. A pedestrian is crossing the road at a zebra crossing. What should you do?",
      "nl": "Je rijdt in een woonwijk. Bij een zebrapad steekt een voetganger de weg over. Wat moet je doen?",
      "ar": "أنت تقود في منطقة سكنية. أحد المشاة يعبر الطريق عند معبر حمار وحشي. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q10o1",
        "text": {
          "en": "Stop and give way to the pedestrian",
          "nl": "Stop en maak plaats voor de voetganger",
          "ar": "التوقف وإفساح الطريق للمشاة"
        }
      },
      {
        "id": "real-2024-03-15-q10o2",
        "text": {
          "en": "Continue if the pedestrian is far enough",
          "nl": "Ga verder als de voetganger ver genoeg is",
          "ar": "تابع إذا كان المشاة بعيدين بما فيه الكفاية"
        }
      },
      {
        "id": "real-2024-03-15-q10o3",
        "text": {
          "en": "Sound your horn to warn the pedestrian",
          "nl": "Klink op je claxon om de voetganger te waarschuwen",
          "ar": "أطلق بوق سيارتك لتحذير المشاة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q10o2",
    "explanation": {
      "en": "Pedestrians at zebra crossings have absolute priority and must be given way to.",
      "nl": "Voetgangers bij zebrapaden hebben absolute voorrang en moeten voorrang krijgen.",
      "ar": "يتمتع المشاة عند معابر الحمار الوحشي بالأولوية المطلقة ويجب إفساح الطريق لهم."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2024-03-15-q11",
    "text": {
      "en": "You are driving on a motorway. You see a speed limit sign showing 100 km/h. What should you do?",
      "nl": "U rijdt op een snelweg. U ziet een snelheidslimietbord met 100 km/u. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. ترى علامة حد السرعة تظهر 100 كم/ساعة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q11o1",
        "text": {
          "en": "Reduce speed to 100 km/h",
          "nl": "Snelheid terugbrengen naar 100 km/u",
          "ar": "قلل السرعة إلى 100 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q11o2",
        "text": {
          "en": "Continue at 130 km/h",
          "nl": "Ga verder met 130 km/u",
          "ar": "استمر بسرعة 130 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q11o3",
        "text": {
          "en": "Increase speed to 100 km/h",
          "nl": "Verhoog de snelheid tot 100 km/u",
          "ar": "زيادة السرعة إلى 100 كم/ساعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q11o1",
    "explanation": {
      "en": "Speed limit signs must be obeyed immediately when visible.",
      "nl": "Snelheidslimietborden moeten onmiddellijk worden opgevolgd wanneer ze zichtbaar zijn.",
      "ar": "يجب الالتزام بإشارات حد السرعة على الفور عندما تكون مرئية."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q12",
    "text": {
      "en": "You are driving in a built-up area. You see a red traffic light. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. Je ziet een rood verkeerslicht. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مأهولة. ترى إشارة مرور حمراء. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q12o1",
        "text": {
          "en": "Stop and wait for green",
          "nl": "Stop en wacht op groen",
          "ar": "توقف وانتظر اللون الأخضر"
        }
      },
      {
        "id": "real-2024-03-15-q12o2",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      },
      {
        "id": "real-2024-03-15-q12o3",
        "text": {
          "en": "Turn right if clear",
          "nl": "Sla rechtsaf indien vrij",
          "ar": "صحيح نظيف"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q12o3",
    "explanation": {
      "en": "Red traffic lights mean stop and wait for green.",
      "nl": "Rode verkeerslichten betekenen stoppen en wachten op groen.",
      "ar": "إشارات المرور الحمراء تعني التوقف وانتظار اللون الأخضر."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2024-03-15-q13",
    "text": {
      "en": "You are driving on a motorway. You see a construction zone sign. What should you do?",
      "nl": "U rijdt op een snelweg. Je ziet een bouwzonebord. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. ترى لافتة منطقة البناء. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q13o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2024-03-15-q13o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2024-03-15-q13o3",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q13o1",
    "explanation": {
      "en": "Construction zones require reducing speed and being extra cautious.",
      "nl": "Bouwzones vereisen snelheidsverlaging en extra voorzichtigheid.",
      "ar": "تتطلب مناطق البناء تقليل السرعة والحذر الشديد."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2024-03-15-q14",
    "text": {
      "en": "You are driving in a residential area. You see a stop sign. What should you do?",
      "nl": "Je rijdt in een woonwijk. Je ziet een stopbord. Wat moet je doen?",
      "ar": "أنت تقود في منطقة سكنية. ترى علامة توقف. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q14o1",
        "text": {
          "en": "Come to a complete stop",
          "nl": "Kom volledig tot stilstand",
          "ar": "توقف تمامًا."
        }
      },
      {
        "id": "real-2024-03-15-q14o2",
        "text": {
          "en": "Slow down but do not stop",
          "nl": "Vertraag, maar stop niet",
          "ar": "خفف السرعة ولكن لا تتوقف"
        }
      },
      {
        "id": "real-2024-03-15-q14o3",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q14o1",
    "explanation": {
      "en": "Stop signs require coming to a complete stop before proceeding.",
      "nl": "Stopborden moeten volledig tot stilstand komen voordat u verder kunt gaan.",
      "ar": "تتطلب علامات التوقف التوقف التام قبل المتابعة."
    },
    "subject": "Traffic Signs"
  },
  {
    "id": "real-2024-03-15-q15",
    "text": {
      "en": "You are driving on a motorway at 100 km/h. You see a speed limit sign showing 80 km/h. What should you do?",
      "nl": "U rijdt op een snelweg met 100 km/u. U ziet een snelheidslimietbord met 80 km/u. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع بسرعة 100 كم/ساعة. ترى علامة حد السرعة تظهر 80 كم/ساعة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q15o1",
        "text": {
          "en": "Reduce speed to 80 km/h",
          "nl": "Verlaag de snelheid tot 80 km/u",
          "ar": "قلل السرعة إلى 80 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q15o2",
        "text": {
          "en": "Continue at 100 km/h",
          "nl": "Ga verder met 100 km/u",
          "ar": "تابع بسرعة 100 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q15o3",
        "text": {
          "en": "Increase speed to 80 km/h",
          "nl": "Verhoog de snelheid tot 80 km/u",
          "ar": "زيادة السرعة إلى 80 كم/ساعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q15o1",
    "explanation": {
      "en": "Speed limit signs must be obeyed immediately when visible. When you see a lower speed limit sign, you must reduce your speed to that limit.",
      "nl": "Snelheidslimietborden moeten onmiddellijk worden opgevolgd wanneer ze zichtbaar zijn. Wanneer u een bord met een lagere snelheidslimiet ziet, moet u uw snelheid tot die limiet verlagen.",
      "ar": "يجب الالتزام بإشارات حد السرعة على الفور عندما تكون مرئية. عندما ترى علامة حد سرعة أقل، يجب عليك تقليل سرعتك إلى هذا الحد."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q16",
    "text": {
      "en": "You are driving in a built-up area. You see a yellow traffic light. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. Je ziet een geel verkeerslicht. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مأهولة. ترى إشارة مرور صفراء. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q16o1",
        "text": {
          "en": "Stop if it is safe to do so",
          "nl": "Stop als het veilig is om dit te doen",
          "ar": "توقف إذا كان من الآمن القيام بذلك"
        }
      },
      {
        "id": "real-2024-03-15-q16o2",
        "text": {
          "en": "Accelerate to pass through",
          "nl": "Versnellen om door te geven",
          "ar": "الإسراع في المرور"
        }
      },
      {
        "id": "real-2024-03-15-q16o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q16o1",
    "explanation": {
      "en": "Yellow lights mean stop if it is safe to do so, otherwise continue with caution.",
      "nl": "Gele lampjes betekenen stoppen als het veilig is om dit te doen, anders gaat u voorzichtig verder.",
      "ar": "تعني الأضواء الصفراء التوقف إذا كان ذلك آمنًا، وإلا فتابع بحذر."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2024-03-15-q17",
    "text": {
      "en": "You are driving on a motorway. You want to change lanes. What should you do?",
      "nl": "U rijdt op een snelweg. U wilt van rijstrook veranderen. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. تريد تغيير المسارات. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q17o1",
        "text": {
          "en": "Check mirrors and blind spots, then change lanes",
          "nl": "Controleer spiegels en dode hoeken en verander vervolgens van rijstrook",
          "ar": "تحقق من المرايا والنقاط العمياء، ثم قم بتغيير الحارات"
        }
      },
      {
        "id": "real-2024-03-15-q17o2",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      },
      {
        "id": "real-2024-03-15-q17o3",
        "text": {
          "en": "Stay in current lane",
          "nl": "Blijf in de huidige rijstrook",
          "ar": "البقاء في الحارة الحالية"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q17o1",
    "explanation": {
      "en": "Before changing lanes, always check mirrors and blind spots for safety.",
      "nl": "Controleer voor het wisselen van rijstrook altijd de spiegels en dode hoeken op veiligheid.",
      "ar": "قبل تغيير الحارات، تحقق دائمًا من المرايا والبقع العمياء للتأكد من سلامتها."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2024-03-15-q18",
    "text": {
      "en": "You are driving in a residential area. A child is playing near the road. What should you do?",
      "nl": "Je rijdt in een woonwijk. Een kind speelt in de buurt van de weg. Wat moet je doen?",
      "ar": "أنت تقود في منطقة سكنية. طفل يلعب بالقرب من الطريق. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q18o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2024-03-15-q18o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2024-03-15-q18o3",
        "text": {
          "en": "Sound your horn to warn the child",
          "nl": "Klink op je claxon om het kind te waarschuwen",
          "ar": "أطلق بوقك لتحذير الطفل"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q18o1",
    "explanation": {
      "en": "Extra caution is required when children are present near the road. You must reduce speed and be extra cautious to ensure their safety.",
      "nl": "Extra voorzichtigheid is geboden wanneer er kinderen in de buurt van de weg aanwezig zijn. Je moet de snelheid verminderen en extra voorzichtig zijn om hun veiligheid te garanderen.",
      "ar": "يجب توخي الحذر الشديد عند وجود الأطفال بالقرب من الطريق. يجب عليك تقليل السرعة وتوخي الحذر الشديد لضمان سلامتهم."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2024-03-15-q19",
    "text": {
      "en": "You are driving on a motorway. It starts raining heavily. What should you do?",
      "nl": "U rijdt op een snelweg. Het begint hevig te regenen. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. يبدأ هطول الأمطار بغزارة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q19o1",
        "text": {
          "en": "Reduce speed to 100 km/h",
          "nl": "Snelheid terugbrengen naar 100 km/u",
          "ar": "قلل السرعة إلى 100 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q19o2",
        "text": {
          "en": "Continue at 130 km/h",
          "nl": "Ga verder met 130 km/u",
          "ar": "استمر بسرعة 130 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q19o3",
        "text": {
          "en": "Stop on the hard shoulder",
          "nl": "Stop op de harde schouder",
          "ar": "توقف على الأكتاف الصلبة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q19o1",
    "explanation": {
      "en": "Speed must be reduced in adverse weather conditions for safety.",
      "nl": "Snelheid moet worden verlaagd in ongunstige weersomstandigheden voor de veiligheid.",
      "ar": "يجب تقليل السرعة في الظروف الجوية السيئة من أجل السلامة."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2024-03-15-q20",
    "text": {
      "en": "You are driving in a built-up area. You see a school zone sign. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. Je ziet een schoolzonebord. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مأهولة. ترى لافتة منطقة المدرسة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q20o1",
        "text": {
          "en": "Reduce speed to 30 km/h",
          "nl": "Snelheid terugbrengen naar 30 km/u",
          "ar": "قلل السرعة إلى 30 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q20o2",
        "text": {
          "en": "Continue at 50 km/h",
          "nl": "Ga verder met 50 km/u",
          "ar": "استمر بسرعة 50 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q20o3",
        "text": {
          "en": "Stop completely",
          "nl": "Volledig stoppen",
          "ar": "التوقف تماما"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q20o2",
    "explanation": {
      "en": "School zones require reducing speed to 30 km/h for child safety.",
      "nl": "Schoolzones vereisen het verlagen van de snelheid tot 30 km/u voor de veiligheid van kinderen.",
      "ar": "تتطلب المناطق المدرسية تقليل السرعة إلى 30 كم/ساعة لسلامة الأطفال."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q21",
    "text": {
      "en": "You are driving on a motorway. You want to overtake a truck. What should you do?",
      "nl": "U rijdt op een snelweg. Je wilt een vrachtwagen inhalen. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. تريد تجاوز شاحنة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q21o1",
        "text": {
          "en": "Check mirrors and blind spots, then overtake",
          "nl": "Spiegels en dode hoeken controleren en dan inhalen",
          "ar": "تحقق من المرايا والبقع العمياء، ثم تجاوز"
        }
      },
      {
        "id": "real-2024-03-15-q21o2",
        "text": {
          "en": "Overtake immediately",
          "nl": "Onmiddellijk inhalen",
          "ar": "التجاوز على الفور"
        }
      },
      {
        "id": "real-2024-03-15-q21o3",
        "text": {
          "en": "Stay behind the truck",
          "nl": "Blijf achter de vrachtwagen",
          "ar": "ابقى خلف الشاحنه"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q21o1",
    "explanation": {
      "en": "Before overtaking, always check mirrors and blind spots for safety.",
      "nl": "Controleer voor het inhalen altijd de spiegels en dode hoeken op veiligheid.",
      "ar": "قبل التجاوز، تحقق دائمًا من المرايا والبقع العمياء للتأكد من سلامتها."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2024-03-15-q22",
    "text": {
      "en": "You are driving in a residential area. A pedestrian is crossing the road at a zebra crossing. What should you do?",
      "nl": "Je rijdt in een woonwijk. Bij een zebrapad steekt een voetganger de weg over. Wat moet je doen?",
      "ar": "أنت تقود في منطقة سكنية. أحد المشاة يعبر الطريق عند معبر حمار وحشي. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q22o1",
        "text": {
          "en": "Stop and give way to the pedestrian",
          "nl": "Stop en maak plaats voor de voetganger",
          "ar": "التوقف وإفساح الطريق للمشاة"
        }
      },
      {
        "id": "real-2024-03-15-q22o2",
        "text": {
          "en": "Continue if the pedestrian is far enough",
          "nl": "Ga verder als de voetganger ver genoeg is",
          "ar": "تابع إذا كان المشاة بعيدين بما فيه الكفاية"
        }
      },
      {
        "id": "real-2024-03-15-q22o3",
        "text": {
          "en": "Sound your horn to warn the pedestrian",
          "nl": "Klink op je claxon om de voetganger te waarschuwen",
          "ar": "أطلق بوق سيارتك لتحذير المشاة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q22o1",
    "explanation": {
      "en": "Pedestrians at zebra crossings have absolute priority and must be given way to.",
      "nl": "Voetgangers bij zebrapaden hebben absolute voorrang en moeten voorrang krijgen.",
      "ar": "يتمتع المشاة عند معابر الحمار الوحشي بالأولوية المطلقة ويجب إفساح الطريق لهم."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2024-03-15-q23",
    "text": {
      "en": "You are driving on a motorway. You see a speed limit sign showing 100 km/h. What should you do?",
      "nl": "U rijdt op een snelweg. U ziet een snelheidslimietbord met 100 km/u. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. ترى علامة حد السرعة تظهر 100 كم/ساعة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q23o1",
        "text": {
          "en": "Reduce speed to 100 km/h",
          "nl": "Snelheid terugbrengen naar 100 km/u",
          "ar": "قلل السرعة إلى 100 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q23o2",
        "text": {
          "en": "Continue at 130 km/h",
          "nl": "Ga verder met 130 km/u",
          "ar": "استمر بسرعة 130 كم/ساعة"
        }
      },
      {
        "id": "real-2024-03-15-q23o3",
        "text": {
          "en": "Increase speed to 100 km/h",
          "nl": "Verhoog de snelheid tot 100 km/u",
          "ar": "زيادة السرعة إلى 100 كم/ساعة"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q23o1",
    "explanation": {
      "en": "Speed limit signs must be obeyed immediately when visible.",
      "nl": "Snelheidslimietborden moeten onmiddellijk worden opgevolgd wanneer ze zichtbaar zijn.",
      "ar": "يجب الالتزام بإشارات حد السرعة على الفور عندما تكون مرئية."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2024-03-15-q24",
    "text": {
      "en": "You are driving in a built-up area. You see a red traffic light. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. Je ziet een rood verkeerslicht. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مأهولة. ترى إشارة مرور حمراء. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q24o1",
        "text": {
          "en": "Stop and wait for green",
          "nl": "Stop en wacht op groen",
          "ar": "توقف وانتظر اللون الأخضر"
        }
      },
      {
        "id": "real-2024-03-15-q24o2",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      },
      {
        "id": "real-2024-03-15-q24o3",
        "text": {
          "en": "Turn right if clear",
          "nl": "Sla rechtsaf indien vrij",
          "ar": "صحيح نظيف"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q24o1",
    "explanation": {
      "en": "Red traffic lights mean stop and wait for green.",
      "nl": "Rode verkeerslichten betekenen stoppen en wachten op groen.",
      "ar": "إشارات المرور الحمراء تعني التوقف وانتظار اللون الأخضر."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2024-03-15-q25",
    "text": {
      "en": "You are driving on a motorway. You see a construction zone sign. What should you do?",
      "nl": "U rijdt op een snelweg. Je ziet een bouwzonebord. Wat moet je doen?",
      "ar": "أنت تقود على طريق سريع. ترى لافتة منطقة البناء. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2024-03-15-q25o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2024-03-15-q25o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2024-03-15-q25o3",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-q25o1",
    "explanation": {
      "en": "Construction zones require reducing speed and being extra cautious.",
      "nl": "Bouwzones vereisen snelheidsverlaging en extra voorzichtigheid.",
      "ar": "تتطلب مناطق البناء تقليل السرعة والحذر الشديد."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2024-03-15-img1",
    "text": {
      "en": "What does this traffic sign mean?",
      "nl": "Wat betekent dit verkeersbord?",
      "ar": "ما الذي تعنيه اللوحة المرورية هذه"
    },
    "options": [
      {
        "id": "real-2024-03-15-img1o1",
        "text": {
          "en": "No entry for vehicles",
          "nl": "Geen toegang voor voertuigen",
          "ar": "ممنوع دخول المركبات"
        }
      },
      {
        "id": "real-2024-03-15-img1o2",
        "text": {
          "en": "One-way street",
          "nl": "straat met eenrichtingsverkeer",
          "ar": "طريق أحادي الاتجاه"
        }
      },
      {
        "id": "real-2024-03-15-img1o3",
        "text": {
          "en": "End of no entry zone",
          "nl": "Einde no entry zone",
          "ar": "نهاية منطقة عدم الدخول"
        }
      }
    ],
    "correctAnswerId": "real-2024-03-15-img1o1",
    "explanation": {
      "en": "This is a \"No Entry\" sign (B1) - a red circular sign with a white horizontal bar. Vehicles are not allowed to enter this road.",
      "nl": "Dit is een \"No Entry\" -bord (B1) - een rood cirkelvormig bord met een witte horizontale balk. Voertuigen mogen deze weg niet op.",
      "ar": "هذه علامة \"ممنوع الدخول\" (B1) - علامة دائرية حمراء مع شريط أفقي أبيض. لا يُسمح للمركبات بدخول هذا الطريق."
    },
    "subject": "Traffic Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory-2/q-prohibit2-2.jpg",
    "imageHint": "No Entry sign B1 - red circle with white horizontal bar",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-01-15-hp1",
    "text": {
      "en": "You are driving at 50 km/h in a built-up area. A pedestrian looking at their phone steps off the pavement from between parked cars. What should you do?",
      "nl": "Je rijdt met 50 km/u in een bebouwde kom. Een voetganger die naar zijn telefoon kijkt, stapt van de stoep af tussen geparkeerde auto's. Wat moet je doen?",
      "ar": "أنت تقود بسرعة 50 كم/ساعة في منطقة مأهولة. أحد المشاة ينظر إلى هاتفه وهو يخطو من الرصيف بين السيارات المتوقفة. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-hp1o1",
        "text": {
          "en": "Brake immediately",
          "nl": "Onmiddellijk remmen",
          "ar": "الفرامل على الفور"
        }
      },
      {
        "id": "real-2025-01-15-hp1o2",
        "text": {
          "en": "Release accelerator and prepare to brake",
          "nl": "Laat het gaspedaal los en bereid u voor om te rem",
          "ar": "حرر دواسة الوقود واستعد للفرامل"
        }
      },
      {
        "id": "real-2025-01-15-hp1o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-hp1o1",
    "explanation": {
      "en": "A pedestrian unexpectedly entering the roadway without looking requires immediate braking to prevent a collision. This is a high-risk situation demanding immediate action.",
      "nl": "Een voetganger die onverwacht de rijbaan oprijdt zonder te kijken, moet onmiddellijk remmen om een botsing te voorkomen. Dit is een situatie met een hoog risico die onmiddellijke actie vereist.",
      "ar": "يحتاج المشاة الذين يدخلون الطريق بشكل غير متوقع دون النظر إلى كبح فوري لمنع الاصطدام. هذا وضع شديد الخطورة يتطلب اتخاذ إجراءات فورية."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2025-01-15-hp2",
    "text": {
      "en": "Your speed is 80 km/h on a country road. A cyclist ahead is swerving slightly and appears unstable. What should you do?",
      "nl": "Je snelheid is 80 km/u op een landweg. Een fietser vooruit zwenkt een beetje en lijkt onstabiel. Wat moet je doen?",
      "ar": "سرعتك 80 كم/ساعة على طريق ريفي. ينحرف راكب الدراجة أمامه قليلاً ويبدو غير مستقر. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-hp2o1",
        "text": {
          "en": "Release accelerator and prepare to brake",
          "nl": "Laat het gaspedaal los en bereid u voor om te rem",
          "ar": "حرر دواسة الوقود واستعد للفرامل"
        }
      },
      {
        "id": "real-2025-01-15-hp2o2",
        "text": {
          "en": "Overtake immediately",
          "nl": "Onmiddellijk inhalen",
          "ar": "التجاوز على الفور"
        }
      },
      {
        "id": "real-2025-01-15-hp2o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-hp2o1",
    "explanation": {
      "en": "An unstable cyclist poses a potential hazard. Release the accelerator to reduce speed and be prepared to brake, giving yourself more time to react if the cyclist falls or swerves into your path.",
      "nl": "Een onstabiele fietser vormt een potentieel gevaar. Laat het gaspedaal los om de snelheid te verlagen en wees bereid om te remmen, zodat je meer tijd hebt om te reageren als de fietser op je pad valt of slingert.",
      "ar": "يشكل راكب الدراجة غير المستقر خطرًا محتملاً. حرر دواسة الوقود لتقليل السرعة وكن مستعدًا للكبح، مما يمنحك مزيدًا من الوقت للرد إذا سقط الدراج أو انحرف في طريقك."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2025-01-15-hp3",
    "text": {
      "en": "You are driving at 100 km/h on a motorway. The vehicle ahead suddenly brakes hard and its brake lights come on. What should you do?",
      "nl": "Je rijdt met 100 km/u op een snelweg. De voorligger remt plotseling hard en de remlichten gaan aan. Wat moet je doen?",
      "ar": "أنت تقود بسرعة 100 كم/ساعة على طريق سريع. تضغط السيارة التي أمامها فجأة على المكابح بشدة وتضيء مصابيح المكابح. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-hp3o1",
        "text": {
          "en": "Brake immediately and maintain safe distance",
          "nl": "Onmiddellijk remmen en veilige afstand houden",
          "ar": "الفرامل على الفور والحفاظ على مسافة آمنة"
        }
      },
      {
        "id": "real-2025-01-15-hp3o2",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      },
      {
        "id": "real-2025-01-15-hp3o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-hp3o1",
    "explanation": {
      "en": "When the vehicle ahead brakes hard, you must brake immediately to maintain a safe following distance and avoid a rear-end collision.",
      "nl": "Wanneer het voertuig voor u hard remt, moet u onmiddellijk remmen om een veilige volgafstand te behouden en een kop-staartbotsing te voorkomen.",
      "ar": "عندما تضغط السيارة التي أمامك بقوة، يجب أن تضغط على الفرامل على الفور للحفاظ على مسافة تتبع آمنة وتجنب الاصطدام الخلفي."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2025-01-15-hp4",
    "text": {
      "en": "You are driving at 50 km/h approaching a junction. A car at the junction starts to pull out but then stops. What should you do?",
      "nl": "Je rijdt met 50 km/u een knooppunt nadert. Een auto op de kruising begint zich terug te trekken, maar stopt dan. Wat moet je doen?",
      "ar": "أنت تقود بسرعة 50 كم/ساعة وتقترب من تقاطع طرق. تبدأ سيارة عند التقاطع في الانسحاب ولكنها تتوقف بعد ذلك. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-hp4o1",
        "text": {
          "en": "Release accelerator and be prepared to brake",
          "nl": "Laat het gaspedaal los en wees voorbereid om te remmen",
          "ar": "حرر دواسة الوقود واستعد للكبح"
        }
      },
      {
        "id": "real-2025-01-15-hp4o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-01-15-hp4o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-hp4o1",
    "explanation": {
      "en": "A car that starts to pull out but stops indicates uncertainty. Release the accelerator to slow down and be prepared to brake if it pulls out again.",
      "nl": "Een auto die begint te trekken, maar stopt, duidt op onzekerheid. Laat het gaspedaal los om te vertragen en wees voorbereid om te remmen als het weer naar buiten trekt.",
      "ar": "السيارة التي تبدأ في الانسحاب ولكن تتوقف تشير إلى عدم اليقين. حرر دواسة الوقود لإبطاء سرعتها واستعد للكبح إذا انسحبت مرة أخرى."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2025-01-15-hp5",
    "text": {
      "en": "You are driving at 30 km/h in a residential area. A ball rolls onto the road ahead, followed by a child running after it. What should you do?",
      "nl": "Je rijdt met 30 km/u in een woonwijk. Een bal rolt de weg op, gevolgd door een kind dat erachteraan rent. Wat moet je doen?",
      "ar": "أنت تقود بسرعة 30 كم/ساعة في منطقة سكنية. تتدحرج الكرة على الطريق أمامك، يليها طفل يركض خلفها. ماذا يجب أن تفعل ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-hp5o1",
        "text": {
          "en": "Brake immediately",
          "nl": "Onmiddellijk remmen",
          "ar": "الفرامل على الفور"
        }
      },
      {
        "id": "real-2025-01-15-hp5o2",
        "text": {
          "en": "Release accelerator",
          "nl": "Versneller loslaten",
          "ar": "مسرع التحرير"
        }
      },
      {
        "id": "real-2025-01-15-hp5o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-hp5o1",
    "explanation": {
      "en": "A child running after a ball into the road is an immediate hazard requiring emergency braking to prevent hitting the child.",
      "nl": "Een kind dat achter een bal de weg op rent, is een onmiddellijk gevaar dat een noodstop vereist om te voorkomen dat het kind wordt geraakt.",
      "ar": "الطفل الذي يركض بعد الكرة في الطريق هو خطر فوري يتطلب الكبح في حالات الطوارئ لمنع ضرب الطفل."
    },
    "subject": "Hazard Perception"
  },
  {
    "id": "real-2025-01-15-pr1",
    "text": {
      "en": "You are at a T-junction. You want to turn right onto the main road. A car is approaching from your left on the main road. Who has priority?",
      "nl": "Je bent op een T-splitsing. U wilt rechtsaf de hoofdweg op. Er nadert een auto van links op de hoofdweg. Wie heeft voorrang?",
      "ar": "أنت في مفترق طرق على شكل حرف T. تريد الانعطاف يمينًا على الطريق الرئيسي. هناك سيارة تقترب من يسارك على الطريق الرئيسي. من له الأولوية ؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-pr1o1",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr1o2",
        "text": {
          "en": "The car on the main road has priority",
          "nl": "De auto op de hoofdweg heeft voorrang",
          "ar": "السيارة على الطريق الرئيسي لها الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr1o3",
        "text": {
          "en": "Neither has priority",
          "nl": "Geen van beide heeft prioriteit",
          "ar": "لا يتمتع أي منهما بالأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-pr1o2",
    "explanation": {
      "en": "At a T-junction, traffic on the main road (through road) has priority over traffic turning onto it. You must give way to the car on the main road.",
      "nl": "Bij een T-splitsing heeft het verkeer op de hoofdweg (doorgaande weg) voorrang op het verkeer dat erop afslaat. Je moet wijken voor de auto op de hoofdweg.",
      "ar": "عند تقاطع T، تكون لحركة المرور على الطريق الرئيسي (عبر الطريق) الأولوية على حركة المرور التي تنقلب عليه. يجب أن تفسح الطريق للسيارة على الطريق الرئيسي."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-01-15-pr2",
    "text": {
      "en": "You are approaching a junction with a \"Give Way\" sign. A car is approaching from your right on the priority road. What should you do?",
      "nl": "Je nadert een kruispunt met een \"Voorrang verlenen\" bord. Een auto nadert van rechts op de voorrangsweg. Wat moet je doen?",
      "ar": "أنت تقترب من تقاطع مع علامة \"أعطِ الأولوية\". سيارة تقترب من يمينك على الطريق ذو الأولوية. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-pr2o1",
        "text": {
          "en": "Stop and give way to the car",
          "nl": "Stop en geef voorrang aan de auto",
          "ar": "توقف وامنح الأولوية للسيارة"
        }
      },
      {
        "id": "real-2025-01-15-pr2o2",
        "text": {
          "en": "Continue, you have priority",
          "nl": "Ga door, jij hebt voorrang",
          "ar": "استمر، لديك الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr2o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-pr2o1",
    "explanation": {
      "en": "A \"Give Way\" sign means you must slow down and be prepared to stop to give way to traffic on the priority road. The car from the right on the priority road has priority.",
      "nl": "Een \"Voorrang verlenen\" bord betekent dat je moet afremmen en voorbereid moet zijn om te stoppen om voorrang te geven aan het verkeer op de voorrangsweg. De auto van rechts op de voorrangsweg heeft voorrang.",
      "ar": "علامة \"أعطِ الأولوية\" تعني أنه يجب عليك التباطؤ والاستعداد للتوقف لإعطاء الأولوية لحركة المرور على الطريق ذو الأولوية. السيارة من اليمين على الطريق ذو الأولوية لها الأولوية."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-01-15-pr3",
    "text": {
      "en": "You are at an unmarked crossroads. A car approaches from your right. Who has priority?",
      "nl": "Je bent bij een onbemand kruispunt. Een auto nadert van rechts. Wie heeft voorrang?",
      "ar": "أنت عند تقاطع غير محدد. سيارة تقترب من يمينك. من لديه الأولوية؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-pr3o1",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr3o2",
        "text": {
          "en": "The car from the right has priority",
          "nl": "De auto van rechts heeft voorrang",
          "ar": "السيارة من اليمين لها الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr3o3",
        "text": {
          "en": "The larger vehicle has priority",
          "nl": "Het grotere voertuig heeft voorrang",
          "ar": "المركبة الأكبر لها الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-pr3o2",
    "explanation": {
      "en": "At an unmarked crossroads, the \"priority to the right\" rule applies. Traffic from the right has priority.",
      "nl": "Bij een onbemand kruispunt geldt de regel \"voorrang van rechts\". Verkeer van rechts heeft voorrang.",
      "ar": "في تقاطع غير محدد، تنطبق قاعدة \"الأولوية من اليمين\". حركة المرور من اليمين لها الأولوية."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-01-15-pr4",
    "text": {
      "en": "You are turning left at a junction. A car is approaching from the opposite direction going straight. Who has priority?",
      "nl": "Je slaat linksaf bij een kruispunt. Een auto nadert van de tegenovergestelde richting en gaat rechtdoor. Wie heeft voorrang?",
      "ar": "أنت تنعطف يسارًا عند تقاطع. سيارة تقترب من الاتجاه المعاكس وتذهب مباشرة. من لديه الأولوية؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-pr4o1",
        "text": {
          "en": "You have priority when turning left",
          "nl": "Je hebt voorrang bij het linksaf slaan",
          "ar": "لديك الأولوية عند الانعطاف يسارًا"
        }
      },
      {
        "id": "real-2025-01-15-pr4o2",
        "text": {
          "en": "The car going straight has priority",
          "nl": "De auto die rechtdoor gaat heeft voorrang",
          "ar": "السيارة التي تسير مباشرة لها الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-pr4o3",
        "text": {
          "en": "Neither has priority",
          "nl": "Geen van beide heeft prioriteit",
          "ar": "لا يتمتع أي منهما بالأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-pr4o2",
    "explanation": {
      "en": "When turning left, you must give way to traffic approaching from the opposite direction that is going straight ahead or turning right.",
      "nl": "Bij het linksaf slaan moet je voorrang geven aan verkeer dat van de tegenovergestelde richting komt en rechtdoor gaat of rechtsaf slaat.",
      "ar": "عند الانعطاف يسارًا، يجب عليك إعطاء الأولوية لحركة المرور القادمة من الاتجاه المعاكس والتي تسير مباشرة أو تنعطف يمينًا."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-01-15-pr5",
    "text": {
      "en": "You see an emergency vehicle with flashing lights and sirens approaching from behind. What should you do?",
      "nl": "Je ziet een hulpverleningsvoertuig met knipperende lichten en sirenes van achteren naderen. Wat moet je doen?",
      "ar": "ترى مركبة طوارئ مع أضواء وشرارات وصرخات تقترب من الخلف. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-pr5o1",
        "text": {
          "en": "Give way and allow it to pass safely",
          "nl": "Geef voorrang en laat het veilig passeren",
          "ar": "امنح الأولوية ودعها تمر بأمان"
        }
      },
      {
        "id": "real-2025-01-15-pr5o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-01-15-pr5o3",
        "text": {
          "en": "Speed up to get out of the way",
          "nl": "Versnel om uit de weg te gaan",
          "ar": "تسارع لتبتعد عن الطريق"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-pr5o1",
    "explanation": {
      "en": "Emergency vehicles with flashing lights and sirens have priority over all other traffic. You must give way and allow them to pass safely, pulling over if necessary.",
      "nl": "Hulpverleningsvoertuigen met knipperende lichten en sirenes hebben voorrang op al het andere verkeer. Je moet voorrang geven en ze veilig laten passeren, eventueel door aan de kant te gaan staan.",
      "ar": "تمتلك مركبات الطوارئ ذات الأضواء الوامضة والصفارات الأولوية على جميع حركة المرور الأخرى. يجب عليك إعطاء الأولوية والسماح لهم بالمرور بأمان، مع التوجه إلى جانب الطريق إذا لزم الأمر."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-01-15-rr1",
    "text": {
      "en": "You are approaching a roundabout and want to go straight ahead. Which lane should you use?",
      "nl": "Je nadert een rotonde en wilt rechtdoor. Welke rijstrook moet je gebruiken?",
      "ar": "أنت تقترب من دوار وتريد الذهاب مباشرة. أي حارة يجب أن تستخدم؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rr1o1",
        "text": {
          "en": "Left lane",
          "nl": "Linker rijstrook",
          "ar": "الحارة اليسرى"
        }
      },
      {
        "id": "real-2025-01-15-rr1o2",
        "text": {
          "en": "Right lane",
          "nl": "Rechter rijstrook",
          "ar": "الحارة اليمنى"
        }
      },
      {
        "id": "real-2025-01-15-rr1o3",
        "text": {
          "en": "Either lane, depending on road markings",
          "nl": "Beide rijstroken, afhankelijk van de wegmarkeringen",
          "ar": "أي حارة، اعتمادًا على علامات الطريق"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rr1o3",
    "explanation": {
      "en": "When going straight ahead at a roundabout, you can use either lane unless road markings indicate otherwise. Always follow road markings and signs.",
      "nl": "Wanneer je rechtdoor gaat op een rotonde, kun je beide rijstroken gebruiken, tenzij de wegmarkeringen anders aangeven. Volg altijd de wegmarkeringen en borden.",
      "ar": "عند الذهاب مباشرة في دوار، يمكنك استخدام أي حارة ما لم تشير علامات الطريق إلى خلاف ذلك. اتبع دائمًا علامات الطريق والإشارات."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2025-01-15-rr2",
    "text": {
      "en": "You are in a roundabout and want to exit. When should you signal right?",
      "nl": "Je bent op een rotonde en wilt afslaan. Wanneer moet je rechts signaleren?",
      "ar": "أنت في دوار وتريد الخروج. متى يجب أن تشير إلى اليمين؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rr2o1",
        "text": {
          "en": "Just before exiting",
          "nl": "Net voor het verlaten",
          "ar": "قبل الخروج مباشرة"
        }
      },
      {
        "id": "real-2025-01-15-rr2o2",
        "text": {
          "en": "When entering the roundabout",
          "nl": "Bij het binnenrijden van de rotonde",
          "ar": "عند دخول الدوار"
        }
      },
      {
        "id": "real-2025-01-15-rr2o3",
        "text": {
          "en": "No need to signal when exiting",
          "nl": "Geen behoefte om te signaleren bij het verlaten",
          "ar": "لا حاجة للإشارة عند الخروج"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rr2o1",
    "explanation": {
      "en": "You should signal right just before exiting a roundabout to indicate your intention to leave. This helps other road users understand your actions.",
      "nl": "Je moet rechts signaleren net voordat je een rotonde verlaat om je intentie om te vertrekken aan te geven. Dit helpt andere weggebruikers je acties te begrijpen.",
      "ar": "يجب أن تشير إلى اليمين قبل الخروج من الدوار مباشرةً للإشارة إلى نيتك في المغادرة. هذا يساعد مستخدمي الطريق الآخرين على فهم أفعالك."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2025-01-15-rr3",
    "text": {
      "en": "You are approaching a roundabout and want to turn right. Which lane should you use?",
      "nl": "Je nadert een rotonde en wilt rechtsaf. Welke rijstrook moet je gebruiken?",
      "ar": "أنت تقترب من دوار وتريد الانعطاف إلى اليمين. أي حارة يجب أن تستخدم؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rr3o1",
        "text": {
          "en": "Left lane",
          "nl": "Linker rijstrook",
          "ar": "الحارة اليسرى"
        }
      },
      {
        "id": "real-2025-01-15-rr3o2",
        "text": {
          "en": "Right lane",
          "nl": "Rechter rijstrook",
          "ar": "الحارة اليمنى"
        }
      },
      {
        "id": "real-2025-01-15-rr3o3",
        "text": {
          "en": "Either lane",
          "nl": "Beide rijstroken",
          "ar": "أي حارة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rr3o2",
    "explanation": {
      "en": "When turning right at a roundabout, use the right lane to enter and stay in the right lane while in the roundabout, unless road markings indicate otherwise.",
      "nl": "Bij het rechtsaf slaan op een rotonde, gebruik je de rechter rijstrook om binnen te rijden en blijf je in de rechter rijstrook terwijl je op de rotonde bent, tenzij de wegmarkeringen anders aangeven.",
      "ar": "عند الانعطاف إلى اليمين في دوار، استخدم الحارة اليمنى للدخول وابق في الحارة اليمنى أثناء وجودك في الدوار، ما لم تشير علامات الطريق إلى خلاف ذلك."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2025-01-15-rr4",
    "text": {
      "en": "You are approaching a roundabout. A tram is already in the roundabout. What should you do?",
      "nl": "Je nadert een rotonde. Een tram is al in de rotonde. Wat moet je doen?",
      "ar": "أنت تقترب من دوار. الترام موجود بالفعل في الدوار. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rr4o1",
        "text": {
          "en": "Give way to the tram",
          "nl": "Geef voorrang aan de tram",
          "ar": "أعطِ الأولوية للترام"
        }
      },
      {
        "id": "real-2025-01-15-rr4o2",
        "text": {
          "en": "Enter the roundabout, trams must give way",
          "nl": "Betreed de rotonde, trams moeten voorrang geven",
          "ar": "ادخل الدوار، يجب على الترام إعطاء الأولوية"
        }
      },
      {
        "id": "real-2025-01-15-rr4o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rr4o1",
    "explanation": {
      "en": "Trams have priority over other vehicles, including at roundabouts. You must give way to trams already in the roundabout before entering.",
      "nl": "Trams hebben voorrang op andere voertuigen, ook bij rotondes. Je moet de tram die al in de rotonde is voorrang geven voordat je de rotonde oprijdt.",
      "ar": "للترايم أولوية على المركبات الأخرى، بما في ذلك في الدوارات. يجب عليك إعطاء الأولوية للترام الموجود بالفعل في الدوار قبل الدخول."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2025-01-15-rr5",
    "text": {
      "en": "You are in a roundabout in the left lane. You want to exit but a car is in the right lane next to you. What should you do?",
      "nl": "Je bent in een rotonde in de linkerbaan. Je wilt afslaan, maar er staat een auto in de rechterbaan naast je. Wat moet je doen?",
      "ar": "أنت في دوار في المسار الأيسر. تريد الخروج لكن هناك سيارة في المسار الأيمن بجانبك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rr5o1",
        "text": {
          "en": "Exit normally, you have priority",
          "nl": "Verlaat normaal, je hebt voorrang",
          "ar": "اخرج بشكل طبيعي، لديك أولوية"
        }
      },
      {
        "id": "real-2025-01-15-rr5o2",
        "text": {
          "en": "Give way to the car in the right lane",
          "nl": "Geef voorrang aan de auto in de rechterbaan",
          "ar": "أعطِ الأولوية للسيارة في المسار الأيمن"
        }
      },
      {
        "id": "real-2025-01-15-rr5o3",
        "text": {
          "en": "Change to the right lane",
          "nl": "Verander naar de rechterbaan",
          "ar": "انتقل إلى المسار الأيمن"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rr5o2",
    "explanation": {
      "en": "When exiting a roundabout, you must give way to vehicles in other lanes. The car in the right lane may also be exiting, so you must be cautious and give way if necessary.",
      "nl": "Bij het verlaten van een rotonde moet je voorrang geven aan voertuigen in andere rijstroken. De auto in de rechterbaan kan ook afslaan, dus je moet voorzichtig zijn en indien nodig voorrang geven.",
      "ar": "عند الخروج من الدوار، يجب عليك إعطاء الأولوية للمركبات في المسارات الأخرى. قد تكون السيارة في المسار الأيمن أيضًا في طريقها للخروج، لذا يجب أن تكون حذرًا وتمنح الأولوية إذا لزم الأمر."
    },
    "subject": "Roundabout Rules"
  },
  {
    "id": "real-2025-01-15-lc1",
    "text": {
      "en": "You want to change lanes on a motorway. What should you do first?",
      "nl": "Je wilt van rijstrook veranderen op de snelweg. Wat moet je eerst doen?",
      "ar": "تريد تغيير المسار على الطريق السريع. ماذا يجب أن تفعل أولاً؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-lc1o1",
        "text": {
          "en": "Check mirrors and blind spots",
          "nl": "Controleer spiegels en dode hoeken",
          "ar": "تحقق من المرايا ونقاط العمى"
        }
      },
      {
        "id": "real-2025-01-15-lc1o2",
        "text": {
          "en": "Signal and change immediately",
          "nl": "Geef een signaal en verander onmiddellijk",
          "ar": "أشر وغيّر على الفور"
        }
      },
      {
        "id": "real-2025-01-15-lc1o3",
        "text": {
          "en": "Change lanes without checking",
          "nl": "Verander van rijstrook zonder te controleren",
          "ar": "غيّر المسار دون التحقق"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-lc1o1",
    "explanation": {
      "en": "Before changing lanes, always check your mirrors and blind spots to ensure it is safe. Then signal your intention before changing lanes.",
      "nl": "Voordat je van rijstrook verandert, moet je altijd je spiegels en dode hoeken controleren om te zorgen dat het veilig is. Geef dan je intentie aan voordat je van rijstrook verandert.",
      "ar": "قبل تغيير المسار، تحقق دائمًا من مراياك ونقاط العمى للتأكد من أنه آمن. ثم قم بإشارة نيتك قبل تغيير المسار."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2025-01-15-lc2",
    "text": {
      "en": "You want to change lanes but there is a vehicle in your blind spot. What should you do?",
      "nl": "Je wilt van rijstrook veranderen, maar er is een voertuig in je dode hoek. Wat moet je doen?",
      "ar": "تريد تغيير المسار ولكن هناك مركبة في النقطة العمياء لديك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-lc2o1",
        "text": {
          "en": "Wait until it is safe, then change lanes",
          "nl": "Wacht tot het veilig is, verander dan van rijstrook",
          "ar": "انتظر حتى يكون الأمر آمنًا، ثم غير المسار"
        }
      },
      {
        "id": "real-2025-01-15-lc2o2",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      },
      {
        "id": "real-2025-01-15-lc2o3",
        "text": {
          "en": "Signal and force your way in",
          "nl": "Geef een signaal en forceer je weg naar binnen",
          "ar": "أعط إشارة واضغط للدخول"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-lc2o1",
    "explanation": {
      "en": "If there is a vehicle in your blind spot, you must wait until it is safe before changing lanes. Never change lanes when another vehicle is in your blind spot.",
      "nl": "Als er een voertuig in je dode hoek is, moet je wachten tot het veilig is voordat je van rijstrook verandert. Verander nooit van rijstrook als er een ander voertuig in je dode hoek is.",
      "ar": "إذا كان هناك مركبة في النقطة العمياء لديك، يجب عليك الانتظار حتى يكون الأمر آمنًا قبل تغيير المسار. لا تغير المسار أبدًا عندما تكون هناك مركبة أخرى في النقطة العمياء لديك."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2025-01-15-lc3",
    "text": {
      "en": "You are driving in the left lane of a two-lane road. You want to move to the right lane. What should you do?",
      "nl": "Je rijdt in de linkerrijstrook van een tweebaansweg. Je wilt naar de rechterrijstrook. Wat moet je doen?",
      "ar": "أنت تقود في المسار الأيسر لطريق ذو مسارين. تريد الانتقال إلى المسار الأيمن. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-lc3o1",
        "text": {
          "en": "Check mirrors, signal, then change when safe",
          "nl": "Controleer de spiegels, geef een signaal en verander dan wanneer het veilig is",
          "ar": "تحقق من المرايا، أعط إشارة، ثم غير عندما يكون الأمر آمنًا"
        }
      },
      {
        "id": "real-2025-01-15-lc3o2",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      },
      {
        "id": "real-2025-01-15-lc3o3",
        "text": {
          "en": "Signal and change without checking",
          "nl": "Geef een signaal en verander zonder te controleren",
          "ar": "أعط إشارة وغير دون التحقق"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-lc3o1",
    "explanation": {
      "en": "The correct procedure for changing lanes is: check mirrors and blind spots, signal your intention, then change lanes when it is safe to do so.",
      "nl": "De juiste procedure voor het veranderen van rijstrook is: kijk in je spiegels en dode hoeken, geef je intentie aan met een signaal en verander dan van rijstrook wanneer het veilig is om dat te doen.",
      "ar": "الإجراء الصحيح لتغيير المسار هو: تحقق من المرايا والنقاط العمياء، أعط إشارة بنواياك، ثم غير المسار عندما يكون ذلك آمنًا."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2025-01-15-lc4",
    "text": {
      "en": "You are on a motorway and want to move to the right lane to overtake. A car is approaching quickly from behind in the right lane. What should you do?",
      "nl": "Je bent op de snelweg en wilt naar de rechterrijstrook om in te halen. Een auto nadert snel van achteren in de rechterrijstrook. Wat moet je doen?",
      "ar": "أنت على الطريق السريع وتريد الانتقال إلى المسار الأيمن لتجاوز. سيارة تقترب بسرعة من الخلف في المسار الأيمن. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-lc4o1",
        "text": {
          "en": "Wait until the car passes, then change lanes",
          "nl": "Wacht tot de auto voorbij is, verander dan van rijstrook",
          "ar": "انتظر حتى تمر السيارة، ثم غير المسار"
        }
      },
      {
        "id": "real-2025-01-15-lc4o2",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      },
      {
        "id": "real-2025-01-15-lc4o3",
        "text": {
          "en": "Speed up and change lanes",
          "nl": "Versnel en verander van rijstrook",
          "ar": "تسارع وغير المسار"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-lc4o1",
    "explanation": {
      "en": "If a car is approaching quickly from behind in the lane you want to enter, you must wait until it passes before changing lanes. Never force your way into a lane.",
      "nl": "Als er een auto snel van achteren nadert in de rijstrook die je wilt betreden, moet je wachten tot deze voorbij is voordat je van rijstrook verandert. Forceer nooit je weg in een rijstrook.",
      "ar": "إذا كانت سيارة تقترب بسرعة من الخلف في المسار الذي تريد الدخول إليه، يجب عليك الانتظار حتى تمر قبل تغيير المسار. لا تضغط أبدًا للدخول إلى مسار."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2025-01-15-lc5",
    "text": {
      "en": "You are driving in the middle lane of a three-lane motorway. You want to move to the right lane. What should you check?",
      "nl": "Je rijdt in de middelste rijstrook van een driebaansnelweg. Je wilt naar de rechterrijstrook. Wat moet je controleren?",
      "ar": "أنت تقود في المسار الأوسط لطريق سريع ذو ثلاثة مسارات. تريد الانتقال إلى المسار الأيمن. ماذا يجب أن تتحقق؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-lc5o1",
        "text": {
          "en": "Right mirror and right blind spot",
          "nl": "Rechtermirror en rechter dode hoek",
          "ar": "مرآة الجانب الأيمن والنقطة العمياء اليمنى"
        }
      },
      {
        "id": "real-2025-01-15-lc5o2",
        "text": {
          "en": "Left mirror only",
          "nl": "Enkel de linkermirror",
          "ar": "مرآة الجانب الأيسر فقط"
        }
      },
      {
        "id": "real-2025-01-15-lc5o3",
        "text": {
          "en": "No need to check, just signal",
          "nl": "Geen behoefte om te controleren, gewoon signaleren",
          "ar": "لا حاجة للتحقق، فقط قم بالإشارة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-lc5o1",
    "explanation": {
      "en": "When moving to the right lane, you must check your right mirror and right blind spot to ensure it is safe before changing lanes.",
      "nl": "Wanneer je naar de rechterrijstrook wilt gaan, moet je je rechterspiegel en rechterdode hoek controleren om te zorgen dat het veilig is voordat je van rijstrook verandert.",
      "ar": "عند الانتقال إلى المسار الأيمن، يجب عليك التحقق من مرآتك اليمنى والنقطة العمياء اليمنى للتأكد من أنه آمن قبل تغيير المسار."
    },
    "subject": "Lane Changing"
  },
  {
    "id": "real-2025-01-15-rm1",
    "text": {
      "en": "You see a broken white line in the center of the road. What does this mean?",
      "nl": "Je ziet een onderbroken witte lijn in het midden van de weg. Wat betekent dit?",
      "ar": "ترى خطًا أبيض متقطعًا في وسط الطريق. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rm1o1",
        "text": {
          "en": "You may cross it to overtake when safe",
          "nl": "Je mag het overschrijden om in te halen wanneer het veilig is",
          "ar": "يمكنك تجاوزه لتجاوز عندما يكون ذلك آمنًا"
        }
      },
      {
        "id": "real-2025-01-15-rm1o2",
        "text": {
          "en": "You must not cross it",
          "nl": "Je mag het niet overschrijden",
          "ar": "لا يجب عليك تجاوزه"
        }
      },
      {
        "id": "real-2025-01-15-rm1o3",
        "text": {
          "en": "It indicates a bus lane",
          "nl": "Het geeft een busbaan aan",
          "ar": "تشير إلى ممر الحافلات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rm1o1",
    "explanation": {
      "en": "A broken white line means you may cross it to overtake or change lanes when it is safe to do so. Always check for oncoming traffic before crossing.",
      "nl": "Een onderbroken witte lijn betekent dat je deze mag overschrijden om in te halen of van rijstrook te wisselen wanneer het veilig is om dit te doen. Controleer altijd op tegemoetkomend verkeer voordat je oversteekt.",
      "ar": "يعني الخط الأبيض المتقطع أنه يمكنك تجاوزه لتجاوز أو تغيير المسارات عندما يكون ذلك آمنًا. تحقق دائمًا من حركة المرور القادمة قبل العبور."
    },
    "subject": "Road Markings"
  },
  {
    "id": "real-2025-01-15-rm2",
    "text": {
      "en": "You see a solid white line in the center of the road. What does this mean?",
      "nl": "Je ziet een doorgetrokken witte lijn in het midden van de weg. Wat betekent dit?",
      "ar": "ترى خطًا أبيض مستمرًا في وسط الطريق. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rm2o1",
        "text": {
          "en": "You may cross it to overtake",
          "nl": "Je mag het overschrijden om in te halen",
          "ar": "يمكنك تجاوزه لتجاوز"
        }
      },
      {
        "id": "real-2025-01-15-rm2o2",
        "text": {
          "en": "You must not cross it except in emergencies",
          "nl": "Je mag het niet overschrijden, behalve in noodgevallen",
          "ar": "لا يجب عليك تجاوزه إلا في حالات الطوارئ"
        }
      },
      {
        "id": "real-2025-01-15-rm2o3",
        "text": {
          "en": "It indicates a parking area",
          "nl": "Het geeft een parkeergebied aan",
          "ar": "تشير إلى منطقة وقوف السيارات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rm2o2",
    "explanation": {
      "en": "A solid white line means you must not cross it except in emergencies. This is a safety measure to prevent dangerous overtaking maneuvers.",
      "nl": "Een doorgetrokken witte lijn betekent dat je deze niet mag overschrijden, behalve in noodgevallen. Dit is een veiligheidsmaatregel om gevaarlijke inhaalmanoeuvres te voorkomen.",
      "ar": "يعني الخط الأبيض المستمر أنه لا يجب عليك تجاوزه إلا في حالات الطوارئ. هذه تدبير أمان لمنع المناورات الخطرة للتجاوز."
    },
    "subject": "Road Markings"
  },
  {
    "id": "real-2025-01-15-rm3",
    "text": {
      "en": "You see yellow lines along the edge of the road. What do they indicate?",
      "nl": "Je ziet gele lijnen langs de rand van de weg. Wat geven ze aan?",
      "ar": "ترى خطوطًا صفراء على حافة الطريق. ماذا تشير؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rm3o1",
        "text": {
          "en": "Parking restrictions",
          "nl": "Parkeerbeperkingen",
          "ar": "قيود على الوقوف"
        }
      },
      {
        "id": "real-2025-01-15-rm3o2",
        "text": {
          "en": "Speed limit zone",
          "nl": "Snelheidslimietzone",
          "ar": "منطقة حد السرعة"
        }
      },
      {
        "id": "real-2025-01-15-rm3o3",
        "text": {
          "en": "Bus lane",
          "nl": "Busbaan",
          "ar": "مسار الحافلات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rm3o1",
    "explanation": {
      "en": "Yellow lines along the edge of the road indicate parking restrictions. A single yellow line usually means no parking during certain times, while a double yellow line means no parking at any time.",
      "nl": "Geel lijnen langs de rand van de weg geven parkeerbeperkingen aan. Een enkele gele lijn betekent meestal dat parkeren op bepaalde tijden niet is toegestaan, terwijl een dubbele gele lijn betekent dat parkeren op elk moment niet is toegestaan.",
      "ar": "تشير الخطوط الصفراء على حافة الطريق إلى قيود على الوقوف. عادةً ما تعني الخط الأصفر المفرد عدم الوقوف خلال أوقات معينة، بينما تعني الخطوط الصفراء المزدوجة عدم الوقوف في أي وقت."
    },
    "subject": "Road Markings"
  },
  {
    "id": "real-2025-01-15-rm4",
    "text": {
      "en": "You see diagonal white stripes in the center of the road. What does this mean?",
      "nl": "Je ziet diagonale witte strepen in het midden van de weg. Wat betekent dit?",
      "ar": "ترى خطوطًا بيضاء مائلة في وسط الطريق. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rm4o1",
        "text": {
          "en": "You must not enter this area",
          "nl": "Je mag dit gebied niet betreden",
          "ar": "لا يجب عليك دخول هذه المنطقة"
        }
      },
      {
        "id": "real-2025-01-15-rm4o2",
        "text": {
          "en": "You may park here",
          "nl": "Je mag hier parkeren",
          "ar": "يمكنك الوقوف هنا"
        }
      },
      {
        "id": "real-2025-01-15-rm4o3",
        "text": {
          "en": "Overtaking is permitted",
          "nl": "Inhalen is toegestaan",
          "ar": "تجاوز مسموح"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rm4o1",
    "explanation": {
      "en": "Diagonal white stripes (hatched markings) indicate an area you must not enter. These are used to separate traffic flows and prevent dangerous maneuvers.",
      "nl": "Diagonale witte strepen (gehaakte markeringen) geven een gebied aan waar je niet mag binnenkomen. Deze worden gebruikt om verkeersstromen te scheiden en gevaarlijke manoeuvres te voorkomen.",
      "ar": "تشير الخطوط البيضاء المائلة (العلامات المخططة) إلى منطقة يجب ألا تدخلها. تُستخدم هذه لفصل تدفقات المرور ومنع المناورات الخطرة."
    },
    "subject": "Road Markings"
  },
  {
    "id": "real-2025-01-15-rm5",
    "text": {
      "en": "You see a solid yellow line next to a broken yellow line. What does this mean?",
      "nl": "Je ziet een doorlopende gele lijn naast een onderbroken gele lijn. Wat betekent dit?",
      "ar": "ترى خطًا أصفر مستمرًا بجوار خط أصفر مكسور. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-15-rm5o1",
        "text": {
          "en": "No parking on the side with the solid line",
          "nl": "Geen parkeren aan de kant met de doorlopende lijn",
          "ar": "لا يُسمح بالوقوف على الجانب الذي يحتوي على الخط المستمر"
        }
      },
      {
        "id": "real-2025-01-15-rm5o2",
        "text": {
          "en": "Parking allowed on both sides",
          "nl": "Parkeren toegestaan aan beide zijden",
          "ar": "الوقوف مسموح به على كلا الجانبين"
        }
      },
      {
        "id": "real-2025-01-15-rm5o3",
        "text": {
          "en": "Speed limit zone",
          "nl": "Snelheidslimietzone",
          "ar": "منطقة حد السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-15-rm5o1",
    "explanation": {
      "en": "A solid yellow line means no parking at any time on that side. A broken yellow line means parking restrictions apply during certain times. The combination indicates different parking rules on each side of the road.",
      "nl": "Een doorlopende gele lijn betekent dat parkeren op dat gedeelte te allen tijde niet is toegestaan. Een onderbroken gele lijn betekent dat parkeerbeperkingen gelden op bepaalde tijden. De combinatie geeft verschillende parkeerregels aan op elke kant van de weg.",
      "ar": "يعني الخط الأصفر المستمر أنه لا يُسمح بالوقوف في أي وقت على ذلك الجانب. يعني الخط الأصفر المكسور أن قيود الوقوف تنطبق خلال أوقات معينة. تشير المجموعة إلى قواعد وقوف مختلفة على كل جانب من جوانب الطريق."
    },
    "subject": "Road Markings"
  },
  {
    "id": "real-2025-01-20-mr1",
    "text": {
      "en": "You are driving on a motorway. What is the maximum speed limit for cars?",
      "nl": "Je rijdt op een autosnelweg. Wat is de maximumsnelheid voor auto's?",
      "ar": "أنت تقود على طريق سريع. ما هو الحد الأقصى للسرعة للسيارات؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-mr1o1",
        "text": {
          "en": "100 km/h",
          "nl": "100 km/u",
          "ar": "100 كم/س"
        }
      },
      {
        "id": "real-2025-01-20-mr1o2",
        "text": {
          "en": "130 km/h",
          "nl": "130 km/u",
          "ar": "130 كم/س"
        }
      },
      {
        "id": "real-2025-01-20-mr1o3",
        "text": {
          "en": "120 km/h",
          "nl": "120 km/u",
          "ar": "120 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-mr1o1",
    "explanation": {
      "en": "The maximum speed limit on Dutch motorways is 100 km/h (as of 2025). This applies during the day. At night (19:00-06:00), the limit is 130 km/h on some sections, but the standard daytime limit is 100 km/h.",
      "nl": "De maximumsnelheid op Nederlandse autosnelwegen is 100 km/u (vanaf 2025). Dit geldt overdag. 's Nachts (19:00-06:00) is de limiet 130 km/u op sommige stukken, maar de standaard daglimiet is 100 km/u.",
      "ar": "الحد الأقصى للسرعة على الطرق السريعة الهولندية هو 100 كم/س (اعتبارًا من 2025). هذا ينطبق خلال النهار. في الليل (19:00-06:00)، الحد هو 130 كم/س في بعض الأقسام، ولكن الحد القياسي خلال النهار هو 100 كم/س."
    },
    "subject": "Motorway Rules"
  },
  {
    "id": "real-2025-01-20-mr2",
    "text": {
      "en": "You are entering a motorway from a slip road. What should you do?",
      "nl": "U komt een autosnelweg op via een invoegstrook. Wat moet u doen?",
      "ar": "أنت تدخل الطريق السريع من طريق انزلاق. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-mr2o1",
        "text": {
          "en": "Match the speed of traffic and merge safely",
          "nl": "Pas de snelheid van het verkeer aan en voeg veilig in",
          "ar": "تطابق سرعة حركة المرور واندماج بأمان"
        }
      },
      {
        "id": "real-2025-01-20-mr2o2",
        "text": {
          "en": "Stop and wait for a gap",
          "nl": "Stop en wacht op een gat",
          "ar": "توقف وانتظر فجوة"
        }
      },
      {
        "id": "real-2025-01-20-mr2o3",
        "text": {
          "en": "Enter immediately at any speed",
          "nl": "Voeg onmiddellijk in met elke snelheid",
          "ar": "ادخل على الفور بأي سرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-mr2o1",
    "explanation": {
      "en": "When entering a motorway, you should match the speed of traffic on the motorway and merge safely when there is a gap. Never stop on the slip road unless absolutely necessary.",
      "nl": "Bij het invoegen op een autosnelweg moet u de snelheid van het verkeer op de autosnelweg aanpassen en veilig invoegen wanneer er een gat is. Stop nooit op de invoegstrook, tenzij absoluut noodzakelijk.",
      "ar": "عند الدخول إلى الطريق السريع، يجب عليك مطابقة سرعة حركة المرور على الطريق السريع والاندماج بأمان عندما يكون هناك فجوة. لا تتوقف أبدًا على طريق الانزلاق ما لم يكن ذلك ضروريًا للغاية."
    },
    "subject": "Motorway Rules"
  },
  {
    "id": "real-2025-01-20-mr3",
    "text": {
      "en": "You are driving on a motorway and see a hard shoulder. When can you use it?",
      "nl": "U rijdt op een autosnelweg en ziet een vluchtstrook. Wanneer mag u deze gebruiken?",
      "ar": "أنت تقود على الطريق السريع وترى حارة الطوارئ. متى يمكنك استخدامها؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-mr3o1",
        "text": {
          "en": "Only in emergencies or when directed by signs",
          "nl": "Alleen in noodgevallen of wanneer aangegeven door borden",
          "ar": "فقط في حالات الطوارئ أو عندما يتم توجيهك بواسطة علامات"
        }
      },
      {
        "id": "real-2025-01-20-mr3o2",
        "text": {
          "en": "To overtake slow vehicles",
          "nl": "Om langzame voertuigen in te halen",
          "ar": "لتجاوز المركبات البطيئة"
        }
      },
      {
        "id": "real-2025-01-20-mr3o3",
        "text": {
          "en": "To take a break whenever you want",
          "nl": "Om een pauze te nemen wanneer u maar wilt",
          "ar": "لأخذ استراحة متى شئت"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-mr3o1",
    "explanation": {
      "en": "The hard shoulder is for emergencies only, such as breakdowns or medical emergencies. You may also use it when directed by traffic signs. Never use it for overtaking or taking breaks.",
      "nl": "De vluchtstrook is alleen voor noodgevallen, zoals pech of medische noodgevallen. U mag deze ook gebruiken wanneer verkeersborden dat aangeven. Gebruik het nooit om in te halen of om pauzes te nemen.",
      "ar": "حارة الطوارئ مخصصة فقط لحالات الطوارئ، مثل الأعطال أو الحالات الطبية الطارئة. يمكنك أيضًا استخدامها عند توجيهك بواسطة إشارات المرور. لا تستخدمها أبدًا لتجاوز المركبات أو لأخذ استراحة."
    },
    "subject": "Motorway Rules"
  },
  {
    "id": "real-2025-01-20-mr4",
    "text": {
      "en": "You are driving on a three-lane motorway. Which lane should you normally use?",
      "nl": "U rijdt op een snelweg met drie rijstroken. Welke rijstrook moet u normaal gebruiken?",
      "ar": "أنت تقود على طريق سريع بثلاثة مسارات. أي مسار يجب أن تستخدمه عادةً؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-mr4o1",
        "text": {
          "en": "Right lane, unless overtaking",
          "nl": "Rechterrijstrook, tenzij inhalen",
          "ar": "المسار الأيمن، ما لم تكن تتجاوز"
        }
      },
      {
        "id": "real-2025-01-20-mr4o2",
        "text": {
          "en": "Middle lane",
          "nl": "Middelste rijstrook",
          "ar": "المسار الأوسط"
        }
      },
      {
        "id": "real-2025-01-20-mr4o3",
        "text": {
          "en": "Left lane",
          "nl": "Linker rijstrook",
          "ar": "الحارة اليسرى"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-mr4o1",
    "explanation": {
      "en": "On a motorway, you should normally drive in the right lane and only use other lanes for overtaking. This is the \"keep right\" rule and helps maintain traffic flow.",
      "nl": "Op een snelweg moet u normaal gesproken in de rechterrijstrook rijden en andere rijstroken alleen gebruiken om in te halen. Dit is de \"houd rechts\" regel en helpt de verkeersstroom te behouden.",
      "ar": "على الطريق السريع، يجب عليك عادةً القيادة في المسار الأيمن واستخدام المسارات الأخرى فقط لتجاوز. هذه هي قاعدة \"ابق على اليمين\" وتساعد في الحفاظ على تدفق حركة المرور."
    },
    "subject": "Motorway Rules"
  },
  {
    "id": "real-2025-01-20-mr5",
    "text": {
      "en": "You are driving on a motorway and see a variable speed limit sign showing 80 km/h. What should you do?",
      "nl": "U rijdt op een snelweg en ziet een variabel snelheidsbord dat 80 km/u aangeeft. Wat moet u doen?",
      "ar": "أنت تقود على طريق سريع وترى علامة حد سرعة متغيرة تظهر 80 كم/س. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-mr5o1",
        "text": {
          "en": "Reduce speed to 80 km/h immediately",
          "nl": "Verlaag de snelheid onmiddellijk naar 80 km/u",
          "ar": "قلل السرعة إلى 80 كم/س على الفور"
        }
      },
      {
        "id": "real-2025-01-20-mr5o2",
        "text": {
          "en": "Continue at 100 km/h",
          "nl": "Ga verder met 100 km/u",
          "ar": "تابع بسرعة 100 كم/ساعة"
        }
      },
      {
        "id": "real-2025-01-20-mr5o3",
        "text": {
          "en": "Ignore the sign if traffic is flowing",
          "nl": "Negeer het bord als het verkeer doorstroomt",
          "ar": "تجاهل العلامة إذا كانت حركة المرور تسير"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-mr5o1",
    "explanation": {
      "en": "Variable speed limit signs on motorways must be obeyed immediately. They are used to manage traffic flow and improve safety, especially during congestion or adverse weather.",
      "nl": "Variabele snelheidsborden op snelwegen moeten onmiddellijk worden opgevolgd. Ze worden gebruikt om de verkeersstroom te beheren en de veiligheid te verbeteren, vooral tijdens drukte of slecht weer.",
      "ar": "يجب الامتثال لعلامات حد السرعة المتغيرة على الطرق السريعة على الفور. تُستخدم لإدارة تدفق حركة المرور وتحسين السلامة، خاصةً أثناء الازدحام أو الظروف الجوية السيئة."
    },
    "subject": "Motorway Rules"
  },
  {
    "id": "real-2025-01-20-bi1",
    "text": {
      "en": "You are driving and see a cyclist ahead. The cyclist is swerving slightly. What should you do?",
      "nl": "U rijdt en ziet een fietser voor u. De fietser zwabbert een beetje. Wat moet u doen?",
      "ar": "أنت تقود وترى راكب دراجة أمامك. راكب الدراجة يتمايل قليلاً. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-bi1o1",
        "text": {
          "en": "Reduce speed and give extra space when overtaking",
          "nl": "Verlaag de snelheid en geef extra ruimte bij het inhalen",
          "ar": "قلل السرعة وامنح مساحة إضافية عند التجاوز"
        }
      },
      {
        "id": "real-2025-01-20-bi1o2",
        "text": {
          "en": "Overtake immediately",
          "nl": "Onmiddellijk inhalen",
          "ar": "التجاوز على الفور"
        }
      },
      {
        "id": "real-2025-01-20-bi1o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-bi1o1",
    "explanation": {
      "en": "An unstable cyclist requires extra caution. Reduce speed and give at least 1.5 meters of space when overtaking. Never overtake too closely.",
      "nl": "Een onstabiele fietser vereist extra voorzichtigheid. Verlaag de snelheid en geef minstens 1,5 meter ruimte bij het inhalen. Haal nooit te dicht in.",
      "ar": "راكب الدراجة غير المستقر يتطلب مزيدًا من الحذر. قلل السرعة وامنح على الأقل 1.5 متر من المسافة عند التجاوز. لا تتجاوز أبدًا عن كثب."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-01-20-bi2",
    "text": {
      "en": "You are turning right at a junction. A cyclist is going straight ahead on your right. What should you do?",
      "nl": "U slaat rechtsaf bij een kruispunt. Een fietser gaat rechtdoor aan uw rechterkant. Wat moet u doen?",
      "ar": "أنت تنعطف يمينًا عند تقاطع. راكب الدراجة يسير مباشرة على يمينك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-bi2o1",
        "text": {
          "en": "Give way to the cyclist",
          "nl": "Maak plaats voor de fietser",
          "ar": "إفساح الطريق لراكب الدراجة"
        }
      },
      {
        "id": "real-2025-01-20-bi2o2",
        "text": {
          "en": "Turn right, cyclists must give way",
          "nl": "Sla rechtsaf, fietsers moeten voorrang geven",
          "ar": "انعطف يمينًا، يجب على راكبي الدراجات إعطاء الأولوية"
        }
      },
      {
        "id": "real-2025-01-20-bi2o3",
        "text": {
          "en": "Sound your horn to warn the cyclist",
          "nl": "Toet de claxon om de fietser te waarschuwen",
          "ar": "استخدم بوق السيارة لتحذير راكب الدراجة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-bi2o1",
    "explanation": {
      "en": "When turning right, you must give way to cyclists going straight ahead on your right. Cyclists have the same rights as other vehicles at junctions.",
      "nl": "Bij het rechtsaf slaan moet u voorrang geven aan fietsers die rechtdoor gaan aan uw rechterkant. Fietsers hebben dezelfde rechten als andere voertuigen bij kruispunten.",
      "ar": "عند الانعطاف يمينًا، يجب عليك إعطاء الأولوية لراكبي الدراجات الذين يسيرون مباشرة على يمينك. يتمتع راكبو الدراجات بنفس حقوق المركبات الأخرى عند التقاطعات."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-01-20-bi3",
    "text": {
      "en": "You are driving in a built-up area. A cyclist is riding in a cycle lane on your right. What should you do?",
      "nl": "Je rijdt in een bebouwde kom. Een fietser rijdt in een fietspad aan je rechterkant. Wat moet je doen?",
      "ar": "أنت تقود في منطقة مبنية. راكب الدراجة يقود في مسار الدراجات على يمينك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-bi3o1",
        "text": {
          "en": "Give way to the cyclist and be extra cautious",
          "nl": "Geef voorrang aan de fietser en wees extra voorzichtig",
          "ar": "أعطِ الأولوية لراكب الدراجة وكن حذرًا بشكل إضافي"
        }
      },
      {
        "id": "real-2025-01-20-bi3o2",
        "text": {
          "en": "Continue normally, cyclists must give way",
          "nl": "Ga normaal door, fietsers moeten voorrang geven",
          "ar": "استمر بشكل طبيعي، يجب على راكبي الدراجات إعطاء الأولوية"
        }
      },
      {
        "id": "real-2025-01-20-bi3o3",
        "text": {
          "en": "Drive in the cycle lane",
          "nl": "Rijd in het fietspad",
          "ar": "قد في مسار الدراجات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-bi3o1",
    "explanation": {
      "en": "Cyclists in cycle lanes have priority. You must give way to them and be extra cautious, especially when turning across cycle lanes.",
      "nl": "Fietsers in fietspaden hebben voorrang. Je moet ze voorrang geven en extra voorzichtig zijn, vooral bij het afslaan over fietspaden.",
      "ar": "لدى راكبي الدراجات في مسارات الدراجات أولوية. يجب عليك إعطاؤهم الأولوية وأن تكون حذرًا بشكل خاص، خاصة عند الانعطاف عبر مسارات الدراجات."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-01-20-bi4",
    "text": {
      "en": "You are overtaking a cyclist on a narrow road. What is the minimum safe distance?",
      "nl": "Je haalt een fietser in op een smalle weg. Wat is de minimale veilige afstand?",
      "ar": "أنت تتجاوز راكب الدراجة على طريق ضيق. ما هي الحد الأدنى من المسافة الآمنة؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-bi4o1",
        "text": {
          "en": "At least 1.5 meters",
          "nl": "Minimaal 1,5 meter",
          "ar": "على الأقل 1.5 متر"
        }
      },
      {
        "id": "real-2025-01-20-bi4o2",
        "text": {
          "en": "1 meter is sufficient",
          "nl": "1 meter is voldoende",
          "ar": "1 متر كافٍ"
        }
      },
      {
        "id": "real-2025-01-20-bi4o3",
        "text": {
          "en": "Any distance is fine",
          "nl": "Elke afstand is goed",
          "ar": "أي مسافة جيدة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-bi4o1",
    "explanation": {
      "en": "When overtaking a cyclist, you must maintain at least 1.5 meters of distance for safety. On narrow roads, you may need to wait for a safe opportunity to overtake.",
      "nl": "Bij het inhalen van een fietser moet je minimaal 1,5 meter afstand houden voor de veiligheid. Op smalle wegen moet je misschien wachten op een veilige gelegenheid om in te halen.",
      "ar": "عند تجاوز راكب الدراجة، يجب عليك الحفاظ على مسافة لا تقل عن 1.5 متر للسلامة. على الطرق الضيقة، قد تحتاج إلى الانتظار حتى تتاح لك فرصة آمنة للتجاوز."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-01-20-bi5",
    "text": {
      "en": "You are driving and see a cyclist ahead signaling to turn right. What should you do?",
      "nl": "Je rijdt en ziet een fietser voor je die aangeeft rechtsaf te slaan. Wat moet je doen?",
      "ar": "أنت تقود وترى راكب الدراجة أمامك يشير إلى الانعطاف إلى اليمين. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-bi5o1",
        "text": {
          "en": "Give way and allow the cyclist to turn",
          "nl": "Geef voorrang en laat de fietser draaien",
          "ar": "أعطِ الأولوية واسمح لراكب الدراجة بالانعطاف"
        }
      },
      {
        "id": "real-2025-01-20-bi5o2",
        "text": {
          "en": "Overtake on the left",
          "nl": "Inhalen aan de linkerkant",
          "ar": "تجاوز من اليسار"
        }
      },
      {
        "id": "real-2025-01-20-bi5o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-bi5o1",
    "explanation": {
      "en": "When a cyclist signals to turn, you must give way and allow them to complete their maneuver safely. Never overtake a cyclist who is signaling to turn.",
      "nl": "Wanneer een fietser aangeeft te draaien, moet je voorrang geven en hen in staat stellen hun manoeuvre veilig te voltooien. Overtreed nooit een fietser die aangeeft te draaien.",
      "ar": "عندما يشير راكب الدراجة إلى الانعطاف، يجب عليك إعطاؤه الأولوية والسماح له بإكمال مناورة بأمان. لا تتجاوز أبدًا راكب الدراجة الذي يشير إلى الانعطاف."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-01-20-ti1",
    "text": {
      "en": "You are driving and see a tram approaching from behind. What should you do?",
      "nl": "Je rijdt en ziet een tram van achteren naderen. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى ترامًا يقترب من الخلف. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-ti1o1",
        "text": {
          "en": "Give way and allow the tram to pass",
          "nl": "Verleen voorrang en laat de tram passeren",
          "ar": "أعطِ الأولوية ودع الترام يمر"
        }
      },
      {
        "id": "real-2025-01-20-ti1o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-01-20-ti1o3",
        "text": {
          "en": "Speed up to stay ahead",
          "nl": "Versnel om voor te blijven",
          "ar": "تسارع لتبقى في المقدمة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-ti1o1",
    "explanation": {
      "en": "Trams have priority over other vehicles. When a tram approaches from behind, you must give way and allow it to pass safely.",
      "nl": "Trams hebben voorrang op andere voertuigen. Wanneer een tram van achteren nadert, moet je voorrang verlenen en het veilig laten passeren.",
      "ar": "لدى الترام أولوية على المركبات الأخرى. عندما يقترب ترام من الخلف، يجب عليك إعطاء الأولوية والسماح له بالمرور بأمان."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-01-20-ti2",
    "text": {
      "en": "You are at a junction. A tram is approaching from your right. Who has priority?",
      "nl": "Je bent bij een kruispunt. Een tram nadert van rechts. Wie heeft voorrang?",
      "ar": "أنت عند تقاطع. ترام يقترب من اليمين. من لديه الأولوية؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-ti2o1",
        "text": {
          "en": "The tram has priority",
          "nl": "De tram heeft voorrang",
          "ar": "لدى الترام أولوية"
        }
      },
      {
        "id": "real-2025-01-20-ti2o2",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      },
      {
        "id": "real-2025-01-20-ti2o3",
        "text": {
          "en": "Neither has priority",
          "nl": "Geen van beide heeft prioriteit",
          "ar": "لا يتمتع أي منهما بالأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-ti2o1",
    "explanation": {
      "en": "Trams have priority over other vehicles at junctions, even when approaching from the right. You must give way to trams.",
      "nl": "Trams hebben voorrang op andere voertuigen bij kruispunten, zelfs als ze van rechts naderen. Je moet voorrang verlenen aan trams.",
      "ar": "لدى الترام أولوية على المركبات الأخرى عند التقاطعات، حتى عند الاقتراب من اليمين. يجب عليك إعطاء الأولوية للترام."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-01-20-ti3",
    "text": {
      "en": "You are driving and see a tram stopped at a stop. Passengers are boarding. What should you do?",
      "nl": "Je rijdt en ziet een tram stoppen bij een halte. Passagiers stappen in. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى ترامًا متوقفًا عند محطة. الركاب يصعدون. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-ti3o1",
        "text": {
          "en": "Stop and wait until the tram moves",
          "nl": "Stop en wacht totdat de tram beweegt",
          "ar": "توقف وانتظر حتى يتحرك الترام"
        }
      },
      {
        "id": "real-2025-01-20-ti3o2",
        "text": {
          "en": "Overtake the tram immediately",
          "nl": "Inhaal de tram onmiddellijk",
          "ar": "تجاوز الترام على الفور"
        }
      },
      {
        "id": "real-2025-01-20-ti3o3",
        "text": {
          "en": "Continue at reduced speed",
          "nl": "Ga door met verminderde snelheid",
          "ar": "استمر بسرعة منخفضة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-ti3o1",
    "explanation": {
      "en": "When a tram is stopped and passengers are boarding or alighting, you must stop and wait until the tram moves or the doors close before proceeding.",
      "nl": "Wanneer een tram stopt en passagiers in- of uitstappen, moet je stoppen en wachten totdat de tram weer rijdt of de deuren sluiten voordat je verder rijdt.",
      "ar": "عندما يتوقف الترام ويصعد الركاب أو ينزلون، يجب عليك التوقف والانتظار حتى يتحرك الترام أو تغلق الأبواب قبل المتابعة."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-01-20-ti4",
    "text": {
      "en": "You are driving and see a tram signaling to turn. What should you do?",
      "nl": "Je rijdt en ziet een tram signaleren om af te slaan. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى ترامًا يشير إلى الانعطاف. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-ti4o1",
        "text": {
          "en": "Give way and allow the tram to turn",
          "nl": "Geef voorrang en laat de tram afslaan",
          "ar": "أعطِ الأولوية ودع الترام ينعطف"
        }
      },
      {
        "id": "real-2025-01-20-ti4o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-01-20-ti4o3",
        "text": {
          "en": "Overtake the tram",
          "nl": "Overtake de tram",
          "ar": "تجاوز الترام"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-ti4o1",
    "explanation": {
      "en": "When a tram signals to turn, you must give way and allow it to complete its maneuver. Never overtake a tram that is signaling to turn.",
      "nl": "Wanneer een tram aangeeft te willen afslaan, moet je voorrang geven en hem zijn manoeuvre laten afmaken. Overtake nooit een tram die aangeeft te willen afslaan.",
      "ar": "عندما تشير الترام إلى الانعطاف، يجب عليك إعطاء الأولوية والسماح لها بإكمال مناورتها. لا تتجاوز الترام التي تشير إلى الانعطاف."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-01-20-ti5",
    "text": {
      "en": "You are driving on a road with tram tracks. What should you be aware of?",
      "nl": "Je rijdt op een weg met tramrails. Waar moet je op letten?",
      "ar": "أنت تقود على طريق به مسارات ترام. ماذا يجب أن تكون على علم به؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-ti5o1",
        "text": {
          "en": "Trams have priority and tracks can be slippery when wet",
          "nl": "Trams hebben voorrang en rails kunnen glad zijn als ze nat zijn",
          "ar": "الترام لها أولوية والمسارات يمكن أن تكون زلقة عندما تكون مبللة"
        }
      },
      {
        "id": "real-2025-01-20-ti5o2",
        "text": {
          "en": "You can drive on the tracks freely",
          "nl": "Je kunt vrij over de rails rijden",
          "ar": "يمكنك القيادة بحرية على المسارات"
        }
      },
      {
        "id": "real-2025-01-20-ti5o3",
        "text": {
          "en": "Trams must always give way to cars",
          "nl": "Trams moeten altijd voorrang geven aan auto's",
          "ar": "يجب على الترام دائمًا إعطاء الأولوية للسيارات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-ti5o1",
    "explanation": {
      "en": "When driving on roads with tram tracks, remember that trams have priority and the tracks can be slippery when wet, especially for motorcycles and bicycles. Always be cautious.",
      "nl": "Wanneer je op wegen met tramrails rijdt, onthoud dan dat trams voorrang hebben en dat de rails glad kunnen zijn als ze nat zijn, vooral voor motorfietsen en fietsen. Wees altijd voorzichtig.",
      "ar": "عند القيادة على الطرق التي تحتوي على مسارات ترام، تذكر أن الترام لها أولوية وأن المسارات يمكن أن تكون زلقة عندما تكون مبللة، خاصة للدراجات النارية والدراجات. كن دائمًا حذرًا."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-01-20-pk1",
    "text": {
      "en": "You want to park your car. You see a sign showing \"P\" with \"Mon-Fri 09:00-17:00\". What does this mean?",
      "nl": "Je wilt je auto parkeren. Je ziet een bord met \"P\" en \"Ma-Vr 09:00-17:00\". Wat betekent dit?",
      "ar": "تريد ركن سيارتك. ترى علامة تظهر \"P\" مع \"الإثنين-الجمعة 09:00-17:00\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-pk1o1",
        "text": {
          "en": "Parking is allowed outside these hours",
          "nl": "Parkeren is toegestaan buiten deze uren",
          "ar": "الوقوف مسموح به خارج هذه الساعات"
        }
      },
      {
        "id": "real-2025-01-20-pk1o2",
        "text": {
          "en": "Parking is only allowed during these hours",
          "nl": "Parkeren is alleen toegestaan tijdens deze uren",
          "ar": "الوقوف مسموح به فقط خلال هذه الساعات"
        }
      },
      {
        "id": "real-2025-01-20-pk1o3",
        "text": {
          "en": "Parking is free during these hours",
          "nl": "Parkeren is gratis tijdens deze uren",
          "ar": "الوقوف مجاني خلال هذه الساعات"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-pk1o1",
    "explanation": {
      "en": "A parking sign with time restrictions means parking is allowed outside the specified hours. During the specified hours, parking restrictions apply (usually requiring a permit or payment).",
      "nl": "Een parkeerbord met tijdsbeperkingen betekent dat parkeren buiten de opgegeven uren is toegestaan. Tijdens de opgegeven uren gelden parkeerbeperkingen (meestal een vergunning of betaling vereist).",
      "ar": "علامة وقوف السيارات مع قيود زمنية تعني أن الوقوف مسموح به خارج الساعات المحددة. خلال الساعات المحددة، تنطبق قيود الوقوف (عادةً ما تتطلب تصريحًا أو دفعًا)."
    },
    "subject": "Parking Rules"
  },
  {
    "id": "real-2025-01-20-pk2",
    "text": {
      "en": "You want to park near a junction. What is the minimum distance you must be from the junction?",
      "nl": "Je wilt parkeren bij een kruispunt. Wat is de minimale afstand die je van het kruispunt moet zijn?",
      "ar": "تريد ركن سيارتك بالقرب من تقاطع. ما هي الحد الأدنى من المسافة التي يجب أن تكون عليها من التقاطع؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-pk2o1",
        "text": {
          "en": "At least 5 meters",
          "nl": "Minstens 5 meter",
          "ar": "على الأقل 5 أمتار"
        }
      },
      {
        "id": "real-2025-01-20-pk2o2",
        "text": {
          "en": "At least 3 meters",
          "nl": "Minstens 3 meter",
          "ar": "على الأقل 3 أمتار"
        }
      },
      {
        "id": "real-2025-01-20-pk2o3",
        "text": {
          "en": "Any distance is fine",
          "nl": "Elke afstand is goed",
          "ar": "أي مسافة جيدة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-pk2o1",
    "explanation": {
      "en": "You must park at least 5 meters away from a junction to ensure visibility and safety for other road users.",
      "nl": "Je moet minstens 5 meter van een kruising parkeren om zichtbaarheid en veiligheid voor andere weggebruikers te waarborgen.",
      "ar": "يجب عليك ركن السيارة على بعد 5 أمتار على الأقل من تقاطع لضمان الرؤية والسلامة لمستخدمي الطريق الآخرين."
    },
    "subject": "Parking Rules"
  },
  {
    "id": "real-2025-01-20-pk3",
    "text": {
      "en": "You want to park on a road with a bus stop. What is the minimum distance you must be from the bus stop?",
      "nl": "Je wilt parkeren op een weg met een bushalte. Wat is de minimale afstand die je van de bushalte moet zijn?",
      "ar": "تريد ركن السيارة على طريق به محطة حافلات. ما هي المسافة الدنيا التي يجب أن تكون بعيدًا عن محطة الحافلات؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-pk3o1",
        "text": {
          "en": "At least 12 meters",
          "nl": "Minstens 12 meter",
          "ar": "على الأقل 12 مترًا"
        }
      },
      {
        "id": "real-2025-01-20-pk3o2",
        "text": {
          "en": "At least 5 meters",
          "nl": "Minstens 5 meter",
          "ar": "على الأقل 5 أمتار"
        }
      },
      {
        "id": "real-2025-01-20-pk3o3",
        "text": {
          "en": "Any distance is fine",
          "nl": "Elke afstand is goed",
          "ar": "أي مسافة جيدة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-pk3o1",
    "explanation": {
      "en": "You must park at least 12 meters away from a bus stop to allow buses to stop and pick up passengers safely.",
      "nl": "Je moet minstens 12 meter van een bushalte parkeren om bussen in staat te stellen veilig te stoppen en passagiers op te halen.",
      "ar": "يجب عليك ركن السيارة على بعد 12 مترًا على الأقل من محطة الحافلات للسماح للحافلات بالتوقف واصطحاب الركاب بأمان."
    },
    "subject": "Parking Rules"
  },
  {
    "id": "real-2025-01-20-pk4",
    "text": {
      "en": "You see a disabled parking space. When can you park there?",
      "nl": "Je ziet een gehandicaptenparkeerplaats. Wanneer mag je daar parkeren?",
      "ar": "ترى مكانًا لركن السيارات المخصصة لذوي الاحتياجات الخاصة. متى يمكنك ركن السيارة هناك؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-pk4o1",
        "text": {
          "en": "Only if you have a valid disabled parking permit",
          "nl": "Alleen als je een geldige gehandicaptenparkeerkaart hebt",
          "ar": "فقط إذا كان لديك تصريح ركن خاص صالح"
        }
      },
      {
        "id": "real-2025-01-20-pk4o2",
        "text": {
          "en": "If no disabled person is using it",
          "nl": "Als er geen gehandicapte persoon gebruik van maakt",
          "ar": "إذا لم يكن هناك شخص معاق يستخدمه"
        }
      },
      {
        "id": "real-2025-01-20-pk4o3",
        "text": {
          "en": "Anytime for a short period",
          "nl": "Altijd voor een korte periode",
          "ar": "في أي وقت لفترة قصيرة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-pk4o1",
    "explanation": {
      "en": "Disabled parking spaces are reserved for vehicles with a valid disabled parking permit. You may only park there if you have such a permit displayed.",
      "nl": "Gehandicaptenparkeerplaatsen zijn gereserveerd voor voertuigen met een geldige gehandicaptenparkeerkaart. Je mag daar alleen parkeren als je zo'n kaart zichtbaar hebt.",
      "ar": "أماكن ركن السيارات المخصصة لذوي الاحتياجات الخاصة محجوزة للمركبات التي تحمل تصريح ركن خاص صالح. يمكنك ركن السيارة هناك فقط إذا كان لديك مثل هذا التصريح معروضًا."
    },
    "subject": "Parking Rules"
  },
  {
    "id": "real-2025-01-20-pk5",
    "text": {
      "en": "You want to park on a road with double yellow lines. What does this mean?",
      "nl": "Je wilt parkeren op een weg met dubbele gele lijnen. Wat betekent dit?",
      "ar": "تريد ركن السيارة على طريق به خطوط صفراء مزدوجة. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-pk5o1",
        "text": {
          "en": "No parking at any time",
          "nl": "Geen parkeren op elk moment",
          "ar": "لا يُسمح بالركن في أي وقت"
        }
      },
      {
        "id": "real-2025-01-20-pk5o2",
        "text": {
          "en": "Parking allowed during certain hours",
          "nl": "Parkeren toegestaan tijdens bepaalde uren",
          "ar": "مسموح بالوقوف خلال ساعات معينة"
        }
      },
      {
        "id": "real-2025-01-20-pk5o3",
        "text": {
          "en": "Parking allowed for residents only",
          "nl": "Parkeren alleen toegestaan voor bewoners",
          "ar": "مسموح بالوقوف للسكان فقط"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-pk5o1",
    "explanation": {
      "en": "Double yellow lines mean no parking at any time. This is a strict parking restriction that applies 24/7.",
      "nl": "Dubbele gele lijnen betekenen dat er op elk moment niet mag worden geparkeerd. Dit is een strikte parkeerbeperking die 24/7 van toepassing is.",
      "ar": "الخطوط الصفراء المزدوجة تعني عدم السماح بالركن في أي وقت. هذه قيود صارمة على الركن تنطبق على مدار الساعة طوال أيام الأسبوع."
    },
    "subject": "Parking Rules"
  },
  {
    "id": "real-2025-01-20-vk1",
    "text": {
      "en": "What is the minimum tread depth for car tires in the Netherlands?",
      "nl": "Wat is de minimale profieldiepte voor autobanden in Nederland?",
      "ar": "ما هو الحد الأدنى لعمق المداس لإطارات السيارات في هولندا؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-vk1o1",
        "text": {
          "en": "1.6 mm",
          "nl": "1,6 mm",
          "ar": "1.6 مم"
        }
      },
      {
        "id": "real-2025-01-20-vk1o2",
        "text": {
          "en": "2.0 mm",
          "nl": "2,0 mm",
          "ar": "2.0 مم"
        }
      },
      {
        "id": "real-2025-01-20-vk1o3",
        "text": {
          "en": "3.0 mm",
          "nl": "3,0 mm",
          "ar": "3.0 مم"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-vk1o1",
    "explanation": {
      "en": "The minimum legal tread depth for car tires in the Netherlands is 1.6 mm. Tires with less tread depth are illegal and unsafe.",
      "nl": "De minimale wettelijke profieldiepte voor autobanden in Nederland is 1,6 mm. Banden met een lagere profieldiepte zijn illegaal en onveilig.",
      "ar": "الحد الأدنى القانوني لعمق المداس لإطارات السيارات في هولندا هو 1.6 مم. الإطارات ذات العمق الأقل غير قانونية وغير آمنة."
    },
    "subject": "Vehicle Knowledge"
  },
  {
    "id": "real-2025-01-20-vk2",
    "text": {
      "en": "You are driving and notice your brake warning light is on. What should you do?",
      "nl": "Je rijdt en merkt dat je remwaarschuwingslampje brandt. Wat moet je doen?",
      "ar": "أنت تقود السيارة وتلاحظ أن ضوء تحذير الفرامل مضاء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-vk2o1",
        "text": {
          "en": "Stop safely and check the brake system",
          "nl": "Stop veilig en controleer het remsysteem",
          "ar": "توقف بأمان وافحص نظام الفرامل"
        }
      },
      {
        "id": "real-2025-01-20-vk2o2",
        "text": {
          "en": "Continue driving normally",
          "nl": "Blijf normaal rijden",
          "ar": "استمر في القيادة بشكل طبيعي"
        }
      },
      {
        "id": "real-2025-01-20-vk2o3",
        "text": {
          "en": "Increase speed to test brakes",
          "nl": "Verhoog de snelheid om de remmen te testen",
          "ar": "زد السرعة لاختبار الفرامل"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-vk2o1",
    "explanation": {
      "en": "A brake warning light indicates a problem with the brake system. You should stop safely as soon as possible and have the brakes checked. Never continue driving with a brake warning light on.",
      "nl": "Een remwaarschuwingslampje geeft een probleem met het remsysteem aan. Je moet zo snel mogelijk veilig stoppen en de remmen laten controleren. Blijf nooit rijden met een brandend remwaarschuwingslampje.",
      "ar": "يشير ضوء تحذير الفرامل إلى وجود مشكلة في نظام الفرامل. يجب عليك التوقف بأمان في أقرب وقت ممكن وفحص الفرامل. لا تستمر في القيادة مع تشغيل ضوء تحذير الفرامل."
    },
    "subject": "Vehicle Knowledge"
  },
  {
    "id": "real-2025-01-20-vk3",
    "text": {
      "en": "What should you check before starting a long journey?",
      "nl": "Wat moet je controleren voordat je aan een lange reis begint?",
      "ar": "ماذا يجب أن تتحقق منه قبل بدء رحلة طويلة؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-vk3o1",
        "text": {
          "en": "Tire pressure, oil level, lights, and fuel",
          "nl": "Bandenpressure, oliepeil, lichten en brandstof",
          "ar": "ضغط الإطارات، مستوى الزيت، الأضواء، والوقود"
        }
      },
      {
        "id": "real-2025-01-20-vk3o2",
        "text": {
          "en": "Only fuel level",
          "nl": "Alleen brandstofniveau",
          "ar": "مستوى الوقود فقط"
        }
      },
      {
        "id": "real-2025-01-20-vk3o3",
        "text": {
          "en": "Nothing, modern cars are reliable",
          "nl": "Niets, moderne auto's zijn betrouwbaar",
          "ar": "لا شيء، السيارات الحديثة موثوقة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-vk3o1",
    "explanation": {
      "en": "Before a long journey, you should check tire pressure, oil level, all lights, fuel level, and ensure your vehicle is in good condition. This helps prevent breakdowns and ensures safety.",
      "nl": "Voor een lange reis moet je de bandenspanning, oliepeil, alle lichten, brandstofniveau controleren en ervoor zorgen dat je voertuig in goede staat is. Dit helpt om pech te voorkomen en zorgt voor veiligheid.",
      "ar": "قبل الرحلة الطويلة، يجب عليك التحقق من ضغط الإطارات، مستوى الزيت، جميع الأضواء، مستوى الوقود، والتأكد من أن سيارتك في حالة جيدة. يساعد ذلك في منع الأعطال ويضمن السلامة."
    },
    "subject": "Vehicle Knowledge"
  },
  {
    "id": "real-2025-01-20-vk4",
    "text": {
      "en": "You notice your car is using more fuel than usual. What could be the cause?",
      "nl": "Je merkt dat je auto meer brandstof verbruikt dan normaal. Wat kan de oorzaak zijn?",
      "ar": "تلاحظ أن سيارتك تستهلك وقودًا أكثر من المعتاد. ما قد يكون السبب؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-vk4o1",
        "text": {
          "en": "Underinflated tires, dirty air filter, or engine problems",
          "nl": "Te zachte banden, vervuilde luchtfilter of motorproblemen",
          "ar": "إطارات منخفضة الضغط، فلتر هواء متسخ، أو مشاكل في المحرك"
        }
      },
      {
        "id": "real-2025-01-20-vk4o2",
        "text": {
          "en": "Only driving style",
          "nl": "Alleen rijstijl",
          "ar": "أسلوب القيادة فقط"
        }
      },
      {
        "id": "real-2025-01-20-vk4o3",
        "text": {
          "en": "Nothing, fuel consumption varies",
          "nl": "Niets, brandstofverbruik varieert",
          "ar": "لا شيء، يختلف استهلاك الوقود"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-vk4o1",
    "explanation": {
      "en": "Increased fuel consumption can be caused by underinflated tires, a dirty air filter, engine problems, or poor driving habits. Regular maintenance helps maintain fuel efficiency.",
      "nl": "Verhoogd brandstofverbruik kan worden veroorzaakt door te zachte banden, een vervuilde luchtfilter, motorproblemen of slechte rijgewoonten. Regelmatig onderhoud helpt om de brandstofefficiëntie te behouden.",
      "ar": "يمكن أن يكون زيادة استهلاك الوقود ناتجًا عن ضغط الإطارات المنخفض، أو فلتر هواء متسخ، أو مشاكل في المحرك، أو عادات قيادة سيئة. يساعد الصيانة المنتظمة في الحفاظ على كفاءة الوقود."
    },
    "subject": "Vehicle Knowledge"
  },
  {
    "id": "real-2025-01-20-vk5",
    "text": {
      "en": "What does an ABS (Anti-lock Braking System) do?",
      "nl": "Wat doet een ABS (Antiblokkeersysteem)?",
      "ar": "ماذا يفعل نظام ABS (نظام منع انغلاق المكابح)؟"
    },
    "options": [
      {
        "id": "real-2025-01-20-vk5o1",
        "text": {
          "en": "Prevents wheels from locking during hard braking",
          "nl": "Voorkomt dat de wielen blokkeren tijdens hard remmen",
          "ar": "يمنع العجلات من الانغلاق أثناء الكبح القوي"
        }
      },
      {
        "id": "real-2025-01-20-vk5o2",
        "text": {
          "en": "Increases braking distance",
          "nl": "Verhoogt de remweg",
          "ar": "يزيد من مسافة الكبح"
        }
      },
      {
        "id": "real-2025-01-20-vk5o3",
        "text": {
          "en": "Only works in wet conditions",
          "nl": "Werkt alleen in natte omstandigheden",
          "ar": "يعمل فقط في الظروف الرطبة"
        }
      }
    ],
    "correctAnswerId": "real-2025-01-20-vk5o1",
    "explanation": {
      "en": "ABS (Anti-lock Braking System) prevents the wheels from locking during hard braking, allowing you to maintain steering control and reducing the risk of skidding.",
      "nl": "ABS (Antiblokkeersysteem) voorkomt dat de wielen blokkeren tijdens hard remmen, zodat je de stuurcontrole kunt behouden en het risico op slippen vermindert.",
      "ar": "يمنع نظام ABS (نظام منع انغلاق المكابح) العجلات من الانغلاق أثناء الكبح القوي، مما يسمح لك بالحفاظ على السيطرة على التوجيه وتقليل خطر الانزلاق."
    },
    "subject": "Vehicle Knowledge"
  },
  {
    "id": "real-2025-02-01-img1",
    "text": {
      "en": "What action must you take when you see this sign?",
      "nl": "Welke actie moet je ondernemen wanneer je dit bord ziet?",
      "ar": "ما الإجراء الذي يجب أن تتخذه عندما ترى هذه العلامة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img1o1",
        "text": {
          "en": "Follow the direction indicated by the sign",
          "nl": "Volg de richting die door het bord wordt aangegeven",
          "ar": "اتبع الاتجاه المشار إليه بواسطة العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img1o2",
        "text": {
          "en": "Ignore the sign if no other traffic is present",
          "nl": "Negeer het bord als er geen ander verkeer aanwezig is",
          "ar": "تجاهل العلامة إذا لم يكن هناك حركة مرور أخرى"
        }
      },
      {
        "id": "real-2025-02-01-img1o3",
        "text": {
          "en": "Stop and wait for further instructions",
          "nl": "Stop en wacht op verdere instructies",
          "ar": "توقف وانتظر للحصول على مزيد من التعليمات"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img1o1",
    "explanation": {
      "en": "This is a mandatory sign (blue circular sign). You must follow the direction or instruction indicated by the sign. Mandatory signs are legally binding and must be obeyed.",
      "nl": "Dit is een verplicht bord (blauw rond bord). U moet de richting of instructie volgen die door het bord wordt aangegeven. Verplichte borden zijn wettelijk bindend en moeten worden nageleefd.",
      "ar": "هذه علامة إلزامية (علامة دائرية زرقاء). يجب عليك اتباع الاتجاه أو التعليمات المشار إليها بواسطة العلامة. العلامات الإلزامية ملزمة قانونًا ويجب الالتزام بها."
    },
    "subject": "Mandatory Signs",
    "imageHint": "Mandatory sign indicating required direction or action"
  },
  {
    "id": "real-2025-02-01-img2",
    "text": {
      "en": "This sign indicates a compulsory route. Who must use it?",
      "nl": "Dit bord geeft een verplichte route aan. Wie moet deze gebruiken?",
      "ar": "تشير هذه العلامة إلى مسار إلزامي. من يجب أن يستخدمه؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img2o1",
        "text": {
          "en": "Only the vehicle type shown on the sign",
          "nl": "Alleen het voertuigtype dat op het bord staat",
          "ar": "فقط نوع المركبة المعروض على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img2o2",
        "text": {
          "en": "All vehicles",
          "nl": "Alle voertuigen",
          "ar": "جميع المركبات"
        }
      },
      {
        "id": "real-2025-02-01-img2o3",
        "text": {
          "en": "Only heavy vehicles",
          "nl": "Alleen zware voertuigen",
          "ar": "فقط المركبات الثقيلة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img2o1",
    "explanation": {
      "en": "This mandatory sign shows a specific vehicle type. Only vehicles of that type must use this route. Other vehicles may use alternative routes if available.",
      "nl": "Dit verplichte bord toont een specifiek voertuigtype. Alleen voertuigen van dat type moeten deze route gebruiken. Andere voertuigen mogen alternatieve routes gebruiken als die beschikbaar zijn.",
      "ar": "تظهر هذه العلامة الإلزامية نوعًا معينًا من المركبات. يجب أن تستخدم هذه المسار فقط المركبات من ذلك النوع. يمكن للمركبات الأخرى استخدام طرق بديلة إذا كانت متاحة."
    },
    "subject": "Mandatory Signs",
    "imageHint": "Compulsory route sign for specific vehicle type"
  },
  {
    "id": "real-2025-02-01-img3",
    "text": {
      "en": "What does this blue circular sign require you to do?",
      "nl": "Wat vereist dit blauwe ronde bord van u?",
      "ar": "ماذا تتطلب منك هذه العلامة الدائرية الزرقاء؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img3o1",
        "text": {
          "en": "Follow the mandatory direction shown",
          "nl": "Volg de verplichte richting die wordt getoond",
          "ar": "اتبع الاتجاه الإلزامي المعروض"
        }
      },
      {
        "id": "real-2025-02-01-img3o2",
        "text": {
          "en": "Proceed with caution",
          "nl": "Ga voorzichtig verder",
          "ar": "تابع بحذر"
        }
      },
      {
        "id": "real-2025-02-01-img3o3",
        "text": {
          "en": "Stop and check for traffic",
          "nl": "Stop en controleer op verkeer",
          "ar": "توقف وتحقق من حركة المرور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img3o1",
    "explanation": {
      "en": "Blue circular signs are mandatory signs. They require you to follow the direction or action shown. These signs are legally binding under Dutch traffic law.",
      "nl": "Blauwe ronde borden zijn verplichte borden. Ze vereisen dat u de richting of actie volgt die wordt getoond. Deze borden zijn wettelijk bindend volgens de Nederlandse verkeerswet.",
      "ar": "العلامات الدائرية الزرقاء هي علامات إلزامية. تتطلب منك اتباع الاتجاه أو الإجراء المعروض. هذه العلامات ملزمة قانونًا بموجب قانون المرور الهولندي."
    },
    "subject": "Mandatory Signs",
    "imageHint": "Blue circular mandatory sign"
  },
  {
    "id": "real-2025-02-01-img4",
    "text": {
      "en": "You see this sign ahead. What must you do?",
      "nl": "U ziet dit bord voor u. Wat moet u doen?",
      "ar": "ترى هذا العلامة أمامك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img4o1",
        "text": {
          "en": "Obey the mandatory instruction shown",
          "nl": "Volg de verplichte instructie die wordt weergegeven",
          "ar": "امتثل للتعليمات الإلزامية المعروضة"
        }
      },
      {
        "id": "real-2025-02-01-img4o2",
        "text": {
          "en": "Reduce speed only",
          "nl": "Verlaag alleen de snelheid",
          "ar": "قلل السرعة فقط"
        }
      },
      {
        "id": "real-2025-02-01-img4o3",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img4o1",
    "explanation": {
      "en": "Mandatory signs (blue circular) require you to follow the instruction shown. These are not optional - they are legally binding requirements.",
      "nl": "Verplichte borden (blauw rond) vereisen dat u de weergegeven instructie volgt. Dit is niet optioneel - het zijn wettelijk bindende vereisten.",
      "ar": "تتطلب العلامات الإلزامية (الدائرية الزرقاء) منك اتباع التعليمات المعروضة. هذه ليست اختيارية - إنها متطلبات ملزمة قانونًا."
    },
    "subject": "Mandatory Signs",
    "imageHint": "Mandatory instruction sign"
  },
  {
    "id": "real-2025-02-01-img5",
    "text": {
      "en": "This sign indicates a compulsory route. What does this mean?",
      "nl": "Dit bord geeft een verplichte route aan. Wat betekent dit?",
      "ar": "تشير هذه العلامة إلى مسار إلزامي. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img5o1",
        "text": {
          "en": "You must use this route if it applies to your vehicle type",
          "nl": "U moet deze route gebruiken als deze van toepassing is op uw voertuigtype",
          "ar": "يجب عليك استخدام هذا المسار إذا كان ينطبق على نوع مركبتك"
        }
      },
      {
        "id": "real-2025-02-01-img5o2",
        "text": {
          "en": "This route is recommended but optional",
          "nl": "Deze route is aanbevolen maar optioneel",
          "ar": "هذا المسار موصى به ولكنه اختياري"
        }
      },
      {
        "id": "real-2025-02-01-img5o3",
        "text": {
          "en": "This route is for emergency vehicles only",
          "nl": "Deze route is alleen voor hulpdiensten",
          "ar": "هذا المسار مخصص فقط لمركبات الطوارئ"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img5o1",
    "explanation": {
      "en": "A compulsory route sign means you must use this route if your vehicle type matches the sign. It is not optional - it is a legal requirement.",
      "nl": "Een bord voor een verplichte route betekent dat u deze route moet gebruiken als uw voertuigtype overeenkomt met het bord. Het is niet optioneel - het is een wettelijke vereiste.",
      "ar": "تعني علامة المسار الإلزامي أنه يجب عليك استخدام هذا المسار إذا كان نوع مركبتك يتطابق مع العلامة. ليس اختياريًا - إنه متطلب قانوني."
    },
    "subject": "Mandatory Signs",
    "imageHint": "Compulsory route mandatory sign"
  },
  {
    "id": "real-2025-02-01-img11",
    "text": {
      "en": "What does this red circular sign prohibit?",
      "nl": "Wat verbiedt dit rode ronde bord?",
      "ar": "ماذا تحظر هذه العلامة الدائرية الحمراء؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img11o1",
        "text": {
          "en": "The action or vehicle type shown on the sign",
          "nl": "De actie of het voertuigtype dat op het bord staat",
          "ar": "الإجراء أو نوع المركبة المعروض على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img11o2",
        "text": {
          "en": "All vehicles",
          "nl": "Alle voertuigen",
          "ar": "جميع المركبات"
        }
      },
      {
        "id": "real-2025-02-01-img11o3",
        "text": {
          "en": "Only heavy vehicles",
          "nl": "Alleen zware voertuigen",
          "ar": "فقط المركبات الثقيلة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img11o1",
    "explanation": {
      "en": "Red circular signs are prohibitory signs. They prohibit the specific action or vehicle type shown on the sign. The prohibition applies only to what is depicted.",
      "nl": "Rode ronde borden zijn verbodsborden. Ze verbieden de specifieke actie of het voertuigtype dat op het bord staat. Het verbod geldt alleen voor wat is afgebeeld.",
      "ar": "تشير العلامات الدائرية الحمراء إلى علامات تحظر. إنها تحظر الإجراء المحدد أو نوع المركبة المعروض على العلامة. ينطبق الحظر فقط على ما هو موضح."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-1.jpg",
    "imageHint": "Red circular prohibitory sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img12",
    "text": {
      "en": "You see this sign. What restriction does it impose?",
      "nl": "U ziet dit bord. Welke beperking legt het op?",
      "ar": "ترى هذه العلامة. ما القيود التي تفرضها؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img12o1",
        "text": {
          "en": "The specific restriction shown on the sign",
          "nl": "De specifieke beperking die op het bord staat",
          "ar": "القيود المحددة الموضحة على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img12o2",
        "text": {
          "en": "No vehicles allowed",
          "nl": "Geen voertuigen toegestaan",
          "ar": "لا يُسمح بالسيارات"
        }
      },
      {
        "id": "real-2025-02-01-img12o3",
        "text": {
          "en": "Speed limit only",
          "nl": "Alleen snelheidslimiet",
          "ar": "حد السرعة فقط"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img12o1",
    "explanation": {
      "en": "Prohibitory signs (red circular) impose the specific restriction shown. You must identify what is prohibited by looking at the symbol or text on the sign.",
      "nl": "Verbodsborden (rood rond) leggen de specifieke beperking op die wordt weergegeven. U moet identificeren wat is verboden door naar het symbool of de tekst op het bord te kijken.",
      "ar": "تفرض علامات الحظر (الدائرية الحمراء) القيود المحددة المعروضة. يجب عليك تحديد ما هو محظور من خلال النظر إلى الرمز أو النص الموجود على العلامة."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-2.jpg",
    "imageHint": "Prohibitory restriction sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img13",
    "text": {
      "en": "This red circular sign with a diagonal line means what?",
      "nl": "Wat betekent dit rode ronde bord met een diagonale lijn?",
      "ar": "ماذا يعني هذا العلامة الدائرية الحمراء مع خط مائل؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img13o1",
        "text": {
          "en": "The action or vehicle shown is prohibited",
          "nl": "De actie of het voertuig dat wordt weergegeven is verboden",
          "ar": "الإجراء أو السيارة المعروضة محظورة"
        }
      },
      {
        "id": "real-2025-02-01-img13o2",
        "text": {
          "en": "The action shown is recommended",
          "nl": "De getoonde actie is aanbevolen",
          "ar": "الإجراء المعروض موصى به"
        }
      },
      {
        "id": "real-2025-02-01-img13o3",
        "text": {
          "en": "The action shown is optional",
          "nl": "De getoonde actie is optioneel",
          "ar": "الإجراء المعروض اختياري"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img13o1",
    "explanation": {
      "en": "A red circular sign with a diagonal line is a prohibitory sign. It means the action or vehicle type shown is prohibited. You must not do what the sign prohibits.",
      "nl": "Een rood rond bord met een diagonale lijn is een verbodsbord. Het betekent dat de actie of het voertuigtype dat wordt weergegeven verboden is. Je moet niet doen wat het bord verbiedt.",
      "ar": "تشير العلامة الدائرية الحمراء مع خط مائل إلى علامة ممنوعة. وهذا يعني أن الإجراء أو نوع السيارة المعروض محظور. يجب عليك عدم القيام بما تحظره العلامة."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-3.jpg",
    "imageHint": "Prohibitory sign with diagonal line",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img14",
    "text": {
      "en": "What does this prohibitory sign indicate?",
      "nl": "Wat geeft dit verbodsbord aan?",
      "ar": "ماذا تشير هذه العلامة الممنوعة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img14o1",
        "text": {
          "en": "A specific vehicle type or action is not allowed",
          "nl": "Een specifiek voertuigtype of actie is niet toegestaan",
          "ar": "نوع السيارة المحدد أو الإجراء غير مسموح به"
        }
      },
      {
        "id": "real-2025-02-01-img14o2",
        "text": {
          "en": "All vehicles are prohibited",
          "nl": "Alle voertuigen zijn verboden",
          "ar": "جميع المركبات محظورة"
        }
      },
      {
        "id": "real-2025-02-01-img14o3",
        "text": {
          "en": "Only parking is prohibited",
          "nl": "Alleen parkeren is verboden",
          "ar": "ممنوع فقط الوقوف"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img14o1",
    "explanation": {
      "en": "Prohibitory signs indicate that a specific vehicle type or action shown on the sign is not allowed. The prohibition is specific to what is depicted, not a general ban.",
      "nl": "Verbodsborden geven aan dat een specifiek voertuigtype of actie dat op het bord staat niet is toegestaan. Het verbod is specifiek voor wat wordt afgebeeld, niet een algemeen verbod.",
      "ar": "تشير علامات المنع إلى أن نوع السيارة المحدد أو الإجراء المعروض على العلامة غير مسموح به. الحظر محدد لما هو موضح، وليس حظراً عاماً."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-4.jpg",
    "imageHint": "Specific prohibitory sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img15",
    "text": {
      "en": "You see this sign. What must you not do?",
      "nl": "Je ziet dit bord. Wat mag je niet doen?",
      "ar": "ترى هذه العلامة. ماذا يجب عليك ألا تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img15o1",
        "text": {
          "en": "The action shown on the sign",
          "nl": "De actie die op het bord staat",
          "ar": "الإجراء المعروض على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img15o2",
        "text": {
          "en": "Drive on this road",
          "nl": "Rijd op deze weg",
          "ar": "قد على هذه الطريق"
        }
      },
      {
        "id": "real-2025-02-01-img15o3",
        "text": {
          "en": "Park on this road",
          "nl": "Parkeer op deze weg",
          "ar": "اركن على هذه الطريق"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img15o1",
    "explanation": {
      "en": "Prohibitory signs tell you what you must not do. Look at the symbol or text on the sign to identify the specific action that is prohibited.",
      "nl": "Verbodsborden vertellen je wat je niet mag doen. Kijk naar het symbool of de tekst op het bord om de specifieke actie te identificeren die verboden is.",
      "ar": "علامات المنع تخبرك بما يجب عليك عدم فعله. انظر إلى الرمز أو النص على العلامة لتحديد الإجراء المحدد الذي تم منعه."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-5.jpg",
    "imageHint": "Prohibitory action sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img16",
    "text": {
      "en": "This red circular sign indicates what type of restriction?",
      "nl": "Dit rode ronde bord geeft aan welk type beperking?",
      "ar": "تشير هذه العلامة الحمراء الدائرية إلى نوع القيود؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img16o1",
        "text": {
          "en": "A prohibition on the action or vehicle shown",
          "nl": "Een verbod op de actie of het voertuig dat wordt getoond",
          "ar": "حظر على الإجراء أو المركبة المعروضة"
        }
      },
      {
        "id": "real-2025-02-01-img16o2",
        "text": {
          "en": "A speed limit",
          "nl": "Een snelheidslimiet",
          "ar": "حد السرعة"
        }
      },
      {
        "id": "real-2025-02-01-img16o3",
        "text": {
          "en": "A recommendation",
          "nl": "Een aanbeveling",
          "ar": "توصية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img16o1",
    "explanation": {
      "en": "Red circular signs are prohibitory signs. They indicate a prohibition on the specific action or vehicle type shown. These are legally binding restrictions.",
      "nl": "Rode ronde borden zijn verbodsborden. Ze geven een verbod aan op de specifieke actie of het type voertuig dat wordt getoond. Dit zijn wettelijk bindende beperkingen.",
      "ar": "العلامات الحمراء الدائرية هي علامات منع. إنها تشير إلى حظر الإجراء المحدد أو نوع المركبة المعروض. هذه قيود ملزمة قانونًا."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory-2/q-prohibit2-1.jpg",
    "imageHint": "Red circular prohibitory sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img17",
    "text": {
      "en": "What does this prohibitory sign mean for your driving?",
      "nl": "Wat betekent dit verbodsbord voor jouw rijgedrag?",
      "ar": "ماذا تعني هذه العلامة الممنوعة بالنسبة لقيادتك؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img17o1",
        "text": {
          "en": "You must not do what the sign prohibits",
          "nl": "Je mag niet doen wat het bord verbiedt",
          "ar": "يجب عليك عدم القيام بما تحظره العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img17o2",
        "text": {
          "en": "You should be cautious",
          "nl": "Je moet voorzichtig zijn",
          "ar": "يجب أن تكون حذرًا"
        }
      },
      {
        "id": "real-2025-02-01-img17o3",
        "text": {
          "en": "The restriction is optional",
          "nl": "De beperking is optioneel",
          "ar": "القيود اختيارية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img17o1",
    "explanation": {
      "en": "Prohibitory signs are legally binding. You must not do what the sign prohibits. Violating prohibitory signs can result in fines and penalty points.",
      "nl": "Verbodsborden zijn wettelijk bindend. Je mag niet doen wat het bord verbiedt. Het overtreden van verbodsborden kan leiden tot boetes en strafpunten.",
      "ar": "علامات المنع ملزمة قانونًا. يجب عليك عدم القيام بما تحظره العلامة. يمكن أن يؤدي انتهاك علامات المنع إلى غرامات ونقاط جزاء."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory-2/q-prohibit2-3.jpg",
    "imageHint": "Prohibitory restriction sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img18",
    "text": {
      "en": "This sign shows a prohibition. What must you do?",
      "nl": "Dit bord toont een verbod. Wat moet je doen?",
      "ar": "هذا الإشارة تظهر حظراً. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img18o1",
        "text": {
          "en": "Obey the prohibition shown on the sign",
          "nl": "Volg het verbod dat op het bord staat",
          "ar": "امتثل للحظر الموضح على الإشارة"
        }
      },
      {
        "id": "real-2025-02-01-img18o2",
        "text": {
          "en": "Continue if safe to do so",
          "nl": "Ga door als het veilig is om dat te doen",
          "ar": "استمر إذا كان ذلك آمناً"
        }
      },
      {
        "id": "real-2025-02-01-img18o3",
        "text": {
          "en": "Ignore the sign if no enforcement is present",
          "nl": "Negeer het bord als er geen handhaving aanwezig is",
          "ar": "تجاهل الإشارة إذا لم يكن هناك إنفاذ"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img18o1",
    "explanation": {
      "en": "Prohibitory signs must always be obeyed, regardless of whether enforcement is present. They are legal requirements, not suggestions.",
      "nl": "Verbodsborden moeten altijd worden nageleefd, ongeacht of er handhaving aanwezig is. Het zijn wettelijke vereisten, geen suggesties.",
      "ar": "يجب دائماً الامتثال لعلامات الحظر، بغض النظر عما إذا كانت هناك إنفاذ. إنها متطلبات قانونية، وليست اقتراحات."
    },
    "subject": "Prohibitory Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory-2/q-prohibit2-4.jpg",
    "imageHint": "Prohibition sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img19",
    "text": {
      "en": "What does this triangular sign warn you about?",
      "nl": "Waar waarschuwt dit driehoekige bord je voor?",
      "ar": "ماذا تحذرك هذه الإشارة المثلثية؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img19o1",
        "text": {
          "en": "A potential hazard ahead shown on the sign",
          "nl": "Een potentieel gevaar voor je dat op het bord staat",
          "ar": "خطر محتمل أمامك موضح على الإشارة"
        }
      },
      {
        "id": "real-2025-02-01-img19o2",
        "text": {
          "en": "A speed limit ahead",
          "nl": "Een snelheidslimiet voor je",
          "ar": "حد السرعة أمامك"
        }
      },
      {
        "id": "real-2025-02-01-img19o3",
        "text": {
          "en": "A mandatory direction",
          "nl": "Een verplichte richting",
          "ar": "اتجاه إلزامي"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img19o1",
    "explanation": {
      "en": "Triangular signs with red borders are warning signs. They warn you about potential hazards ahead. Look at the symbol on the sign to identify the specific hazard.",
      "nl": "Driehoekige borden met rode randen zijn waarschuwingsborden. Ze waarschuwen je voor mogelijke gevaren voor je. Kijk naar het symbool op het bord om het specifieke gevaar te identificeren.",
      "ar": "العلامات المثلثية ذات الحدود الحمراء هي علامات تحذيرية. إنها تحذرك من المخاطر المحتملة في الأمام. انظر إلى الرمز على الإشارة لتحديد الخطر المحدد."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-6.jpg",
    "imageHint": "Triangular warning sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img20",
    "text": {
      "en": "You see this warning sign. What should you do?",
      "nl": "Je ziet dit waarschuwingsbord. Wat moet je doen?",
      "ar": "ترى هذه الإشارة التحذيرية. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img20o1",
        "text": {
          "en": "Be prepared for the hazard shown ahead",
          "nl": "Wees voorbereid op het gevaar dat voor je staat",
          "ar": "كن مستعدًا للخطر المعروض أمامك"
        }
      },
      {
        "id": "real-2025-02-01-img20o2",
        "text": {
          "en": "Stop immediately",
          "nl": "Stop onmiddellijk",
          "ar": "توقف على الفور"
        }
      },
      {
        "id": "real-2025-02-01-img20o3",
        "text": {
          "en": "Reduce speed to 30 km/h",
          "nl": "Snelheid terugbrengen naar 30 km/u",
          "ar": "قلل السرعة إلى 30 كم/ساعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img20o1",
    "explanation": {
      "en": "Warning signs alert you to potential hazards ahead. You should be prepared for the hazard shown, adjust your speed if necessary, and be ready to take appropriate action.",
      "nl": "Waarschuwingsborden waarschuwen je voor mogelijke gevaren voor je. Je moet voorbereid zijn op het gevaar dat wordt getoond, je snelheid indien nodig aanpassen en klaar zijn om passende actie te ondernemen.",
      "ar": "تحذيرات الإشارات تنبهك إلى المخاطر المحتملة في الأمام. يجب أن تكون مستعدًا للخطر المعروض، وضبط سرعتك إذا لزم الأمر، وأن تكون جاهزًا لاتخاذ الإجراء المناسب."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-7.jpg",
    "imageHint": "Warning sign for hazard ahead",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img21",
    "text": {
      "en": "This triangular sign with a red border indicates what?",
      "nl": "Dit driehoekige bord met een rode rand geeft aan wat?",
      "ar": "ماذا يشير هذا العلامة مثلثية الشكل ذات الحدود الحمراء؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img21o1",
        "text": {
          "en": "A warning about a hazard ahead",
          "nl": "Een waarschuwing voor een gevaar voor je",
          "ar": "تحذير من خطر قادم"
        }
      },
      {
        "id": "real-2025-02-01-img21o2",
        "text": {
          "en": "A prohibition",
          "nl": "Een verbod",
          "ar": "منع"
        }
      },
      {
        "id": "real-2025-02-01-img21o3",
        "text": {
          "en": "A mandatory direction",
          "nl": "Een verplichte richting",
          "ar": "اتجاه إلزامي"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img21o1",
    "explanation": {
      "en": "Triangular signs with red borders are warning signs. They warn you about potential hazards ahead. The shape and color help you identify the sign type quickly.",
      "nl": "Driehoekige borden met rode randen zijn waarschuwingsborden. Ze waarschuwen je voor mogelijke gevaren die komen gaan. De vorm en kleur helpen je om het type bord snel te identificeren.",
      "ar": "العلامات مثلثية الشكل ذات الحدود الحمراء هي علامات تحذيرية. إنها تحذرك من المخاطر المحتملة في المستقبل. تساعدك الشكل واللون في التعرف على نوع العلامة بسرعة."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-8.jpg",
    "imageHint": "Triangular warning sign with red border",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img22",
    "text": {
      "en": "What type of information does this sign provide?",
      "nl": "Wat voor soort informatie geeft dit bord?",
      "ar": "ما نوع المعلومات التي يوفرها هذا العلامة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img22o1",
        "text": {
          "en": "A warning about a potential hazard",
          "nl": "Een waarschuwing voor een potentieel gevaar",
          "ar": "تحذير من خطر محتمل"
        }
      },
      {
        "id": "real-2025-02-01-img22o2",
        "text": {
          "en": "A speed limit",
          "nl": "Een snelheidslimiet",
          "ar": "حد السرعة"
        }
      },
      {
        "id": "real-2025-02-01-img22o3",
        "text": {
          "en": "A parking restriction",
          "nl": "Een parkeerbeperking",
          "ar": "قيود على الوقوف"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img22o1",
    "explanation": {
      "en": "Warning signs provide information about potential hazards ahead. They help you prepare for and respond to dangerous situations on the road.",
      "nl": "Waarschuwingsborden geven informatie over mogelijke gevaren die voor je liggen. Ze helpen je om je voor te bereiden op en te reageren op gevaarlijke situaties op de weg.",
      "ar": "توفر علامات التحذير معلومات حول المخاطر المحتملة القادمة. إنها تساعدك على الاستعداد والاستجابة للمواقف الخطرة على الطريق."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-9.jpg",
    "imageHint": "Warning sign providing hazard information",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img23",
    "text": {
      "en": "You see this warning sign ahead. How should you respond?",
      "nl": "Je ziet dit waarschuwingsbord voor je. Hoe moet je reageren?",
      "ar": "ترى هذه العلامة التحذيرية أمامك. كيف يجب أن تستجيب؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img23o1",
        "text": {
          "en": "Be alert and prepared for the hazard shown",
          "nl": "Wees alert en voorbereid op het getoonde gevaar",
          "ar": "كن في حالة تأهب ومستعد للخطر المعروض"
        }
      },
      {
        "id": "real-2025-02-01-img23o2",
        "text": {
          "en": "Stop immediately",
          "nl": "Stop onmiddellijk",
          "ar": "توقف على الفور"
        }
      },
      {
        "id": "real-2025-02-01-img23o3",
        "text": {
          "en": "Increase speed to pass quickly",
          "nl": "Verhoog de snelheid om snel te passeren",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img23o1",
    "explanation": {
      "en": "When you see a warning sign, you should be alert and prepared for the hazard shown. Adjust your speed and driving behavior accordingly, but you do not need to stop unless the hazard requires it.",
      "nl": "Wanneer je een waarschuwingsbord ziet, moet je alert zijn en voorbereid op het getoonde gevaar. Pas je snelheid en rijgedrag dienovereenkomstig aan, maar je hoeft niet te stoppen tenzij het gevaar dat vereist.",
      "ar": "عندما ترى علامة تحذيرية، يجب أن تكون في حالة تأهب ومستعد للخطر المعروض. قم بتعديل سرعتك وسلوكك في القيادة وفقًا لذلك، ولكن لا تحتاج إلى التوقف ما لم يتطلب الخطر ذلك."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-10.jpg",
    "imageHint": "Warning sign requiring alertness",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img24",
    "text": {
      "en": "What type of sign is this?",
      "nl": "Wat voor soort bord is dit?",
      "ar": "ما نوع العلامة هذه؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img24o1",
        "text": {
          "en": "Identify the sign type based on shape and color",
          "nl": "Identificeer het type verkeersbord op basis van vorm en kleur",
          "ar": "حدد نوع الإشارة بناءً على الشكل واللون"
        }
      },
      {
        "id": "real-2025-02-01-img24o2",
        "text": {
          "en": "Always a warning sign",
          "nl": "Altijd een waarschuwingsbord",
          "ar": "دائمًا ما يكون علامة تحذيرية"
        }
      },
      {
        "id": "real-2025-02-01-img24o3",
        "text": {
          "en": "Always a prohibitory sign",
          "nl": "Altijd een verbodsbord",
          "ar": "دائمًا ما يكون علامة ممنوعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img24o1",
    "explanation": {
      "en": "Sign identification requires looking at the shape, color, and symbol. Triangular with red border = warning, red circular = prohibitory, blue circular = mandatory, rectangular = information.",
      "nl": "Bordidentificatie vereist het kijken naar de vorm, kleur en symbool. Driehoekig met rode rand = waarschuwing, rode cirkel = verbod, blauwe cirkel = verplicht, rechthoekig = informatie.",
      "ar": "يتطلب تحديد العلامة النظر إلى الشكل واللون والرمز. مثلث مع حدود حمراء = تحذير، دائرة حمراء = منع، دائرة زرقاء = إلزامي، مستطيل = معلومات."
    },
    "subject": "Sign Identification",
    "imageHint": "Traffic sign requiring identification"
  },
  {
    "id": "real-2025-02-01-img25",
    "text": {
      "en": "How do you identify what this sign means?",
      "nl": "Hoe identificeer je wat dit bord betekent?",
      "ar": "كيف تحدد ما تعنيه هذه الإشارة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img25o1",
        "text": {
          "en": "By its shape, color, and symbol",
          "nl": "Aan de hand van zijn vorm, kleur en symbool",
          "ar": "من خلال شكله ولونه ورمزه"
        }
      },
      {
        "id": "real-2025-02-01-img25o2",
        "text": {
          "en": "By its size only",
          "nl": "Alleen op basis van de grootte",
          "ar": "فقط بناءً على الحجم"
        }
      },
      {
        "id": "real-2025-02-01-img25o3",
        "text": {
          "en": "By its location only",
          "nl": "Alleen op basis van de locatie",
          "ar": "فقط بناءً على الموقع"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img25o1",
    "explanation": {
      "en": "Sign identification is based on shape, color, and symbol. These visual elements tell you the sign type and its meaning. Learn the standard shapes and colors for each sign category.",
      "nl": "De identificatie van verkeersborden is gebaseerd op vorm, kleur en symbool. Deze visuele elementen vertellen je het type bord en de betekenis ervan. Leer de standaardvormen en -kleuren voor elke bordcategorie.",
      "ar": "تستند هوية الإشارات إلى الشكل واللون والرمز. تخبرك هذه العناصر المرئية بنوع الإشارة ومعناها. تعلم الأشكال والألوان القياسية لكل فئة من الإشارات."
    },
    "subject": "Sign Identification",
    "imageHint": "Sign requiring identification by visual elements"
  },
  {
    "id": "real-2025-02-01-img26",
    "text": {
      "en": "This sign can be identified by what characteristics?",
      "nl": "Dit bord kan worden geïdentificeerd aan de hand van welke kenmerken?",
      "ar": "يمكن تحديد هذه الإشارة من خلال أي خصائص؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img26o1",
        "text": {
          "en": "Shape, color, and symbol design",
          "nl": "Vorm, kleur en symboolontwerp",
          "ar": "شكل ولون وتصميم الرمز"
        }
      },
      {
        "id": "real-2025-02-01-img26o2",
        "text": {
          "en": "Height above ground",
          "nl": "Hoogte boven de grond",
          "ar": "الارتفاع عن الأرض"
        }
      },
      {
        "id": "real-2025-02-01-img26o3",
        "text": {
          "en": "Material it is made from",
          "nl": "Materiaal waarvan het is gemaakt",
          "ar": "المادة المصنوعة منها"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img26o1",
    "explanation": {
      "en": "Traffic signs are identified by their shape, color, and symbol design. These standardized characteristics allow drivers to quickly recognize sign types and meanings.",
      "nl": "Verkeersborden worden geïdentificeerd aan de hand van hun vorm, kleur en symboolontwerp. Deze gestandaardiseerde kenmerken stellen bestuurders in staat om snel bordtypes en betekenissen te herkennen.",
      "ar": "تُحدد إشارات المرور من خلال شكلها ولونها وتصميم رمزها. تتيح هذه الخصائص القياسية للسائقين التعرف بسرعة على أنواع الإشارات ومعانيها."
    },
    "subject": "Sign Identification",
    "imageHint": "Sign with identifiable characteristics"
  },
  {
    "id": "real-2025-02-01-img27",
    "text": {
      "en": "What is the primary way to identify this sign's meaning?",
      "nl": "Wat is de belangrijkste manier om de betekenis van dit bord te identificeren?",
      "ar": "ما هي الطريقة الأساسية لتحديد معنى هذه الإشارة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img27o1",
        "text": {
          "en": "Analyze its visual characteristics (shape, color, symbol)",
          "nl": "Analyseer de visuele kenmerken (vorm, kleur, symbool)",
          "ar": "قم بتحليل خصائصها البصرية (الشكل، اللون، الرمز)"
        }
      },
      {
        "id": "real-2025-02-01-img27o2",
        "text": {
          "en": "Read any text on the sign",
          "nl": "Lees eventuele tekst op het bord",
          "ar": "اقرأ أي نص على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img27o3",
        "text": {
          "en": "Ask other drivers",
          "nl": "Vraag andere bestuurders",
          "ar": "اسأل السائقين الآخرين"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img27o1",
    "explanation": {
      "en": "The primary way to identify a sign is by analyzing its visual characteristics: shape (triangular, circular, rectangular), color (red, blue, yellow, white), and symbol design.",
      "nl": "De belangrijkste manier om een bord te identificeren is door de visuele kenmerken te analyseren: vorm (driehoekig, rond, rechthoekig), kleur (rood, blauw, geel, wit) en symboolontwerp.",
      "ar": "الطريقة الأساسية لتحديد علامة هي من خلال تحليل خصائصها البصرية: الشكل (مثلث، دائري، مستطيل)، اللون (أحمر، أزرق، أصفر، أبيض)، وتصميم الرمز."
    },
    "subject": "Sign Identification",
    "imageHint": "Sign requiring visual analysis"
  },
  {
    "id": "real-2025-02-01-img28",
    "text": {
      "en": "To understand this sign, you should look at what?",
      "nl": "Om dit bord te begrijpen, moet je naar wat kijken?",
      "ar": "لفهم هذه العلامة، يجب أن تنظر إلى ماذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img28o1",
        "text": {
          "en": "The sign's shape, color, and symbol",
          "nl": "De vorm, kleur en het symbool van het bord",
          "ar": "شكل العلامة ولونها ورمزها"
        }
      },
      {
        "id": "real-2025-02-01-img28o2",
        "text": {
          "en": "The sign's position on the road",
          "nl": "De positie van het bord op de weg",
          "ar": "موضع العلامة على الطريق"
        }
      },
      {
        "id": "real-2025-02-01-img28o3",
        "text": {
          "en": "The time of day",
          "nl": "Het tijdstip van de dag",
          "ar": "وقت اليوم"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img28o1",
    "explanation": {
      "en": "To understand a traffic sign, focus on its shape, color, and symbol. These three elements together tell you the sign type and its specific meaning.",
      "nl": "Om een verkeersbord te begrijpen, concentreer je je op de vorm, kleur en het symbool. Deze drie elementen samen vertellen je het type bord en de specifieke betekenis.",
      "ar": "لفهم علامة المرور، ركز على شكلها ولونها ورمزها. هذه العناصر الثلاثة معًا تخبرك بنوع العلامة ومعناها المحدد."
    },
    "subject": "Sign Identification",
    "imageHint": "Sign requiring shape, color, symbol analysis"
  },
  {
    "id": "real-2025-02-01-img29",
    "text": {
      "en": "What type of information does this sign provide?",
      "nl": "Wat voor soort informatie geeft dit bord?",
      "ar": "ما نوع المعلومات التي يوفرها هذا العلامة؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img29o1",
        "text": {
          "en": "Road information or direction",
          "nl": "Weginformatie of richting",
          "ar": "معلومات الطريق أو الاتجاه"
        }
      },
      {
        "id": "real-2025-02-01-img29o2",
        "text": {
          "en": "A prohibition",
          "nl": "Een verbod",
          "ar": "منع"
        }
      },
      {
        "id": "real-2025-02-01-img29o3",
        "text": {
          "en": "A warning",
          "nl": "Een waarschuwing",
          "ar": "تحذير"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img29o1",
    "explanation": {
      "en": "Rectangular signs typically provide road information, directions, or guidance. They inform you about services, routes, or road conditions rather than prohibiting or warning.",
      "nl": "Rechthoekige borden geven doorgaans informatie over de weg, richtingen of begeleiding. Ze informeren je over diensten, routes of wegomstandigheden in plaats van te verbieden of te waarschuwen.",
      "ar": "تقدم العلامات المستطيلة عادةً معلومات عن الطريق، الاتجاهات، أو الإرشادات. إنها تخبرك عن الخدمات، والمسارات، أو ظروف الطريق بدلاً من الحظر أو التحذير."
    },
    "subject": "Road Information",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-1.jpg",
    "imageHint": "Rectangular information sign",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-01-img30",
    "text": {
      "en": "This sign provides information about what?",
      "nl": "Dit bord geeft informatie over wat?",
      "ar": "توفر هذه العلامة معلومات عن ماذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-01-img30o1",
        "text": {
          "en": "Road conditions, services, or directions shown on the sign",
          "nl": "Wegomstandigheden, diensten of richtingen weergegeven op het bord",
          "ar": "حالات الطريق أو الخدمات أو الاتجاهات الموضحة على العلامة"
        }
      },
      {
        "id": "real-2025-02-01-img30o2",
        "text": {
          "en": "Speed limits only",
          "nl": "Alleen snelheidslimieten",
          "ar": "حدود السرعة فقط"
        }
      },
      {
        "id": "real-2025-02-01-img30o3",
        "text": {
          "en": "Prohibitions only",
          "nl": "Alleen verboden",
          "ar": "ممنوعات فقط"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-01-img30o1",
    "explanation": {
      "en": "Information signs provide details about road conditions, available services, directions, or guidance. They help you navigate and make informed decisions while driving.",
      "nl": "Informatieborden geven details over wegomstandigheden, beschikbare diensten, richtingen of begeleiding. Ze helpen je navigeren en weloverwogen beslissingen te nemen tijdens het rijden.",
      "ar": "توفر علامات المعلومات تفاصيل حول ظروف الطريق، والخدمات المتاحة، والاتجاهات، أو الإرشادات. إنها تساعدك على التنقل واتخاذ قرارات مستنيرة أثناء القيادة."
    },
    "subject": "Road Information",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/road-info/q-park-lane-2.jpg",
    "imageHint": "Information sign about road conditions or services",
    "questionType": "hotspot"
  },
  {
    "id": "real-2025-02-05-sl1",
    "text": {
      "en": "You are driving in a built-up area. What is the default speed limit?",
      "nl": "Je rijdt in een bebouwde kom. Wat is de standaard snelheidslimiet?",
      "ar": "أنت تقود في منطقة مبنية. ما هو حد السرعة الافتراضي؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl1o1",
        "text": {
          "en": "50 km/h",
          "nl": "50 km/u",
          "ar": "50 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl1o2",
        "text": {
          "en": "30 km/h",
          "nl": "30 km/u",
          "ar": "30 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl1o3",
        "text": {
          "en": "60 km/h",
          "nl": "60 km/u",
          "ar": "60 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl1o1",
    "explanation": {
      "en": "In built-up areas (indicated by built-up area signs), the default speed limit is 50 km/h unless otherwise indicated by signs.",
      "nl": "In bebouwde kommen (aangegeven door borden voor bebouwde kom) is de standaard snelheidslimiet 50 km/u, tenzij anders aangegeven door borden.",
      "ar": "في المناطق المبنية (المشار إليها بعلامات المناطق المبنية)، حد السرعة الافتراضي هو 50 كم/س ما لم يُشار إلى خلاف ذلك بواسطة علامات."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl2",
    "text": {
      "en": "You are driving in a residential area with a 30 km/h zone sign. What is the speed limit?",
      "nl": "Je rijdt in een woonwijk met een bord voor een 30 km/u zone. Wat is de snelheidslimiet?",
      "ar": "أنت تقود في منطقة سكنية مع علامة منطقة 30 كم/س. ما هو حد السرعة؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl2o1",
        "text": {
          "en": "30 km/h",
          "nl": "30 km/u",
          "ar": "30 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl2o2",
        "text": {
          "en": "50 km/h",
          "nl": "50 km/u",
          "ar": "50 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl2o3",
        "text": {
          "en": "40 km/h",
          "nl": "40 km/u",
          "ar": "40 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl2o1",
    "explanation": {
      "en": "When you see a 30 km/h zone sign, the speed limit is 30 km/h. This applies to the entire zone until you see an end of zone sign.",
      "nl": "Wanneer je een bord voor een 30 km/u zone ziet, is de snelheidslimiet 30 km/u. Dit geldt voor de gehele zone totdat je een einde van de zone bord ziet.",
      "ar": "عندما ترى علامة منطقة 30 كم/س، فإن حد السرعة هو 30 كم/س. هذا ينطبق على المنطقة بأكملها حتى ترى علامة نهاية المنطقة."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl3",
    "text": {
      "en": "You are driving on a country road outside built-up areas. What is the default speed limit?",
      "nl": "Je rijdt op een buitenweg buiten bebouwde kommen. Wat is de standaard snelheidslimiet?",
      "ar": "أنت تقود على طريق ريفي خارج المناطق المبنية. ما هو حد السرعة الافتراضي؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl3o1",
        "text": {
          "en": "80 km/h",
          "nl": "80 km/u",
          "ar": "80 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl3o2",
        "text": {
          "en": "100 km/h",
          "nl": "100 km/u",
          "ar": "100 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl3o3",
        "text": {
          "en": "60 km/h",
          "nl": "60 km/u",
          "ar": "60 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl3o1",
    "explanation": {
      "en": "On country roads outside built-up areas, the default speed limit is 80 km/h for cars, unless otherwise indicated by signs.",
      "nl": "Op buitenwegen buiten bebouwde kommen is de standaard snelheidslimiet 80 km/u voor auto's, tenzij anders aangegeven door borden.",
      "ar": "على الطرق الريفية خارج المناطق المبنية، حد السرعة الافتراضي هو 80 كم/س للسيارات، ما لم يُشار إلى خلاف ذلك بواسطة علامات."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl4",
    "text": {
      "en": "You see a speed limit sign showing 60 km/h. What should you do?",
      "nl": "U ziet een snelheidslimietbord met 60 km/u. Wat moet u doen?",
      "ar": "ترى علامة حد السرعة تظهر 60 كم/س. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl4o1",
        "text": {
          "en": "Reduce speed to 60 km/h immediately",
          "nl": "Verlaag de snelheid onmiddellijk naar 60 km/u",
          "ar": "قلل السرعة إلى 60 كم/س على الفور"
        }
      },
      {
        "id": "real-2025-02-05-sl4o2",
        "text": {
          "en": "Continue at current speed",
          "nl": "Ga door met de huidige snelheid",
          "ar": "استمر بنفس السرعة الحالية"
        }
      },
      {
        "id": "real-2025-02-05-sl4o3",
        "text": {
          "en": "Reduce speed gradually over 100 meters",
          "nl": "Verlaag de snelheid geleidelijk over 100 meter",
          "ar": "قلل السرعة تدريجياً على مدى 100 متر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl4o1",
    "explanation": {
      "en": "Speed limit signs must be obeyed immediately when visible. You should reduce your speed to the limit shown as soon as you see the sign.",
      "nl": "Snelheidslimietborden moeten onmiddellijk worden nageleefd wanneer ze zichtbaar zijn. U moet uw snelheid verlagen tot de aangegeven limiet zodra u het bord ziet.",
      "ar": "يجب الالتزام بعلامات حد السرعة على الفور عند رؤيتها. يجب عليك تقليل سرعتك إلى الحد المعروض بمجرد رؤية العلامة."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl5",
    "text": {
      "en": "You see an \"End of Speed Limit\" sign. What does this mean?",
      "nl": "U ziet een bord \"Einde van de snelheidslimiet\". Wat betekent dit?",
      "ar": "ترى علامة \"نهاية حد السرعة\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl5o1",
        "text": {
          "en": "The previous speed limit no longer applies, default limit applies",
          "nl": "De vorige snelheidslimiet is niet meer van toepassing, de standaardlimiet is van toepassing",
          "ar": "الحد السابق للسرعة لم يعد ساريًا، الحد الافتراضي ساري"
        }
      },
      {
        "id": "real-2025-02-05-sl5o2",
        "text": {
          "en": "No speed limit applies",
          "nl": "Er geldt geen snelheidslimiet",
          "ar": "لا يوجد حد للسرعة"
        }
      },
      {
        "id": "real-2025-02-05-sl5o3",
        "text": {
          "en": "Speed limit is now 50 km/h",
          "nl": "De snelheidslimiet is nu 50 km/u",
          "ar": "حد السرعة الآن 50 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl5o1",
    "explanation": {
      "en": "An \"End of Speed Limit\" sign means the previous speed limit no longer applies. The default speed limit for that road type now applies (50 km/h in built-up areas, 80 km/h on country roads, 100 km/h on motorways).",
      "nl": "Een bord \"Einde van de snelheidslimiet\" betekent dat de vorige snelheidslimiet niet meer van toepassing is. De standaard snelheidslimiet voor dat type weg is nu van toepassing (50 km/u in bebouwde kom, 80 km/u op buitenwegen, 100 km/u op autosnelwegen).",
      "ar": "تعني علامة \"نهاية حد السرعة\" أن الحد السابق للسرعة لم يعد ساريًا. الحد الافتراضي للسرعة لهذا النوع من الطرق ينطبق الآن (50 كم/س في المناطق المأهولة، 80 كم/س في الطرق الريفية، 100 كم/س على الطرق السريعة)."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl6",
    "text": {
      "en": "You are driving at 50 km/h in a built-up area. You see a school zone sign. What should you do?",
      "nl": "U rijdt 50 km/u in een bebouwde kom. U ziet een bord voor een schoolzone. Wat moet u doen?",
      "ar": "أنت تقود بسرعة 50 كم/س في منطقة مأهولة. ترى علامة منطقة مدرسة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl6o1",
        "text": {
          "en": "Reduce speed to 30 km/h",
          "nl": "Snelheid terugbrengen naar 30 km/u",
          "ar": "قلل السرعة إلى 30 كم/ساعة"
        }
      },
      {
        "id": "real-2025-02-05-sl6o2",
        "text": {
          "en": "Continue at 50 km/h",
          "nl": "Ga verder met 50 km/u",
          "ar": "استمر بسرعة 50 كم/ساعة"
        }
      },
      {
        "id": "real-2025-02-05-sl6o3",
        "text": {
          "en": "Reduce speed to 40 km/h",
          "nl": "Verlaag de snelheid naar 40 km/u",
          "ar": "قلل السرعة إلى 40 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl6o1",
    "explanation": {
      "en": "School zones require reducing speed to 30 km/h for child safety. This applies during school hours and when children are present.",
      "nl": "In schoolzones moet de snelheid worden verlaagd tot 30 km/u voor de veiligheid van kinderen. Dit geldt tijdens schooluren en wanneer er kinderen aanwezig zijn.",
      "ar": "تتطلب مناطق المدارس تقليل السرعة إلى 30 كم/س لسلامة الأطفال. ينطبق هذا خلال ساعات المدرسة وعندما يكون الأطفال موجودين."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl7",
    "text": {
      "en": "You are driving on a motorway. What is the maximum speed limit during the day?",
      "nl": "U rijdt op een autosnelweg. Wat is de maximumsnelheidslimiet overdag?",
      "ar": "أنت تقود على طريق سريع. ما هو الحد الأقصى للسرعة خلال النهار؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl7o1",
        "text": {
          "en": "100 km/h",
          "nl": "100 km/u",
          "ar": "100 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl7o2",
        "text": {
          "en": "130 km/h",
          "nl": "130 km/u",
          "ar": "130 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl7o3",
        "text": {
          "en": "120 km/h",
          "nl": "120 km/u",
          "ar": "120 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl7o1",
    "explanation": {
      "en": "On Dutch motorways, the maximum speed limit during the day (06:00-19:00) is 100 km/h as of 2025. At night (19:00-06:00), some sections allow 130 km/h, but the standard daytime limit is 100 km/h.",
      "nl": "Op Nederlandse autosnelwegen is de maximumsnelheid overdag (06:00-19:00) 100 km/u vanaf 2025. 's Nachts (19:00-06:00) mogen sommige delen 130 km/u, maar de standaard daglimiet is 100 km/u.",
      "ar": "على الطرق السريعة الهولندية، الحد الأقصى للسرعة خلال النهار (06:00-19:00) هو 100 كم/س اعتبارًا من عام 2025. في الليل (19:00-06:00)، تسمح بعض الأقسام بسرعة 130 كم/س، لكن الحد الأقصى القياسي خلال النهار هو 100 كم/س."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl8",
    "text": {
      "en": "You see a variable speed limit sign on a motorway showing 80 km/h. What should you do?",
      "nl": "Je ziet een variabele snelheidslimietbord op een autosnelweg dat 80 km/u aangeeft. Wat moet je doen?",
      "ar": "ترى علامة حد سرعة متغيرة على الطريق السريع تشير إلى 80 كم/س. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl8o1",
        "text": {
          "en": "Reduce speed to 80 km/h immediately",
          "nl": "Verlaag de snelheid onmiddellijk naar 80 km/u",
          "ar": "قلل السرعة إلى 80 كم/س على الفور"
        }
      },
      {
        "id": "real-2025-02-05-sl8o2",
        "text": {
          "en": "Continue at 100 km/h",
          "nl": "Ga verder met 100 km/u",
          "ar": "تابع بسرعة 100 كم/ساعة"
        }
      },
      {
        "id": "real-2025-02-05-sl8o3",
        "text": {
          "en": "Reduce speed only if traffic is heavy",
          "nl": "Verlaag de snelheid alleen als het verkeer druk is",
          "ar": "قلل السرعة فقط إذا كان المرور كثيفًا"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl8o1",
    "explanation": {
      "en": "Variable speed limit signs on motorways must be obeyed immediately. They are used to manage traffic flow and improve safety, especially during congestion or adverse weather.",
      "nl": "Variabele snelheidsborden op snelwegen moeten onmiddellijk worden opgevolgd. Ze worden gebruikt om de verkeersstroom te beheren en de veiligheid te verbeteren, vooral tijdens drukte of slecht weer.",
      "ar": "يجب الامتثال لعلامات حد السرعة المتغيرة على الطرق السريعة على الفور. تُستخدم لإدارة تدفق حركة المرور وتحسين السلامة، خاصةً أثناء الازدحام أو الظروف الجوية السيئة."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl9",
    "text": {
      "en": "You are driving in fog with visibility less than 50 meters. What is the maximum speed?",
      "nl": "Je rijdt in de mist met een zicht van minder dan 50 meter. Wat is de maximumsnelheid?",
      "ar": "أنت تقود في ضباب مع رؤية أقل من 50 مترًا. ما هي السرعة القصوى؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl9o1",
        "text": {
          "en": "50 km/h",
          "nl": "50 km/u",
          "ar": "50 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl9o2",
        "text": {
          "en": "80 km/h",
          "nl": "80 km/u",
          "ar": "80 كم/س"
        }
      },
      {
        "id": "real-2025-02-05-sl9o3",
        "text": {
          "en": "100 km/h",
          "nl": "100 km/u",
          "ar": "100 كم/س"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl9o1",
    "explanation": {
      "en": "In fog with visibility less than 50 meters, the maximum speed is 50 km/h for safety. You must reduce speed to match visibility conditions.",
      "nl": "In de mist met een zicht van minder dan 50 meter is de maximumsnelheid 50 km/u voor de veiligheid. Je moet de snelheid verlagen om aan de zichtomstandigheden te voldoen.",
      "ar": "في الضباب مع رؤية أقل من 50 مترًا، الحد الأقصى للسرعة هو 50 كم/س من أجل السلامة. يجب عليك تقليل السرعة لتتناسب مع ظروف الرؤية."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-sl10",
    "text": {
      "en": "You see a speed limit sign showing 30 km/h. When does this limit apply?",
      "nl": "Je ziet een snelheidslimietbord dat 30 km/u aangeeft. Wanneer geldt deze limiet?",
      "ar": "ترى علامة حد السرعة تشير إلى 30 كم/س. متى تنطبق هذه الحد؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sl10o1",
        "text": {
          "en": "From the sign until an end of limit sign or different limit",
          "nl": "Van het bord tot een einde van de limietbord of een andere limiet",
          "ar": "من العلامة حتى علامة نهاية الحد أو حد مختلف"
        }
      },
      {
        "id": "real-2025-02-05-sl10o2",
        "text": {
          "en": "Only during school hours",
          "nl": "Alleen tijdens schooluren",
          "ar": "فقط خلال ساعات المدرسة"
        }
      },
      {
        "id": "real-2025-02-05-sl10o3",
        "text": {
          "en": "Only at night",
          "nl": "Alleen 's nachts",
          "ar": "فقط في الليل"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sl10o1",
    "explanation": {
      "en": "Speed limit signs apply from the point where the sign is located until you see an \"End of Speed Limit\" sign or a different speed limit sign.",
      "nl": "Snelheidslimietborden gelden vanaf het punt waar het bord zich bevindt tot je een \"Einde van de Snelheidslimiet\" bord of een ander snelheidslimietbord ziet.",
      "ar": "تسري علامات حد السرعة من النقطة التي يوجد فيها العلامة حتى ترى علامة \"نهاية حد السرعة\" أو علامة حد سرعة مختلفة."
    },
    "subject": "Speed Limits"
  },
  {
    "id": "real-2025-02-05-tl1",
    "text": {
      "en": "You are approaching traffic lights. The light is green. What should you do?",
      "nl": "Je nadert verkeerslichten. Het licht is groen. Wat moet je doen?",
      "ar": "أنت تقترب من إشارات المرور. الضوء أخضر. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl1o1",
        "text": {
          "en": "Proceed with caution",
          "nl": "Ga voorzichtig verder",
          "ar": "تابع بحذر"
        }
      },
      {
        "id": "real-2025-02-05-tl1o2",
        "text": {
          "en": "Stop and wait",
          "nl": "Stop en wacht",
          "ar": "توقف وانتظر"
        }
      },
      {
        "id": "real-2025-02-05-tl1o3",
        "text": {
          "en": "Speed up to pass quickly",
          "nl": "Versnel om snel te passeren",
          "ar": "تسارع للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl1o1",
    "explanation": {
      "en": "Green lights mean you may proceed, but you must still proceed with caution and be prepared to stop if necessary. Always check for pedestrians and other hazards.",
      "nl": "Groene lichten betekenen dat je mag doorgaan, maar je moet nog steeds voorzichtig doorgaan en voorbereid zijn om te stoppen indien nodig. Controleer altijd op voetgangers en andere gevaren.",
      "ar": "تشير الأضواء الخضراء إلى أنه يمكنك المتابعة، ولكن يجب عليك الاستمرار بحذر والاستعداد للتوقف إذا لزم الأمر. تحقق دائمًا من وجود المشاة والمخاطر الأخرى."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl2",
    "text": {
      "en": "You are approaching traffic lights. The light changes from green to amber. What should you do?",
      "nl": "U nadert verkeerslichten. Het licht verandert van groen naar amber. Wat moet u doen?",
      "ar": "أنت تقترب من إشارات المرور. يتحول الضوء من الأخضر إلى الأصفر. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl2o1",
        "text": {
          "en": "Stop if it is safe to do so, otherwise continue",
          "nl": "Stop als het veilig is om dat te doen, anders ga door",
          "ar": "توقف إذا كان ذلك آمناً، وإلا استمر"
        }
      },
      {
        "id": "real-2025-02-05-tl2o2",
        "text": {
          "en": "Accelerate to pass through",
          "nl": "Versnellen om door te geven",
          "ar": "الإسراع في المرور"
        }
      },
      {
        "id": "real-2025-02-05-tl2o3",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl2o1",
    "explanation": {
      "en": "Amber lights mean stop if it is safe to do so. If you are too close to stop safely, you may continue, but you must not accelerate to pass through.",
      "nl": "Amberlichten betekenen stoppen als het veilig is om dat te doen. Als u te dichtbij bent om veilig te stoppen, mag u doorgaan, maar u mag niet versnellen om door te rijden.",
      "ar": "تشير الأضواء الصفراء إلى أنه يجب عليك التوقف إذا كان ذلك آمناً. إذا كنت قريباً جداً من التوقف بأمان، يمكنك الاستمرار، لكن لا يجب عليك التسارع للعبور."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl3",
    "text": {
      "en": "You see a red traffic light. What must you do?",
      "nl": "U ziet een rood verkeerslicht. Wat moet u doen?",
      "ar": "ترى إشارة مرور حمراء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl3o1",
        "text": {
          "en": "Stop and wait for green",
          "nl": "Stop en wacht op groen",
          "ar": "توقف وانتظر اللون الأخضر"
        }
      },
      {
        "id": "real-2025-02-05-tl3o2",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      },
      {
        "id": "real-2025-02-05-tl3o3",
        "text": {
          "en": "Turn right if clear",
          "nl": "Sla rechtsaf indien vrij",
          "ar": "صحيح نظيف"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl3o1",
    "explanation": {
      "en": "Red traffic lights mean you must stop and wait for the light to turn green before proceeding. Running a red light is a serious traffic violation.",
      "nl": "Rode verkeerslichten betekenen dat u moet stoppen en wachten tot het licht op groen springt voordat u verdergaat. Doorrijden bij een rood licht is een ernstige verkeersovertreding.",
      "ar": "تشير إشارات المرور الحمراء إلى أنه يجب عليك التوقف والانتظار حتى يتحول الضوء إلى الأخضر قبل المتابعة. تجاوز الإشارة الحمراء هو انتهاك خطير لقواعد المرور."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl4",
    "text": {
      "en": "You see a flashing amber light at traffic lights. What does this mean?",
      "nl": "U ziet een knipperend amberlicht bij verkeerslichten. Wat betekent dit?",
      "ar": "ترى ضوءاً أصفر وامضاً عند إشارات المرور. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl4o1",
        "text": {
          "en": "Proceed with caution, give way to traffic from other directions",
          "nl": "Ga voorzichtig verder, geef voorrang aan verkeer uit andere richtingen",
          "ar": "تابع بحذر، وامنح الأولوية لحركة المرور من الاتجاهات الأخرى"
        }
      },
      {
        "id": "real-2025-02-05-tl4o2",
        "text": {
          "en": "Stop and wait",
          "nl": "Stop en wacht",
          "ar": "توقف وانتظر"
        }
      },
      {
        "id": "real-2025-02-05-tl4o3",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl4o1",
    "explanation": {
      "en": "A flashing amber light means the traffic lights are not functioning normally. Proceed with caution and give way to traffic from other directions, as priority rules apply.",
      "nl": "Een knipperend amberlicht betekent dat de verkeerslichten niet normaal functioneren. Ga voorzichtig verder en geef voorrang aan verkeer uit andere richtingen, aangezien de voorrangsregels van toepassing zijn.",
      "ar": "يعني الضوء الأصفر الوامض أن إشارات المرور لا تعمل بشكل طبيعي. تابع بحذر وامنح الأولوية لحركة المرور من الاتجاهات الأخرى، حيث تنطبق قواعد الأولوية."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl5",
    "text": {
      "en": "You are turning right at traffic lights. The light is green. What should you do?",
      "nl": "U slaat rechtsaf bij verkeerslichten. Het licht is groen. Wat moet u doen?",
      "ar": "أنت تنعطف يميناً عند إشارات المرور. الضوء أخضر. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl5o1",
        "text": {
          "en": "Proceed with caution, giving way to pedestrians and oncoming traffic",
          "nl": "Ga voorzichtig verder, geef voorrang aan voetgangers en tegemoetkomend verkeer",
          "ar": "تابع بحذر، وامنح الأولوية للمشاة وحركة المرور القادمة"
        }
      },
      {
        "id": "real-2025-02-05-tl5o2",
        "text": {
          "en": "Turn immediately without checking",
          "nl": "Draai onmiddellijk zonder te controleren",
          "ar": "انعطف فوراً دون التحقق"
        }
      },
      {
        "id": "real-2025-02-05-tl5o3",
        "text": {
          "en": "Wait for a right-turn arrow",
          "nl": "Wacht op een rechtsaf pijltje",
          "ar": "انتظر سهم الانعطاف لليمين"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl5o1",
    "explanation": {
      "en": "When turning right at a green light, you may proceed but must give way to pedestrians crossing and oncoming traffic going straight or turning left.",
      "nl": "Bij rechtsaf slaan bij een groen licht mag u doorgaan, maar u moet voorrang geven aan voetgangers die oversteken en tegemoetkomend verkeer dat rechtdoor gaat of linksaf slaat.",
      "ar": "عند الانعطاف يميناً عند الضوء الأخضر، يمكنك المتابعة ولكن يجب عليك منح الأولوية للمشاة الذين يعبرون والمرور القادم الذي يسير مباشرة أو ينعطف يساراً."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl6",
    "text": {
      "en": "You see a green arrow pointing right at traffic lights. What does this mean?",
      "nl": "U ziet een groene pijl naar rechts bij verkeerslichten. Wat betekent dit?",
      "ar": "ترى سهمًا أخضرًا يشير إلى اليمين عند إشارات المرور. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl6o1",
        "text": {
          "en": "You may turn right, but still give way to pedestrians",
          "nl": "Je mag rechtsaf slaan, maar moet nog steeds voorrang geven aan voetgangers.",
          "ar": "يمكنك الانعطاف إلى اليمين، ولكن يجب عليك أيضًا إعطاء الأولوية للمشاة."
        }
      },
      {
        "id": "real-2025-02-05-tl6o2",
        "text": {
          "en": "You must turn right immediately",
          "nl": "Je moet onmiddellijk rechtsaf slaan.",
          "ar": "يجب عليك الانعطاف إلى اليمين على الفور."
        }
      },
      {
        "id": "real-2025-02-05-tl6o3",
        "text": {
          "en": "Right turns are prohibited",
          "nl": "Rechtsaf slaan is verboden.",
          "ar": "الانعطاف إلى اليمين محظور."
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl6o1",
    "explanation": {
      "en": "A green arrow means you may turn in that direction, but you must still give way to pedestrians crossing the road you are turning into.",
      "nl": "Een groene pijl betekent dat je in die richting mag afslaan, maar je moet nog steeds voorrang geven aan voetgangers die de weg oversteken waar je in afslaat.",
      "ar": "تشير السهم الأخضر إلى أنه يمكنك الانعطاف في ذلك الاتجاه، ولكن يجب عليك أيضًا إعطاء الأولوية للمشاة الذين يعبرون الطريق الذي تنعطف إليه."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl7",
    "text": {
      "en": "Traffic lights are not working (all lights off). What should you do?",
      "nl": "Verkeerslichten werken niet (alle lichten zijn uit). Wat moet je doen?",
      "ar": "إشارات المرور لا تعمل (جميع الأضواء مطفأة). ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl7o1",
        "text": {
          "en": "Treat as an unmarked junction, apply priority rules",
          "nl": "Behandel als een ongereguleerd kruispunt, pas de voorrangsregels toe.",
          "ar": "اعتبره تقاطعًا غير محدد، وطبق قواعد الأولوية."
        }
      },
      {
        "id": "real-2025-02-05-tl7o2",
        "text": {
          "en": "Stop and wait indefinitely",
          "nl": "Stop en wacht onbepaalde tijd.",
          "ar": "توقف وانتظر إلى أجل غير مسمى."
        }
      },
      {
        "id": "real-2025-02-05-tl7o3",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl7o1",
    "explanation": {
      "en": "When traffic lights are not working, treat the junction as an unmarked junction. Apply priority rules: priority to the right, or follow road markings if present.",
      "nl": "Wanneer verkeerslichten niet werken, behandel het kruispunt als een ongereguleerd kruispunt. Pas de voorrangsregels toe: voorrang van rechts, of volg de wegmarkeringen als die aanwezig zijn.",
      "ar": "عندما لا تعمل إشارات المرور، اعتبر التقاطع كأنه تقاطع غير محدد. طبق قواعد الأولوية: الأولوية من اليمين، أو اتبع علامات الطريق إذا كانت موجودة."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-tl8",
    "text": {
      "en": "You are at traffic lights. The light is red but there is a green arrow for turning right. What should you do?",
      "nl": "Je staat bij verkeerslichten. Het licht is rood, maar er is een groene pijl voor rechtsaf. Wat moet je doen?",
      "ar": "أنت عند إشارات المرور. الضوء أحمر ولكن هناك سهم أخضر للانعطاف إلى اليمين. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-tl8o1",
        "text": {
          "en": "You may turn right, giving way to pedestrians",
          "nl": "Je mag rechtsaf slaan, met voorrang voor voetgangers.",
          "ar": "يمكنك الانعطاف إلى اليمين، مع إعطاء الأولوية للمشاة."
        }
      },
      {
        "id": "real-2025-02-05-tl8o2",
        "text": {
          "en": "Wait for the main light to turn green",
          "nl": "Wacht tot het hoofdlicht groen wordt.",
          "ar": "انتظر حتى يتحول الضوء الرئيسي إلى الأخضر."
        }
      },
      {
        "id": "real-2025-02-05-tl8o3",
        "text": {
          "en": "Right turns are not allowed",
          "nl": "Rechtsaf slaan is niet toegestaan.",
          "ar": "الانعطاف إلى اليمين غير مسموح."
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-tl8o1",
    "explanation": {
      "en": "When there is a green arrow for turning right, you may turn right even if the main light is red, but you must give way to pedestrians and other traffic.",
      "nl": "Wanneer er een groene pijl voor rechtsaf is, mag je rechtsaf slaan, zelfs als het hoofdlicht rood is, maar je moet voorrang geven aan voetgangers en ander verkeer.",
      "ar": "عندما يكون هناك سهم أخضر للانعطاف إلى اليمين، يمكنك الانعطاف إلى اليمين حتى لو كان الضوء الرئيسي أحمر، ولكن يجب عليك إعطاء الأولوية للمشاة والمرور الآخر."
    },
    "subject": "Traffic Lights"
  },
  {
    "id": "real-2025-02-05-ov1",
    "text": {
      "en": "You want to overtake a vehicle. What should you check first?",
      "nl": "Je wilt een voertuig inhalen. Wat moet je als eerste controleren?",
      "ar": "تريد تجاوز مركبة. ماذا يجب أن تتحقق أولاً؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov1o1",
        "text": {
          "en": "Mirrors, blind spots, and oncoming traffic",
          "nl": "Spiegels, dode hoeken en tegemoetkomend verkeer",
          "ar": "المرايا، والنقاط العمياء، وحركة المرور القادمة"
        }
      },
      {
        "id": "real-2025-02-05-ov1o2",
        "text": {
          "en": "Only the road ahead",
          "nl": "Alleen de weg voor je",
          "ar": "فقط الطريق أمامك"
        }
      },
      {
        "id": "real-2025-02-05-ov1o3",
        "text": {
          "en": "Only your speed",
          "nl": "Alleen je snelheid",
          "ar": "فقط سرعتك"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov1o1",
    "explanation": {
      "en": "Before overtaking, always check your mirrors, blind spots, and oncoming traffic to ensure it is safe. Never overtake without checking all around.",
      "nl": "Voordat je inhaalt, controleer altijd je spiegels, dode hoeken en tegemoetkomend verkeer om te zorgen dat het veilig is. Haal nooit in zonder alles rondom te controleren.",
      "ar": "قبل التجاوز، تحقق دائمًا من مراياك، والنقاط العمياء، وحركة المرور القادمة للتأكد من أنه آمن. لا تتجاوز أبدًا دون التحقق من كل شيء حولك."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov2",
    "text": {
      "en": "You want to overtake on a two-lane road. When is it safe?",
      "nl": "Je wilt inhalen op een tweebaansweg. Wanneer is het veilig?",
      "ar": "تريد التجاوز على طريق ذو مسارين. متى يكون ذلك آمنًا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov2o1",
        "text": {
          "en": "When there is sufficient space, no oncoming traffic, and clear visibility",
          "nl": "Wanneer er voldoende ruimte is, geen tegemoetkomend verkeer en een goed zicht",
          "ar": "عندما تكون هناك مساحة كافية، ولا يوجد حركة مرور قادمة، ورؤية واضحة"
        }
      },
      {
        "id": "real-2025-02-05-ov2o2",
        "text": {
          "en": "When you can accelerate quickly",
          "nl": "Wanneer je snel kunt accelereren",
          "ar": "عندما يمكنك التسارع بسرعة"
        }
      },
      {
        "id": "real-2025-02-05-ov2o3",
        "text": {
          "en": "When the vehicle ahead is slow",
          "nl": "Wanneer het voertuig voor je langzaam is",
          "ar": "عندما يكون المركبة أمامك بطيئة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov2o1",
    "explanation": {
      "en": "Overtaking is safe only when there is sufficient space, no oncoming traffic, and clear visibility ahead. Never overtake if any of these conditions are not met.",
      "nl": "Inhalen is alleen veilig wanneer er voldoende ruimte is, geen tegemoetkomend verkeer en een goed zicht naar voren. Haal nooit in als aan een van deze voorwaarden niet is voldaan.",
      "ar": "التجاوز آمن فقط عندما يكون هناك مساحة كافية، ولا يوجد حركة مرور قادمة، ورؤية واضحة للأمام. لا تتجاوز أبدًا إذا لم يتم استيفاء أي من هذه الشروط."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov3",
    "text": {
      "en": "You see a \"No Overtaking\" sign. What does this mean?",
      "nl": "Je ziet een \"Inhalen Verboden\" bord. Wat betekent dit?",
      "ar": "ترى علامة \"التجاوز ممنوع\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov3o1",
        "text": {
          "en": "Overtaking is prohibited until an end of restriction sign",
          "nl": "Inhalen is verboden totdat er een einde van beperking bord is",
          "ar": "التجاوز محظور حتى علامة نهاية القيود"
        }
      },
      {
        "id": "real-2025-02-05-ov3o2",
        "text": {
          "en": "Overtaking is allowed for fast vehicles",
          "nl": "Inhalen is toegestaan voor snelle voertuigen",
          "ar": "التجاوز مسموح به للمركبات السريعة"
        }
      },
      {
        "id": "real-2025-02-05-ov3o3",
        "text": {
          "en": "Overtaking is allowed if safe",
          "nl": "Inhalen is toegestaan als het veilig is",
          "ar": "التجاوز مسموح به إذا كان آمنًا"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov3o1",
    "explanation": {
      "en": "A \"No Overtaking\" sign means overtaking is prohibited until you see an \"End of No Overtaking\" sign. This restriction applies to all vehicles.",
      "nl": "Een \"Inhalen Verboden\" bord betekent dat inhalen verboden is totdat je een \"Einde Inhalen Verboden\" bord ziet. Deze beperking geldt voor alle voertuigen.",
      "ar": "علامة \"التجاوز ممنوع\" تعني أن التجاوز محظور حتى ترى علامة \"نهاية التجاوز ممنوع\". هذا القيد ينطبق على جميع المركبات."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov4",
    "text": {
      "en": "You want to overtake a cyclist. What is the minimum safe distance?",
      "nl": "Je wilt een fietser inhalen. Wat is de minimale veilige afstand?",
      "ar": "تريد تجاوز راكب دراجة. ما هي الحد الأدنى من المسافة الآمنة؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov4o1",
        "text": {
          "en": "At least 1.5 meters",
          "nl": "Minimaal 1,5 meter",
          "ar": "على الأقل 1.5 متر"
        }
      },
      {
        "id": "real-2025-02-05-ov4o2",
        "text": {
          "en": "1 meter is sufficient",
          "nl": "1 meter is voldoende",
          "ar": "1 متر كافٍ"
        }
      },
      {
        "id": "real-2025-02-05-ov4o3",
        "text": {
          "en": "Any distance is fine",
          "nl": "Elke afstand is goed",
          "ar": "أي مسافة جيدة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov4o1",
    "explanation": {
      "en": "When overtaking a cyclist, you must maintain at least 1.5 meters of distance for safety. On narrow roads, you may need to wait for a safe opportunity.",
      "nl": "Bij het inhalen van een fietser moet je minimaal 1,5 meter afstand houden voor de veiligheid. Op smalle wegen moet je misschien wachten op een veilige gelegenheid.",
      "ar": "عند تجاوز راكب دراجة، يجب أن تحافظ على مسافة لا تقل عن 1.5 متر للسلامة. على الطرق الضيقة، قد تحتاج إلى الانتظار حتى تتاح لك فرصة آمنة."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov5",
    "text": {
      "en": "You are overtaking on a motorway. What should you do?",
      "nl": "Je bent aan het inhalen op de snelweg. Wat moet je doen?",
      "ar": "أنت تتجاوز على الطريق السريع. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov5o1",
        "text": {
          "en": "Use the left lane, signal, and return to the right lane after overtaking",
          "nl": "Gebruik de linkerbaan, geef een signaal en keer terug naar de rechterbaan na het inhalen",
          "ar": "استخدم الحارة اليسرى، وأشر، وارجع إلى الحارة اليمنى بعد التجاوز"
        }
      },
      {
        "id": "real-2025-02-05-ov5o2",
        "text": {
          "en": "Overtake from the right lane",
          "nl": "Inhalen vanuit de rechterbaan",
          "ar": "تجاوز من الحارة اليمنى"
        }
      },
      {
        "id": "real-2025-02-05-ov5o3",
        "text": {
          "en": "Stay in the left lane after overtaking",
          "nl": "Blijf op de linkerbaan na het inhalen",
          "ar": "ابقَ في الحارة اليسرى بعد التجاوز"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov5o1",
    "explanation": {
      "en": "On motorways, use the left lane to overtake, signal your intention, and return to the right lane after overtaking. Never stay in the left lane unnecessarily.",
      "nl": "Op snelwegen gebruik je de linkerbaan om in te halen, geef je je intentie aan met een signaal en keer je terug naar de rechterbaan na het inhalen. Blijf nooit onnodig op de linkerbaan.",
      "ar": "على الطرق السريعة، استخدم الحارة اليسرى للتجاوز، وأشر إلى نيتك، وارجع إلى الحارة اليمنى بعد التجاوز. لا تبقَ في الحارة اليسرى دون داعٍ."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov6",
    "text": {
      "en": "You see a solid white line in the center of the road. Can you overtake?",
      "nl": "Je ziet een doorgetrokken witte lijn in het midden van de weg. Mag je inhalen?",
      "ar": "ترى خطًا أبيض متصلًا في وسط الطريق. هل يمكنك التجاوز؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov6o1",
        "text": {
          "en": "No, overtaking is prohibited across solid lines",
          "nl": "Nee, inhalen is verboden over doorgetrokken lijnen",
          "ar": "لا، التجاوز محظور عبر الخطوط المتصلة"
        }
      },
      {
        "id": "real-2025-02-05-ov6o2",
        "text": {
          "en": "Yes, if safe to do so",
          "nl": "Ja, als het veilig is om te doen",
          "ar": "نعم، إذا كان ذلك آمنًا للقيام به"
        }
      },
      {
        "id": "real-2025-02-05-ov6o3",
        "text": {
          "en": "Yes, but only for slow vehicles",
          "nl": "Ja, maar alleen voor langzame voertuigen",
          "ar": "نعم، ولكن فقط للمركبات البطيئة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov6o1",
    "explanation": {
      "en": "Solid white lines mean you must not cross them to overtake, except in emergencies. Overtaking across solid lines is prohibited and dangerous.",
      "nl": "Doorgetrokken witte lijnen betekenen dat je ze niet mag overschrijden om in te halen, behalve in noodgevallen. Inhalen over doorgetrokken lijnen is verboden en gevaarlijk.",
      "ar": "الخطوط البيضاء المتصلة تعني أنه لا يجب عليك عبورها للتجاوز، باستثناء حالات الطوارئ. التجاوز عبر الخطوط المتصلة محظور وخطير."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov7",
    "text": {
      "en": "You want to overtake but there is oncoming traffic. What should you do?",
      "nl": "Je wilt inhalen, maar er is tegenliggend verkeer. Wat moet je doen?",
      "ar": "تريد التجاوز ولكن هناك حركة مرور قادمة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov7o1",
        "text": {
          "en": "Wait until it is safe, do not overtake",
          "nl": "Wacht tot het veilig is, haal niet in",
          "ar": "انتظر حتى يكون الأمر آمناً، لا تتجاوز"
        }
      },
      {
        "id": "real-2025-02-05-ov7o2",
        "text": {
          "en": "Overtake quickly before the oncoming vehicle arrives",
          "nl": "Haal snel in voordat het tegemoetkomende voertuig arriveert",
          "ar": "تجاوز بسرعة قبل وصول المركبة القادمة"
        }
      },
      {
        "id": "real-2025-02-05-ov7o3",
        "text": {
          "en": "Overtake if you can accelerate fast enough",
          "nl": "Haal in als je snel genoeg kunt accelereren",
          "ar": "تجاوز إذا كنت تستطيع التسارع بسرعة كافية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov7o1",
    "explanation": {
      "en": "Never overtake when there is oncoming traffic. Wait until it is completely safe. Overtaking with oncoming traffic is extremely dangerous and illegal.",
      "nl": "Haal nooit in als er tegenliggend verkeer is. Wacht tot het volledig veilig is. Inhalen met tegenliggend verkeer is extreem gevaarlijk en illegaal.",
      "ar": "لا تتجاوز أبدًا عندما يكون هناك حركة مرور قادمة. انتظر حتى يصبح الأمر آمنًا تمامًا. التجاوز مع حركة المرور القادمة خطير للغاية وغير قانوني."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-ov8",
    "text": {
      "en": "You are overtaking and the vehicle ahead signals to turn left. What should you do?",
      "nl": "Je bent aan het inhalen en het voertuig voor je geeft aan dat het naar links wil afslaan. Wat moet je doen?",
      "ar": "أنت تتجاوز والمركبة أمامك تشير إلى أنها ستنعطف يساراً. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ov8o1",
        "text": {
          "en": "Cancel the overtake and wait",
          "nl": "Annuleer het inhalen en wacht",
          "ar": "ألغِ التجاوز وانتظر"
        }
      },
      {
        "id": "real-2025-02-05-ov8o2",
        "text": {
          "en": "Continue overtaking",
          "nl": "Ga door met inhalen",
          "ar": "استمر في التجاوز"
        }
      },
      {
        "id": "real-2025-02-05-ov8o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ov8o1",
    "explanation": {
      "en": "If a vehicle signals to turn left while you are overtaking, you must cancel the overtake and wait. The vehicle may turn into your path.",
      "nl": "Als een voertuig aangeeft naar links te willen afslaan terwijl je aan het inhalen bent, moet je het inhalen annuleren en wachten. Het voertuig kan je pad kruisen.",
      "ar": "إذا كانت المركبة تشير إلى أنها ستنعطف يساراً أثناء تجاوزك، يجب عليك إلغاء التجاوز والانتظار. قد تتجه المركبة إلى مسارك."
    },
    "subject": "Overtaking"
  },
  {
    "id": "real-2025-02-05-pc1",
    "text": {
      "en": "You see a pedestrian waiting at a zebra crossing. What should you do?",
      "nl": "Je ziet een voetganger wachten bij een zebrapad. Wat moet je doen?",
      "ar": "ترى مشاة ينتظرون عند معبر المشاة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc1o1",
        "text": {
          "en": "Stop and give way to the pedestrian",
          "nl": "Stop en maak plaats voor de voetganger",
          "ar": "التوقف وإفساح الطريق للمشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc1o2",
        "text": {
          "en": "Continue if the pedestrian is not yet crossing",
          "nl": "Ga door als de voetganger nog niet aan het oversteken is",
          "ar": "استمر إذا لم يكن المشاة قد بدأوا بالعبور بعد"
        }
      },
      {
        "id": "real-2025-02-05-pc1o3",
        "text": {
          "en": "Sound your horn to warn the pedestrian",
          "nl": "Klink op je claxon om de voetganger te waarschuwen",
          "ar": "أطلق بوق سيارتك لتحذير المشاة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc1o1",
    "explanation": {
      "en": "At zebra crossings, pedestrians have absolute priority. You must stop and give way to pedestrians who are waiting to cross or already crossing.",
      "nl": "Bij zebrapaden hebben voetgangers absolute voorrang. Je moet stoppen en voorrang geven aan voetgangers die wachten om over te steken of al aan het oversteken zijn.",
      "ar": "عند معابر المشاة، يتمتع المشاة بأولوية مطلقة. يجب عليك التوقف وإعطاء الأولوية للمشاة الذين ينتظرون للعبور أو الذين يعبرون بالفعل."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc2",
    "text": {
      "en": "A pedestrian is crossing the road at a zebra crossing. What should you do?",
      "nl": "Een voetganger steekt de weg over bij een zebrapad. Wat moet je doen?",
      "ar": "يمر المشاة عبر الطريق عند معبر المشاة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc2o1",
        "text": {
          "en": "Stop and wait until the pedestrian has crossed completely",
          "nl": "Stop en wacht totdat de voetganger volledig is overgestoken",
          "ar": "توقف وانتظر حتى يكتمل عبور المشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc2o2",
        "text": {
          "en": "Continue if you can pass behind the pedestrian",
          "nl": "Ga door als je achter de voetganger kunt passeren",
          "ar": "استمر إذا كنت تستطيع المرور خلف المشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc2o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc2o1",
    "explanation": {
      "en": "When a pedestrian is crossing at a zebra crossing, you must stop and wait until they have crossed completely. Never try to pass a pedestrian who is crossing.",
      "nl": "Wanneer een voetganger oversteekt bij een zebrapad, moet je stoppen en wachten totdat ze volledig zijn overgestoken. Probeer nooit een voetganger die aan het oversteken is te passeren.",
      "ar": "عندما يعبر المشاة عند معبر المشاة، يجب عليك التوقف والانتظار حتى يكتمل عبورهم. لا تحاول أبداً تجاوز مشاة يعبرون."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc3",
    "text": {
      "en": "You see a pedestrian crossing sign. What should you do?",
      "nl": "Je ziet een voetgangersoversteekplaats bord. Wat moet je doen?",
      "ar": "ترى علامة عبور المشاة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc3o1",
        "text": {
          "en": "Be prepared to stop for pedestrians",
          "nl": "Wees voorbereid om te stoppen voor voetgangers",
          "ar": "كن مستعدًا للتوقف للمشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc3o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-pc3o3",
        "text": {
          "en": "Increase speed to pass quickly",
          "nl": "Verhoog de snelheid om snel te passeren",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc3o1",
    "explanation": {
      "en": "A pedestrian crossing sign warns you that there is a pedestrian crossing ahead. Be prepared to stop for pedestrians and reduce speed if necessary.",
      "nl": "Een voetgangersoversteekplaats bord waarschuwt je dat er een voetgangersoversteekplaats aankomt. Wees voorbereid om te stoppen voor voetgangers en verlaag indien nodig je snelheid.",
      "ar": "علامة عبور المشاة تحذرك من وجود عبور للمشاة في الأمام. كن مستعدًا للتوقف للمشاة وقلل السرعة إذا لزم الأمر."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc4",
    "text": {
      "en": "You are turning right at a junction. A pedestrian is crossing the road you are turning into. What should you do?",
      "nl": "Je slaat rechtsaf bij een kruispunt. Een voetganger steekt de weg over waar je naartoe draait. Wat moet je doen?",
      "ar": "أنت تنعطف يمينًا عند تقاطع. عابر سبيل يعبر الطريق الذي تنعطف إليه. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc4o1",
        "text": {
          "en": "Give way to the pedestrian",
          "nl": "Geef voorrang aan de voetganger",
          "ar": "أعطِ الأولوية لعبور المشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc4o2",
        "text": {
          "en": "Continue, pedestrians must give way",
          "nl": "Ga door, voetgangers moeten voorrang geven",
          "ar": "استمر، يجب على المشاة إعطاء الأولوية"
        }
      },
      {
        "id": "real-2025-02-05-pc4o3",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc4o1",
    "explanation": {
      "en": "When turning, you must give way to pedestrians who are crossing the road you are turning into. Pedestrians have priority in this situation.",
      "nl": "Bij het afslaan moet je voorrang geven aan voetgangers die de weg oversteken waar je naartoe draait. Voetgangers hebben voorrang in deze situatie.",
      "ar": "عند الانعطاف، يجب عليك إعطاء الأولوية للمشاة الذين يعبرون الطريق الذي تنعطف إليه. للمشاة أولوية في هذا الموقف."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc5",
    "text": {
      "en": "You see a pedestrian crossing with traffic lights. The light is green for you. What should you do?",
      "nl": "Je ziet een voetgangersoversteekplaats met verkeerslichten. Het licht is groen voor jou. Wat moet je doen?",
      "ar": "ترى عبور المشاة مع إشارات المرور. الضوء أخضر لك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc5o1",
        "text": {
          "en": "Proceed with caution, giving way to pedestrians who are already crossing",
          "nl": "Ga voorzichtig verder, geef voorrang aan voetgangers die al oversteken",
          "ar": "تقدم بحذر، مع إعطاء الأولوية للمشاة الذين يعبرون بالفعل"
        }
      },
      {
        "id": "real-2025-02-05-pc5o2",
        "text": {
          "en": "Proceed normally, pedestrians must wait",
          "nl": "Ga normaal verder, voetgangers moeten wachten",
          "ar": "تقدم بشكل طبيعي، يجب على المشاة الانتظار"
        }
      },
      {
        "id": "real-2025-02-05-pc5o3",
        "text": {
          "en": "Stop and wait",
          "nl": "Stop en wacht",
          "ar": "توقف وانتظر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc5o1",
    "explanation": {
      "en": "Even when the light is green for you, you must proceed with caution and give way to pedestrians who are already crossing the road.",
      "nl": "Zelfs als het licht groen is voor jou, moet je voorzichtig doorgaan en voorrang geven aan voetgangers die al de weg oversteken.",
      "ar": "حتى عندما يكون الضوء أخضر لك، يجب عليك التقدم بحذر وإعطاء الأولوية للمشاة الذين يعبرون الطريق بالفعل."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc6",
    "text": {
      "en": "You see children near a pedestrian crossing. What should you do?",
      "nl": "Je ziet kinderen bij een voetgangersoversteekplaats. Wat moet je doen?",
      "ar": "ترى أطفالًا بالقرب من عبور المشاة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc6o1",
        "text": {
          "en": "Be extra cautious and prepared to stop",
          "nl": "Wees extra voorzichtig en voorbereid om te stoppen",
          "ar": "كن حذرًا جدًا ومستعدًا للتوقف"
        }
      },
      {
        "id": "real-2025-02-05-pc6o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-pc6o3",
        "text": {
          "en": "Sound your horn to warn them",
          "nl": "Toet je claxon om hen te waarschuwen",
          "ar": "استخدم بوق السيارة لتحذيرهم"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc6o1",
    "explanation": {
      "en": "When children are near a pedestrian crossing, you must be extra cautious and prepared to stop. Children may behave unpredictably and may not follow crossing rules properly.",
      "nl": "Wanneer kinderen bij een voetgangersoversteekplaats zijn, moet je extra voorzichtig zijn en voorbereid zijn om te stoppen. Kinderen kunnen onvoorspelbaar gedrag vertonen en zich mogelijk niet goed aan de oversteekregels houden.",
      "ar": "عندما يكون الأطفال بالقرب من عبور المشاة، يجب أن تكون حذرًا جدًا ومستعدًا للتوقف. قد يتصرف الأطفال بشكل غير متوقع وقد لا يتبعون قواعد العبور بشكل صحيح."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc7",
    "text": {
      "en": "You are approaching a zebra crossing. There are no pedestrians visible. What should you do?",
      "nl": "Je nadert een zebrapad. Er zijn geen voetgangers zichtbaar. Wat moet je doen?",
      "ar": "أنت تقترب من معبر المشاة. لا توجد أي مشاة مرئيون. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc7o1",
        "text": {
          "en": "Continue but be prepared to stop if pedestrians appear",
          "nl": "Ga door, maar wees voorbereid om te stoppen als er voetgangers verschijnen",
          "ar": "تابع ولكن كن مستعدًا للتوقف إذا ظهر المشاة"
        }
      },
      {
        "id": "real-2025-02-05-pc7o2",
        "text": {
          "en": "Stop and wait",
          "nl": "Stop en wacht",
          "ar": "توقف وانتظر"
        }
      },
      {
        "id": "real-2025-02-05-pc7o3",
        "text": {
          "en": "Increase speed to pass quickly",
          "nl": "Verhoog de snelheid om snel te passeren",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc7o1",
    "explanation": {
      "en": "If there are no pedestrians at a zebra crossing, you may continue but must be prepared to stop if pedestrians appear. Always be ready to give way.",
      "nl": "Als er geen voetgangers bij een zebrapad zijn, mag je doorgaan, maar je moet voorbereid zijn om te stoppen als er voetgangers verschijnen. Wees altijd bereid om voorrang te geven.",
      "ar": "إذا لم يكن هناك مشاة عند معبر المشاة، يمكنك المتابعة ولكن يجب أن تكون مستعدًا للتوقف إذا ظهر المشاة. كن دائمًا مستعدًا لمنح الأولوية."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-pc8",
    "text": {
      "en": "A pedestrian is crossing slowly at a zebra crossing. What should you do?",
      "nl": "Een voetganger steekt langzaam over bij een zebrapad. Wat moet je doen?",
      "ar": "يمر مشاة ببطء عند معبر المشاة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-pc8o1",
        "text": {
          "en": "Wait patiently until the pedestrian has crossed completely",
          "nl": "Wacht geduldig totdat de voetganger volledig is overgestoken",
          "ar": "انتظر بصبر حتى يعبر المشاة بالكامل"
        }
      },
      {
        "id": "real-2025-02-05-pc8o2",
        "text": {
          "en": "Sound your horn to hurry them",
          "nl": "Toet je claxon om hen te haasten",
          "ar": "استخدم بوق السيارة لتسريعهم"
        }
      },
      {
        "id": "real-2025-02-05-pc8o3",
        "text": {
          "en": "Proceed if you can pass safely",
          "nl": "Ga door als je veilig kunt passeren",
          "ar": "تابع إذا كنت تستطيع المرور بأمان"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-pc8o1",
    "explanation": {
      "en": "You must wait patiently for pedestrians to cross completely, regardless of their speed. Never try to hurry pedestrians or pass them while they are crossing.",
      "nl": "Je moet geduldig wachten tot voetgangers volledig zijn overgestoken, ongeacht hun snelheid. Probeer nooit voetgangers te haasten of ze te passeren terwijl ze oversteken.",
      "ar": "يجب أن تنتظر بصبر حتى يعبر المشاة بالكامل، بغض النظر عن سرعتهم. لا تحاول أبدًا تسريع المشاة أو تجاوزهم أثناء عبورهم."
    },
    "subject": "Pedestrian Crossings"
  },
  {
    "id": "real-2025-02-05-cz1",
    "text": {
      "en": "You see a construction zone sign. What should you do?",
      "nl": "Je ziet een bord voor een bouwzone. Wat moet je doen?",
      "ar": "ترى علامة منطقة البناء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz1o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2025-02-05-cz1o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-cz1o3",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz1o1",
    "explanation": {
      "en": "Construction zones require reducing speed and being extra cautious. There may be workers, equipment, or changed road conditions ahead.",
      "nl": "Bouwzones vereisen dat je je snelheid vermindert en extra voorzichtig bent. Er kunnen werknemers, apparatuur of veranderde wegomstandigheden zijn.",
      "ar": "تتطلب مناطق البناء تقليل السرعة وكونك أكثر حذرًا. قد يكون هناك عمال أو معدات أو ظروف طرق متغيرة في الأمام."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz2",
    "text": {
      "en": "You are driving through a construction zone. What should you be aware of?",
      "nl": "Je rijdt door een bouwzone. Waar moet je op letten?",
      "ar": "أنت تقود عبر منطقة بناء. ماذا يجب أن تكون على علم به؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz2o1",
        "text": {
          "en": "Workers, changed road conditions, and reduced speed limits",
          "nl": "Werknemers, veranderde wegomstandigheden en verlaagde snelheidslimieten",
          "ar": "العمال وظروف الطرق المتغيرة والحدود السرعية المنخفضة"
        }
      },
      {
        "id": "real-2025-02-05-cz2o2",
        "text": {
          "en": "Only the speed limit",
          "nl": "Alleen de snelheidslimiet",
          "ar": "فقط حد السرعة"
        }
      },
      {
        "id": "real-2025-02-05-cz2o3",
        "text": {
          "en": "Only other vehicles",
          "nl": "Alleen andere voertuigen",
          "ar": "فقط المركبات الأخرى"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz2o1",
    "explanation": {
      "en": "In construction zones, be aware of workers, changed road conditions, reduced speed limits, and potential hazards. Always be extra cautious.",
      "nl": "In bouwzones moet je letten op werknemers, veranderde wegomstandigheden, verlaagde snelheidslimieten en potentiële gevaren. Wees altijd extra voorzichtig.",
      "ar": "في مناطق البناء، كن على علم بالعمال وظروف الطرق المتغيرة والحدود السرعية المنخفضة والمخاطر المحتملة. كن دائمًا أكثر حذرًا."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz3",
    "text": {
      "en": "You see a reduced speed limit sign in a construction zone. What should you do?",
      "nl": "Je ziet een bord met een verlaagde snelheidslimiet in een bouwzone. Wat moet je doen?",
      "ar": "ترى علامة حد السرعة المخفضة في منطقة البناء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz3o1",
        "text": {
          "en": "Reduce speed to the limit shown immediately",
          "nl": "Verlaag de snelheid onmiddellijk tot de aangegeven limiet",
          "ar": "قلل السرعة إلى الحد المعروض على الفور"
        }
      },
      {
        "id": "real-2025-02-05-cz3o2",
        "text": {
          "en": "Continue at current speed",
          "nl": "Ga door met de huidige snelheid",
          "ar": "استمر بنفس السرعة الحالية"
        }
      },
      {
        "id": "real-2025-02-05-cz3o3",
        "text": {
          "en": "Reduce speed only if workers are visible",
          "nl": "Verlaag de snelheid alleen als werknemers zichtbaar zijn",
          "ar": "قلل السرعة فقط إذا كان العمال مرئيين"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz3o1",
    "explanation": {
      "en": "Reduced speed limits in construction zones must be obeyed immediately, regardless of whether workers are visible. These limits are for safety.",
      "nl": "Verlaagde snelheidslimieten in bouwzones moeten onmiddellijk worden nageleefd, ongeacht of er werknemers zichtbaar zijn. Deze limieten zijn voor de veiligheid.",
      "ar": "يجب الالتزام بحدود السرعة المخفضة في مناطق البناء على الفور، بغض النظر عما إذا كان العمال مرئيين. هذه الحدود من أجل السلامة."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz4",
    "text": {
      "en": "You see workers in a construction zone. What should you do?",
      "nl": "Je ziet werknemers in een bouwzone. Wat moet je doen?",
      "ar": "ترى عمالًا في منطقة البناء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz4o1",
        "text": {
          "en": "Reduce speed further and be extra cautious",
          "nl": "Verlaag de snelheid verder en wees extra voorzichtig",
          "ar": "قلل السرعة أكثر وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2025-02-05-cz4o2",
        "text": {
          "en": "Continue at the posted speed limit",
          "nl": "Ga door met de aangegeven snelheidslimiet",
          "ar": "استمر في الحد المعلن للسرعة"
        }
      },
      {
        "id": "real-2025-02-05-cz4o3",
        "text": {
          "en": "Sound your horn to warn workers",
          "nl": "Toet je claxon om werknemers te waarschuwen",
          "ar": "استخدم بوق سيارتك لتحذير العمال"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz4o1",
    "explanation": {
      "en": "When workers are present in a construction zone, reduce speed further and be extra cautious. Workers may be close to the road and need protection.",
      "nl": "Wanneer er werknemers aanwezig zijn in een bouwzone, verlaag dan de snelheid verder en wees extra voorzichtig. Werknemers kunnen dicht bij de weg zijn en hebben bescherming nodig.",
      "ar": "عندما يكون العمال موجودين في منطقة البناء، قلل السرعة أكثر وكن حذرًا للغاية. قد يكون العمال قريبين من الطريق ويحتاجون إلى الحماية."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz5",
    "text": {
      "en": "You see a lane closure in a construction zone. What should you do?",
      "nl": "Je ziet een rijstrookafsluiting in een bouwzone. Wat moet je doen?",
      "ar": "ترى إغلاق حارة في منطقة البناء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz5o1",
        "text": {
          "en": "Merge safely into the open lane when indicated",
          "nl": "Voeg veilig in de open rijstrook in wanneer aangegeven",
          "ar": "ادمج بأمان في الحارة المفتوحة عندما يتم الإشارة إليها"
        }
      },
      {
        "id": "real-2025-02-05-cz5o2",
        "text": {
          "en": "Continue in the closed lane",
          "nl": "Ga door in de gesloten rijstrook",
          "ar": "استمر في المسار المغلق"
        }
      },
      {
        "id": "real-2025-02-05-cz5o3",
        "text": {
          "en": "Stop and wait",
          "nl": "Stop en wacht",
          "ar": "توقف وانتظر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz5o1",
    "explanation": {
      "en": "When a lane is closed in a construction zone, merge safely into the open lane when indicated by signs or road markings. Follow the merge pattern shown.",
      "nl": "Wanneer een rijstrook is afgesloten in een bouwzone, voeg je veilig in de open rijstrook in wanneer dit wordt aangegeven door borden of wegmarkeringen. Volg het aangegeven invoegpatroon.",
      "ar": "عندما تكون حارة مغلقة في منطقة البناء، اندمج بأمان في الحارة المفتوحة عندما تشير إليها العلامات أو علامات الطريق. اتبع نمط الدمج المعروض."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz6",
    "text": {
      "en": "You see an \"End of Construction Zone\" sign. What should you do?",
      "nl": "U ziet een \"Einde van de bouwzone\" bord. Wat moet u doen?",
      "ar": "رأيت علامة \"نهاية منطقة البناء\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz6o1",
        "text": {
          "en": "You may resume normal speed if conditions allow",
          "nl": "U mag weer normaal snelheid maken als de omstandigheden dat toelaten",
          "ar": "يمكنك استئناف السرعة العادية إذا سمحت الظروف"
        }
      },
      {
        "id": "real-2025-02-05-cz6o2",
        "text": {
          "en": "Continue at reduced speed",
          "nl": "Ga door met verminderde snelheid",
          "ar": "استمر بسرعة منخفضة"
        }
      },
      {
        "id": "real-2025-02-05-cz6o3",
        "text": {
          "en": "Stop and check road conditions",
          "nl": "Stop en controleer de wegomstandigheden",
          "ar": "توقف وتحقق من ظروف الطريق"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz6o1",
    "explanation": {
      "en": "An \"End of Construction Zone\" sign means the construction zone restrictions no longer apply. You may resume normal speed if road conditions and other factors allow.",
      "nl": "Een \"Einde van de bouwzone\" bord betekent dat de beperkingen van de bouwzone niet meer van toepassing zijn. U mag weer normaal snelheid maken als de wegomstandigheden en andere factoren dat toelaten.",
      "ar": "علامة \"نهاية منطقة البناء\" تعني أن قيود منطقة البناء لم تعد سارية. يمكنك استئناف السرعة العادية إذا سمحت ظروف الطريق وعوامل أخرى."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz7",
    "text": {
      "en": "You see temporary traffic lights in a construction zone. What should you do?",
      "nl": "U ziet tijdelijke verkeerslichten in een bouwzone. Wat moet u doen?",
      "ar": "رأيت إشارات مرور مؤقتة في منطقة البناء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz7o1",
        "text": {
          "en": "Obey the temporary traffic lights as you would normal traffic lights",
          "nl": "Volg de tijdelijke verkeerslichten zoals u normale verkeerslichten zou volgen",
          "ar": "امتثل لإشارات المرور المؤقتة كما تفعل مع إشارات المرور العادية"
        }
      },
      {
        "id": "real-2025-02-05-cz7o2",
        "text": {
          "en": "Ignore them if no workers are present",
          "nl": "Negeer ze als er geen werknemers aanwezig zijn",
          "ar": "تجاهلها إذا لم يكن هناك عمال موجودون"
        }
      },
      {
        "id": "real-2025-02-05-cz7o3",
        "text": {
          "en": "Proceed with caution only",
          "nl": "Ga alleen voorzichtig verder",
          "ar": "تقدم بحذر فقط"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz7o1",
    "explanation": {
      "en": "Temporary traffic lights in construction zones must be obeyed exactly as you would normal traffic lights. They control traffic flow through the work area.",
      "nl": "Tijdelijke verkeerslichten in bouwzones moeten precies worden nageleefd zoals normale verkeerslichten. Ze regelen de verkeersstroom door het werkgebied.",
      "ar": "يجب الالتزام بإشارات المرور المؤقتة في مناطق البناء تمامًا كما تفعل مع إشارات المرور العادية. إنها تتحكم في تدفق حركة المرور عبر منطقة العمل."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-cz8",
    "text": {
      "en": "You see roadworks ahead. What should you do?",
      "nl": "U ziet wegwerkzaamheden voor u. Wat moet u doen?",
      "ar": "رأيت أعمال طرق أمامك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-cz8o1",
        "text": {
          "en": "Reduce speed and be prepared for changed road conditions",
          "nl": "Verlaag uw snelheid en wees voorbereid op veranderde wegomstandigheden",
          "ar": "قلل من سرعتك وكن مستعدًا لتغيرات ظروف الطريق"
        }
      },
      {
        "id": "real-2025-02-05-cz8o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-cz8o3",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-cz8o1",
    "explanation": {
      "en": "When you see roadworks ahead, reduce speed and be prepared for changed road conditions, lane closures, or workers. Always be extra cautious.",
      "nl": "Wanneer u wegwerkzaamheden voor u ziet, verlaag dan uw snelheid en wees voorbereid op veranderde wegomstandigheden, rijstrooksluitingen of werknemers. Wees altijd extra voorzichtig.",
      "ar": "عندما ترى أعمال الطرق أمامك، قلل من سرعتك وكن مستعدًا لتغيرات ظروف الطريق، وإغلاق المسارات، أو وجود عمال. كن دائمًا حذرًا جدًا."
    },
    "subject": "Construction Zones"
  },
  {
    "id": "real-2025-02-05-wc1",
    "text": {
      "en": "It starts raining while you are driving. What should you do?",
      "nl": "Het begint te regenen terwijl u aan het rijden bent. Wat moet u doen?",
      "ar": "بدأت تمطر أثناء قيادتك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc1o1",
        "text": {
          "en": "Reduce speed and increase following distance",
          "nl": "Verlaag de snelheid en verhoog de volgafstand",
          "ar": "تقليل السرعة وزيادة المسافة التالية"
        }
      },
      {
        "id": "real-2025-02-05-wc1o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-wc1o3",
        "text": {
          "en": "Stop immediately",
          "nl": "Stop onmiddellijk",
          "ar": "توقف على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc1o1",
    "explanation": {
      "en": "In rain, you must reduce speed and increase following distance. Rain reduces visibility and increases stopping distances. Adjust your driving to the conditions.",
      "nl": "Bij regen moet je je snelheid verminderen en de volgafstand vergroten. Regen vermindert de zichtbaarheid en vergroot de remweg. Pas je rijgedrag aan de omstandigheden aan.",
      "ar": "في المطر، يجب عليك تقليل السرعة وزيادة مسافة التتبع. المطر يقلل من الرؤية ويزيد من مسافات التوقف. قم بضبط قيادتك وفقًا للظروف."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc2",
    "text": {
      "en": "You are driving in heavy rain. What is the most important thing to do?",
      "nl": "Je rijdt in zware regen. Wat is het belangrijkste om te doen?",
      "ar": "أنت تقود في مطر غزير. ما هو الشيء الأكثر أهمية الذي يجب القيام به؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc2o1",
        "text": {
          "en": "Reduce speed significantly and increase following distance",
          "nl": "Verminder de snelheid aanzienlijk en vergroot de volgafstand",
          "ar": "قلل السرعة بشكل كبير وزد مسافة التتبع"
        }
      },
      {
        "id": "real-2025-02-05-wc2o2",
        "text": {
          "en": "Use high beam headlights",
          "nl": "Gebruik grootlicht",
          "ar": "استخدم المصابيح العالية"
        }
      },
      {
        "id": "real-2025-02-05-wc2o3",
        "text": {
          "en": "Continue at normal speed",
          "nl": "Ga door met normale snelheid",
          "ar": "استمر بسرعة طبيعية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc2o1",
    "explanation": {
      "en": "In heavy rain, the most important thing is to reduce speed significantly and increase following distance. Heavy rain severely reduces visibility and road grip.",
      "nl": "Bij zware regen is het belangrijkste om de snelheid aanzienlijk te verminderen en de volgafstand te vergroten. Zware regen vermindert de zichtbaarheid en grip op de weg ernstig.",
      "ar": "في المطر الغزير، فإن الشيء الأكثر أهمية هو تقليل السرعة بشكل كبير وزيادة مسافة التتبع. المطر الغزير يقلل بشكل كبير من الرؤية والتمسك بالطريق."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc3",
    "text": {
      "en": "You are driving in fog. What should you do?",
      "nl": "Je rijdt in de mist. Wat moet je doen?",
      "ar": "أنت تقود في الضباب. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc3o1",
        "text": {
          "en": "Reduce speed, use low beam headlights, and increase following distance",
          "nl": "Verminder de snelheid, gebruik dimlichten en vergroot de volgafstand",
          "ar": "قلل السرعة، واستخدم المصابيح المنخفضة، وزد مسافة التتبع"
        }
      },
      {
        "id": "real-2025-02-05-wc3o2",
        "text": {
          "en": "Use high beam headlights",
          "nl": "Gebruik grootlicht",
          "ar": "استخدم المصابيح العالية"
        }
      },
      {
        "id": "real-2025-02-05-wc3o3",
        "text": {
          "en": "Continue at normal speed",
          "nl": "Ga door met normale snelheid",
          "ar": "استمر بسرعة طبيعية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc3o1",
    "explanation": {
      "en": "In fog, reduce speed, use low beam headlights (high beam reflects off fog and reduces visibility), and increase following distance. Fog severely reduces visibility.",
      "nl": "In de mist moet je de snelheid verminderen, dimlichten gebruiken (grootlicht weerkaatst op de mist en vermindert de zichtbaarheid) en de volgafstand vergroten. Mist vermindert de zichtbaarheid ernstig.",
      "ar": "في الضباب، قلل السرعة، واستخدم المصابيح المنخفضة (المصابيح العالية تنعكس على الضباب وتقلل من الرؤية)، وزد مسافة التتبع. الضباب يقلل بشكل كبير من الرؤية."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc4",
    "text": {
      "en": "You are driving and it starts snowing. What should you do?",
      "nl": "Je rijdt en het begint te sneeuwen. Wat moet je doen?",
      "ar": "أنت تقود وبدأ الثلج يتساقط. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc4o1",
        "text": {
          "en": "Reduce speed significantly and drive very carefully",
          "nl": "Verminder de snelheid aanzienlijk en rij heel voorzichtig",
          "ar": "قلل السرعة بشكل كبير وكن حذرًا جدًا في القيادة"
        }
      },
      {
        "id": "real-2025-02-05-wc4o2",
        "text": {
          "en": "Continue at normal speed",
          "nl": "Ga door met normale snelheid",
          "ar": "استمر بسرعة طبيعية"
        }
      },
      {
        "id": "real-2025-02-05-wc4o3",
        "text": {
          "en": "Increase speed to get through quickly",
          "nl": "Verhoog de snelheid om snel door te gaan",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc4o1",
    "explanation": {
      "en": "In snow, you must reduce speed significantly and drive very carefully. Snow reduces visibility, road grip, and increases stopping distances dramatically.",
      "nl": "Bij sneeuw moet je de snelheid aanzienlijk verminderen en heel voorzichtig rijden. Sneeuw vermindert de zichtbaarheid, grip op de weg en vergroot de remweg dramatisch.",
      "ar": "في الثلج، يجب عليك تقليل السرعة بشكل كبير والقيادة بحذر شديد. الثلج يقلل من الرؤية، والتمسك بالطريق، ويزيد بشكل كبير من مسافات التوقف."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc5",
    "text": {
      "en": "You are driving in strong winds. What should you be aware of?",
      "nl": "Je rijdt in sterke wind. Waar moet je op letten?",
      "ar": "أنت تقود في رياح قوية. ماذا يجب أن تكون واعيًا له؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc5o1",
        "text": {
          "en": "Wind can affect vehicle stability, especially for high vehicles and motorcycles",
          "nl": "Wind kan de stabiliteit van voertuigen beïnvloeden, vooral voor hoge voertuigen en motorfietsen.",
          "ar": "يمكن أن تؤثر الرياح على استقرار المركبة، خاصةً للمركبات العالية والدراجات النارية."
        }
      },
      {
        "id": "real-2025-02-05-wc5o2",
        "text": {
          "en": "Wind has no effect on driving",
          "nl": "Wind heeft geen invloed op het rijden.",
          "ar": "الرياح ليس لها تأثير على القيادة."
        }
      },
      {
        "id": "real-2025-02-05-wc5o3",
        "text": {
          "en": "Only speed is affected",
          "nl": "Alleen de snelheid is beïnvloed.",
          "ar": "فقط السرعة هي المتأثرة."
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc5o1",
    "explanation": {
      "en": "Strong winds can affect vehicle stability, especially for high vehicles, motorcycles, and when overtaking. Reduce speed and be extra cautious in strong winds.",
      "nl": "Sterke winden kunnen de stabiliteit van voertuigen beïnvloeden, vooral voor hoge voertuigen, motorfietsen en bij het inhalen. Verminder snelheid en wees extra voorzichtig bij sterke winden.",
      "ar": "يمكن أن تؤثر الرياح القوية على استقرار المركبة، خاصةً للمركبات العالية والدراجات النارية وعند التجاوز. قلل السرعة وكن حذرًا بشكل إضافي في الرياح القوية."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc6",
    "text": {
      "en": "You are driving in icy conditions. What is the most important thing?",
      "nl": "Je rijdt in ijzige omstandigheden. Wat is het belangrijkste?",
      "ar": "أنت تقود في ظروف جليدية. ما هو الشيء الأكثر أهمية؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc6o1",
        "text": {
          "en": "Reduce speed significantly and drive very smoothly",
          "nl": "Verminder de snelheid aanzienlijk en rij zeer soepel.",
          "ar": "قلل السرعة بشكل كبير وقيادة بسلاسة."
        }
      },
      {
        "id": "real-2025-02-05-wc6o2",
        "text": {
          "en": "Use high beam headlights",
          "nl": "Gebruik grootlicht",
          "ar": "استخدم المصابيح العالية"
        }
      },
      {
        "id": "real-2025-02-05-wc6o3",
        "text": {
          "en": "Brake hard when needed",
          "nl": "Rem hard wanneer nodig.",
          "ar": "اضغط على الفرامل بقوة عند الحاجة."
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc6o1",
    "explanation": {
      "en": "In icy conditions, reduce speed significantly and drive very smoothly. Avoid sudden steering, braking, or acceleration. Ice dramatically reduces road grip.",
      "nl": "In ijzige omstandigheden moet je de snelheid aanzienlijk verminderen en zeer soepel rijden. Vermijd plotselinge stuurbewegingen, remmen of accelereren. IJs vermindert de grip op de weg dramatisch.",
      "ar": "في الظروف الجليدية، قلل السرعة بشكل كبير وقيادة بسلاسة. تجنب التوجيه المفاجئ أو الكبح أو التسارع. الجليد يقلل بشكل كبير من تماسك الطريق."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc7",
    "text": {
      "en": "You are driving and visibility is reduced due to weather. What should you do?",
      "nl": "Je rijdt en de zichtbaarheid is verminderd door het weer. Wat moet je doen?",
      "ar": "أنت تقود والرؤية محدودة بسبب الطقس. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc7o1",
        "text": {
          "en": "Reduce speed to match visibility conditions",
          "nl": "Verminder de snelheid om aan de zichtbaarheidseisen te voldoen.",
          "ar": "قلل السرعة لتتناسب مع ظروف الرؤية."
        }
      },
      {
        "id": "real-2025-02-05-wc7o2",
        "text": {
          "en": "Continue at normal speed",
          "nl": "Ga door met normale snelheid",
          "ar": "استمر بسرعة طبيعية"
        }
      },
      {
        "id": "real-2025-02-05-wc7o3",
        "text": {
          "en": "Use hazard lights and continue",
          "nl": "Gebruik de gevarendriehoek en ga door.",
          "ar": "استخدم أضواء التحذير واستمر."
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc7o1",
    "explanation": {
      "en": "When visibility is reduced due to weather, you must reduce speed to match the visibility conditions. Never drive faster than you can see ahead safely.",
      "nl": "Wanneer de zichtbaarheid door het weer is verminderd, moet je de snelheid verminderen om aan de zichtbaarheidseisen te voldoen. Rijd nooit sneller dan je veilig vooruit kunt zien.",
      "ar": "عندما تكون الرؤية محدودة بسبب الطقس، يجب عليك تقليل السرعة لتتناسب مع ظروف الرؤية. لا تقود أبدًا أسرع مما يمكنك رؤيته بأمان."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-wc8",
    "text": {
      "en": "You are driving in wet conditions after rain. What should you be aware of?",
      "nl": "Je rijdt in natte omstandigheden na regen. Waar moet je op letten?",
      "ar": "أنت تقود في ظروف رطبة بعد المطر. ماذا يجب أن تكون على علم به؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-wc8o1",
        "text": {
          "en": "Roads may be slippery, especially at the start of rain",
          "nl": "De wegen kunnen glad zijn, vooral aan het begin van de regen",
          "ar": "قد تكون الطرق زلقة، خاصة في بداية المطر"
        }
      },
      {
        "id": "real-2025-02-05-wc8o2",
        "text": {
          "en": "Roads are always safe after rain",
          "nl": "De wegen zijn altijd veilig na de regen",
          "ar": "الطرق آمنة دائمًا بعد المطر"
        }
      },
      {
        "id": "real-2025-02-05-wc8o3",
        "text": {
          "en": "Only visibility is affected",
          "nl": "Alleen de zichtbaarheid is aangetast",
          "ar": "فقط الرؤية تتأثر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-wc8o1",
    "explanation": {
      "en": "After rain starts, roads can be especially slippery as oil and dirt mix with water. Reduce speed and be extra cautious, especially in the first minutes of rain.",
      "nl": "Na de start van de regen kunnen wegen bijzonder glad zijn omdat olie en vuil met water mengen. Verminder de snelheid en wees extra voorzichtig, vooral in de eerste minuten van de regen.",
      "ar": "بعد بدء المطر، يمكن أن تكون الطرق زلقة بشكل خاص حيث تختلط الزيوت والأوساخ بالماء. قلل السرعة وكن حذرًا بشكل إضافي، خاصةً في الدقائق الأولى من المطر."
    },
    "subject": "Weather Conditions"
  },
  {
    "id": "real-2025-02-05-sr1",
    "text": {
      "en": "You are driving and see children playing near the road. What should you do?",
      "nl": "Je rijdt en ziet kinderen spelen nabij de weg. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى أطفالًا يلعبون بالقرب من الطريق. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr1o1",
        "text": {
          "en": "Reduce speed and be extra cautious",
          "nl": "Verlaag de snelheid en wees extra voorzichtig",
          "ar": "قلل السرعة وكن حذرًا للغاية"
        }
      },
      {
        "id": "real-2025-02-05-sr1o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-sr1o3",
        "text": {
          "en": "Sound your horn to warn them",
          "nl": "Toet je claxon om hen te waarschuwen",
          "ar": "استخدم بوق السيارة لتحذيرهم"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr1o1",
    "explanation": {
      "en": "When children are playing near the road, you must reduce speed and be extra cautious. Children may behave unpredictably and may not be aware of traffic dangers.",
      "nl": "Wanneer kinderen nabij de weg spelen, moet je je snelheid verminderen en extra voorzichtig zijn. Kinderen kunnen onvoorspelbaar gedrag vertonen en zich niet bewust zijn van verkeersgevaar.",
      "ar": "عندما يلعب الأطفال بالقرب من الطريق، يجب عليك تقليل السرعة وكونك حذرًا بشكل إضافي. قد يتصرف الأطفال بشكل غير متوقع وقد لا يكونون على دراية بمخاطر المرور."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr2",
    "text": {
      "en": "You are driving and see an elderly pedestrian crossing slowly. What should you do?",
      "nl": "Je rijdt en ziet een oudere voetganger langzaam oversteken. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى شخصًا مسنًا يعبر ببطء. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr2o1",
        "text": {
          "en": "Wait patiently and give them extra time",
          "nl": "Wacht geduldig en geef ze extra tijd",
          "ar": "انتظر بصبر وامنحهم وقتًا إضافيًا"
        }
      },
      {
        "id": "real-2025-02-05-sr2o2",
        "text": {
          "en": "Sound your horn to hurry them",
          "nl": "Toet je claxon om hen te haasten",
          "ar": "استخدم بوق السيارة لتسريعهم"
        }
      },
      {
        "id": "real-2025-02-05-sr2o3",
        "text": {
          "en": "Proceed if you can pass safely",
          "nl": "Ga door als je veilig kunt passeren",
          "ar": "تابع إذا كنت تستطيع المرور بأمان"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr2o1",
    "explanation": {
      "en": "When elderly pedestrians are crossing, wait patiently and give them extra time. They may move more slowly and need more time to cross safely.",
      "nl": "Wanneer oudere voetgangers oversteken, wacht geduldig en geef ze extra tijd. Ze kunnen langzamer bewegen en meer tijd nodig hebben om veilig over te steken.",
      "ar": "عندما يعبر المشاة المسنون، انتظر بصبر وامنحهم وقتًا إضافيًا. قد يتحركون ببطء أكبر ويحتاجون إلى مزيد من الوقت لعبور الطريق بأمان."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr3",
    "text": {
      "en": "You are driving and see a school bus stopped with flashing lights. What should you do?",
      "nl": "Je rijdt en ziet een schoolbus die stopt met knipperende lichten. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى حافلة مدرسية متوقفة مع أضواء وامضة. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr3o1",
        "text": {
          "en": "Stop and wait until the bus moves or lights stop flashing",
          "nl": "Stop en wacht totdat de bus weer rijdt of de lichten stoppen met knipperen",
          "ar": "توقف وانتظر حتى تتحرك الحافلة أو تتوقف الأضواء عن الوميض"
        }
      },
      {
        "id": "real-2025-02-05-sr3o2",
        "text": {
          "en": "Continue at reduced speed",
          "nl": "Ga door met verminderde snelheid",
          "ar": "استمر بسرعة منخفضة"
        }
      },
      {
        "id": "real-2025-02-05-sr3o3",
        "text": {
          "en": "Overtake the bus carefully",
          "nl": "Overschrijd de bus voorzichtig",
          "ar": "تجاوز الحافلة بحذر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr3o1",
    "explanation": {
      "en": "When a school bus is stopped with flashing lights, you must stop and wait until the bus moves or the lights stop flashing. Children may be boarding or alighting.",
      "nl": "Wanneer een schoolbus stopt met knipperende lichten, moet je stoppen en wachten totdat de bus weer rijdt of de lichten stoppen met knipperen. Kinderen kunnen in- of uitstappen.",
      "ar": "عندما تتوقف حافلة مدرسية مع أضواء وامضة، يجب عليك التوقف والانتظار حتى تتحرك الحافلة أو تتوقف الأضواء عن الوميض. قد يكون الأطفال في طريقهم للصعود أو النزول."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr4",
    "text": {
      "en": "You are driving and see a disabled person crossing. What should you do?",
      "nl": "Je rijdt en ziet een persoon met een handicap oversteken. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى شخصًا معاقًا يعبر. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr4o1",
        "text": {
          "en": "Wait patiently and give them extra time",
          "nl": "Wacht geduldig en geef ze extra tijd",
          "ar": "انتظر بصبر وامنحهم وقتًا إضافيًا"
        }
      },
      {
        "id": "real-2025-02-05-sr4o2",
        "text": {
          "en": "Sound your horn",
          "nl": "Laat je claxon klinken",
          "ar": "\"إضغط بوق سفينتك\""
        }
      },
      {
        "id": "real-2025-02-05-sr4o3",
        "text": {
          "en": "Proceed if you can pass safely",
          "nl": "Ga door als je veilig kunt passeren",
          "ar": "تابع إذا كنت تستطيع المرور بأمان"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr4o1",
    "explanation": {
      "en": "When disabled persons are crossing, wait patiently and give them extra time. They may need more time to cross safely and should not be rushed.",
      "nl": "Wanneer personen met een handicap oversteken, wacht geduldig en geef ze extra tijd. Ze hebben misschien meer tijd nodig om veilig over te steken en mogen niet worden opgejaagd.",
      "ar": "عندما يعبر الأشخاص ذوو الإعاقة، انتظر بصبر وامنحهم وقتًا إضافيًا. قد يحتاجون إلى مزيد من الوقت لعبور الطريق بأمان ولا ينبغي التعجل بهم."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr5",
    "text": {
      "en": "You are driving and see an animal on the road. What should you do?",
      "nl": "Je rijdt en ziet een dier op de weg. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى حيوانًا على الطريق. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr5o1",
        "text": {
          "en": "Reduce speed and be prepared to stop if necessary",
          "nl": "Verlaag de snelheid en wees bereid om te stoppen indien nodig",
          "ar": "قلل من السرعة وكن مستعدًا للتوقف إذا لزم الأمر"
        }
      },
      {
        "id": "real-2025-02-05-sr5o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-sr5o3",
        "text": {
          "en": "Sound your horn to scare it away",
          "nl": "Toet je claxon om het weg te jagen",
          "ar": "استخدم بوق السيارة لطرده"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr5o1",
    "explanation": {
      "en": "When you see an animal on the road, reduce speed and be prepared to stop if necessary. Animals can be unpredictable and may suddenly move into your path.",
      "nl": "Wanneer je een dier op de weg ziet, verlaag dan je snelheid en wees bereid om te stoppen indien nodig. Dieren kunnen onvoorspelbaar zijn en kunnen plotseling in je pad bewegen.",
      "ar": "عندما ترى حيوانًا على الطريق، قلل من سرعتك وكن مستعدًا للتوقف إذا لزم الأمر. يمكن أن تكون الحيوانات غير متوقعة وقد تتحرك فجأة إلى مسارك."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr6",
    "text": {
      "en": "You are driving at night. What is the most important safety consideration?",
      "nl": "Je rijdt 's nachts. Wat is de belangrijkste veiligheidsoverweging?",
      "ar": "أنت تقود السيارة في الليل. ما هو أهم اعتبار للسلامة؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr6o1",
        "text": {
          "en": "Reduced visibility requires extra caution and appropriate speed",
          "nl": "Verminderde zichtbaarheid vereist extra voorzichtigheid en een geschikte snelheid",
          "ar": "تتطلب الرؤية المحدودة مزيدًا من الحذر وسرعة مناسبة"
        }
      },
      {
        "id": "real-2025-02-05-sr6o2",
        "text": {
          "en": "Speed limits are higher at night",
          "nl": "De snelheidslimieten zijn hoger 's nachts",
          "ar": "حدود السرعة أعلى في الليل"
        }
      },
      {
        "id": "real-2025-02-05-sr6o3",
        "text": {
          "en": "No special considerations needed",
          "nl": "Geen speciale overwegingen nodig",
          "ar": "لا حاجة لاعتبارات خاصة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr6o1",
    "explanation": {
      "en": "At night, reduced visibility is the most important safety consideration. You must drive at an appropriate speed for the conditions and use headlights properly.",
      "nl": "In de nacht is verminderde zichtbaarheid de belangrijkste veiligheidsoverweging. Je moet met een geschikte snelheid voor de omstandigheden rijden en de koplampen goed gebruiken.",
      "ar": "في الليل، تعتبر الرؤية المحدودة أهم اعتبار للسلامة. يجب أن تقود بسرعة مناسبة للظروف وأن تستخدم المصابيح الأمامية بشكل صحيح."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr7",
    "text": {
      "en": "You are driving and see a vehicle with hazard lights on. What should you do?",
      "nl": "Je rijdt en ziet een voertuig met waarschuwingslichten aan. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى مركبة بها أضواء التحذير. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr7o1",
        "text": {
          "en": "Be extra cautious and prepared for unexpected behavior",
          "nl": "Wees extra voorzichtig en voorbereid op onverwacht gedrag",
          "ar": "كن حذرًا جدًا واستعد لسلوك غير متوقع"
        }
      },
      {
        "id": "real-2025-02-05-sr7o2",
        "text": {
          "en": "Ignore the hazard lights",
          "nl": "Negeer de waarschuwingslichten",
          "ar": "تجاهل أضواء التحذير"
        }
      },
      {
        "id": "real-2025-02-05-sr7o3",
        "text": {
          "en": "Overtake immediately",
          "nl": "Onmiddellijk inhalen",
          "ar": "التجاوز على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr7o1",
    "explanation": {
      "en": "When a vehicle has hazard lights on, it indicates a problem or emergency situation. Be extra cautious and prepared for unexpected behavior from that vehicle.",
      "nl": "Wanneer een voertuig waarschuwingslichten aan heeft, duidt dit op een probleem of noodsituatie. Wees extra voorzichtig en voorbereid op onverwacht gedrag van dat voertuig.",
      "ar": "عندما تكون أضواء التحذير مضاءة في مركبة، فهذا يدل على وجود مشكلة أو حالة طوارئ. كن حذرًا جدًا واستعد لسلوك غير متوقع من تلك المركبة."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-sr8",
    "text": {
      "en": "You are driving and see a vehicle stopped on the hard shoulder. What should you do?",
      "nl": "Je rijdt en ziet een voertuig dat op de vluchtstrook is gestopt. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى مركبة متوقفة على جانب الطريق. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-sr8o1",
        "text": {
          "en": "Continue normally but be aware they may re-enter traffic",
          "nl": "Ga normaal door maar wees je ervan bewust dat ze weer de weg op kunnen komen.",
          "ar": "استمر بشكل طبيعي ولكن كن واعيًا أنهم قد يعودون إلى حركة المرور."
        }
      },
      {
        "id": "real-2025-02-05-sr8o2",
        "text": {
          "en": "Stop and help",
          "nl": "Stop en help",
          "ar": "توقف وساعد"
        }
      },
      {
        "id": "real-2025-02-05-sr8o3",
        "text": {
          "en": "Change lanes immediately",
          "nl": "Onmiddellijk van rijstrook veranderen",
          "ar": "قم بتغيير المسارات على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-sr8o1",
    "explanation": {
      "en": "When a vehicle is stopped on the hard shoulder, continue normally but be aware they may re-enter traffic. Do not stop unless it is an emergency.",
      "nl": "Wanneer een voertuig op de vluchtstrook is gestopt, ga normaal door maar wees je ervan bewust dat ze weer de weg op kunnen komen. Stop niet tenzij het een noodgeval is.",
      "ar": "عندما يتوقف مركبة على جانب الطريق، استمر بشكل طبيعي ولكن كن واعيًا أنهم قد يعودون إلى حركة المرور. لا تتوقف إلا إذا كان ذلك طارئًا."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-ws1",
    "text": {
      "en": "You see a warning sign with a triangular shape and red border. What does this indicate?",
      "nl": "Je ziet een waarschuwingsbord met een driehoekige vorm en rode rand. Wat geeft dit aan?",
      "ar": "ترى علامة تحذيرية بشكل مثلث وحدود حمراء. ماذا يشير هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws1o1",
        "text": {
          "en": "A potential hazard ahead",
          "nl": "Een potentiële gevaren voor je",
          "ar": "خطر محتمل في الأمام"
        }
      },
      {
        "id": "real-2025-02-05-ws1o2",
        "text": {
          "en": "A prohibition",
          "nl": "Een verbod",
          "ar": "منع"
        }
      },
      {
        "id": "real-2025-02-05-ws1o3",
        "text": {
          "en": "A mandatory direction",
          "nl": "Een verplichte richting",
          "ar": "اتجاه إلزامي"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws1o1",
    "explanation": {
      "en": "Triangular signs with red borders are warning signs. They warn you about potential hazards ahead. Look at the symbol on the sign to identify the specific hazard.",
      "nl": "Driehoekige borden met rode randen zijn waarschuwingsborden. Ze waarschuwen je voor mogelijke gevaren voor je. Kijk naar het symbool op het bord om het specifieke gevaar te identificeren.",
      "ar": "العلامات المثلثية ذات الحدود الحمراء هي علامات تحذيرية. إنها تحذرك من المخاطر المحتملة في الأمام. انظر إلى الرمز على الإشارة لتحديد الخطر المحدد."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws2",
    "text": {
      "en": "You see a warning sign for a sharp bend. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een scherpe bocht. Wat moet je doen?",
      "ar": "ترى علامة تحذيرية لمنعطف حاد. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws2o1",
        "text": {
          "en": "Reduce speed and be prepared for the bend",
          "nl": "Verminder snelheid en wees voorbereid op de bocht.",
          "ar": "قلل السرعة وكن مستعدًا للمنعطف."
        }
      },
      {
        "id": "real-2025-02-05-ws2o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws2o3",
        "text": {
          "en": "Increase speed to pass quickly",
          "nl": "Verhoog de snelheid om snel te passeren",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws2o1",
    "explanation": {
      "en": "Warning signs for sharp bends require you to reduce speed and be prepared for the bend ahead. Adjust your speed before entering the bend.",
      "nl": "Waarschuwingsborden voor scherpe bochten vereisen dat je je snelheid vermindert en voorbereid bent op de bocht die komt. Pas je snelheid aan voordat je de bocht ingaat.",
      "ar": "تتطلب علامات التحذير للمنعطفات الحادة أن تقلل من سرعتك وأن تكون مستعدًا للمنعطف القادم. قم بتعديل سرعتك قبل دخول المنعطف."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws3",
    "text": {
      "en": "You see a warning sign for a junction ahead. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een kruising voor je. Wat moet je doen?",
      "ar": "ترى علامة تحذيرية لتقاطع أمامك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws3o1",
        "text": {
          "en": "Be prepared for traffic from side roads",
          "nl": "Wees voorbereid op verkeer van zijwegen.",
          "ar": "كن مستعدًا لحركة المرور من الطرق الجانبية."
        }
      },
      {
        "id": "real-2025-02-05-ws3o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws3o3",
        "text": {
          "en": "Stop immediately",
          "nl": "Stop onmiddellijk",
          "ar": "توقف على الفور"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws3o1",
    "explanation": {
      "en": "Warning signs for junctions ahead require you to be prepared for traffic from side roads. Reduce speed and be ready to give way if necessary.",
      "nl": "Waarschuwingsborden voor kruisingen vereisen dat je voorbereid bent op verkeer van zijwegen. Verminder snelheid en wees bereid om voorrang te verlenen indien nodig.",
      "ar": "تتطلب علامات التحذير للتقاطعات أن تكون مستعدًا لحركة المرور من الطرق الجانبية. قلل السرعة وكن مستعدًا لمنح الأولوية إذا لزم الأمر."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws4",
    "text": {
      "en": "You see a warning sign for a steep hill. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een steile heuvel. Wat moet je doen?",
      "ar": "ترى علامة تحذيرية لتل شديد الانحدار. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws4o1",
        "text": {
          "en": "Reduce speed and be prepared for the gradient",
          "nl": "Verminder snelheid en wees voorbereid op de helling.",
          "ar": "قلل السرعة وكن مستعدًا للانحدار."
        }
      },
      {
        "id": "real-2025-02-05-ws4o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws4o3",
        "text": {
          "en": "Increase speed to climb the hill",
          "nl": "Verhoog de snelheid om de heuvel op te rijden",
          "ar": "زد السرعة لتسلق التل"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws4o1",
    "explanation": {
      "en": "Warning signs for steep hills require you to reduce speed and be prepared for the gradient. Steep hills can affect vehicle performance and control.",
      "nl": "Waarschuwingsborden voor steile heuvels vereisen dat je je snelheid vermindert en voorbereid bent op de helling. Steile heuvels kunnen de prestaties en controle van het voertuig beïnvloeden.",
      "ar": "تتطلب علامات التحذير للتلال الشديدة الانحدار أن تقلل من سرعتك وأن تكون مستعدًا للانحدار. يمكن أن تؤثر التلال الشديدة على أداء السيارة والتحكم فيها."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws5",
    "text": {
      "en": "You see a warning sign for a slippery road. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een gladde weg. Wat moet je doen?",
      "ar": "ترى علامة تحذير لطريق زلق. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws5o1",
        "text": {
          "en": "Reduce speed and drive very carefully",
          "nl": "Verminder snelheid en rij heel voorzichtig",
          "ar": "قلل السرعة وكن حذرًا جدًا"
        }
      },
      {
        "id": "real-2025-02-05-ws5o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws5o3",
        "text": {
          "en": "Use hazard lights",
          "nl": "Gebruik de gevarendriehoek",
          "ar": "استخدم أضواء التحذير"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws5o1",
    "explanation": {
      "en": "Warning signs for slippery roads require you to reduce speed and drive very carefully. Slippery conditions dramatically reduce road grip and increase stopping distances.",
      "nl": "Waarschuwingsborden voor gladde wegen vereisen dat je de snelheid vermindert en heel voorzichtig rijdt. Gladheid vermindert de grip op de weg en vergroot de remweg aanzienlijk.",
      "ar": "تتطلب علامات التحذير للطريق الزلق تقليل السرعة والقيادة بحذر شديد. الظروف الزلقة تقلل بشكل كبير من تماسك الطريق وتزيد من مسافات التوقف."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws6",
    "text": {
      "en": "You see a warning sign for wild animals. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor wilde dieren. Wat moet je doen?",
      "ar": "ترى علامة تحذير للحيوانات البرية. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws6o1",
        "text": {
          "en": "Be extra cautious, especially at dawn and dusk",
          "nl": "Wees extra voorzichtig, vooral bij zonsopgang en zonsondergang",
          "ar": "كن حذرًا بشكل إضافي، خاصة عند الفجر والغسق"
        }
      },
      {
        "id": "real-2025-02-05-ws6o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws6o3",
        "text": {
          "en": "Sound your horn continuously",
          "nl": "Toet je continu op de claxon",
          "ar": "اضغط على بوق السيارة باستمرار"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws6o1",
    "explanation": {
      "en": "Warning signs for wild animals require you to be extra cautious, especially at dawn and dusk when animals are most active. Reduce speed and be prepared to stop.",
      "nl": "Waarschuwingsborden voor wilde dieren vereisen dat je extra voorzichtig bent, vooral bij zonsopgang en zonsondergang wanneer dieren het meest actief zijn. Verminder snelheid en wees voorbereid om te stoppen.",
      "ar": "تتطلب علامات التحذير للحيوانات البرية أن تكون حذرًا بشكل إضافي، خاصة عند الفجر والغسق عندما تكون الحيوانات أكثر نشاطًا. قلل السرعة وكن مستعدًا للتوقف."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws7",
    "text": {
      "en": "You see a warning sign for a level crossing. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een spoorwegovergang. Wat moet je doen?",
      "ar": "ترى علامة تحذير لعبور السكك الحديدية. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws7o1",
        "text": {
          "en": "Be prepared to stop if a train is approaching",
          "nl": "Wees voorbereid om te stoppen als er een trein aankomt",
          "ar": "كن مستعدًا للتوقف إذا كانت القطار قادمًا"
        }
      },
      {
        "id": "real-2025-02-05-ws7o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws7o3",
        "text": {
          "en": "Increase speed to cross quickly",
          "nl": "Verhoog de snelheid om snel over te steken",
          "ar": "زد السرعة لتقطع بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws7o1",
    "explanation": {
      "en": "Warning signs for level crossings require you to be prepared to stop if a train is approaching. Never cross when warning lights are flashing or barriers are down.",
      "nl": "Waarschuwingsborden voor spoorwegovergangen vereisen dat je voorbereid bent om te stoppen als er een trein aankomt. Steek nooit over als de waarschuwingslichten knipperen of als de hekken omlaag zijn.",
      "ar": "تتطلب علامات التحذير لعبور السكك الحديدية أن تكون مستعدًا للتوقف إذا كانت القطار قادمًا. لا تعبر أبدًا عندما تكون الأضواء التحذيرية تومض أو عندما تكون الحواجز مغلقة."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ws8",
    "text": {
      "en": "You see a warning sign for a roundabout ahead. What should you do?",
      "nl": "Je ziet een waarschuwingsbord voor een rotonde voor je. Wat moet je doen?",
      "ar": "ترى علامة تحذير لدائرة أمامك. ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ws8o1",
        "text": {
          "en": "Be prepared to give way to traffic on the roundabout",
          "nl": "Wees voorbereid om voorrang te geven aan verkeer op de rotonde",
          "ar": "كن مستعدًا لمنح الأولوية لحركة المرور على الدائرة"
        }
      },
      {
        "id": "real-2025-02-05-ws8o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-ws8o3",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ws8o1",
    "explanation": {
      "en": "Warning signs for roundabouts ahead require you to be prepared to give way to traffic already on the roundabout. Reduce speed and be ready to stop if necessary.",
      "nl": "Waarschuwingsborden voor rotondes vereisen dat je voorbereid bent om voorrang te geven aan verkeer dat al op de rotonde is. Verminder snelheid en wees klaar om te stoppen indien nodig.",
      "ar": "تتطلب علامات التحذير من الدوارات القادمة أن تكون مستعدًا لمنح الأولوية لحركة المرور الموجودة بالفعل على الدائرة. قلل السرعة وكن مستعدًا للتوقف إذا لزم الأمر."
    },
    "subject": "Warning Signs"
  },
  {
    "id": "real-2025-02-05-ps1",
    "text": {
      "en": "You see a red circular sign with a diagonal line. What does this mean?",
      "nl": "Je ziet een rood rond bord met een diagonale lijn. Wat betekent dit?",
      "ar": "ترى علامة دائرية حمراء مع خط مائل. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps1o1",
        "text": {
          "en": "The action or vehicle shown is prohibited",
          "nl": "De actie of het voertuig dat wordt weergegeven is verboden",
          "ar": "الإجراء أو السيارة المعروضة محظورة"
        }
      },
      {
        "id": "real-2025-02-05-ps1o2",
        "text": {
          "en": "The action shown is recommended",
          "nl": "De getoonde actie is aanbevolen",
          "ar": "الإجراء المعروض موصى به"
        }
      },
      {
        "id": "real-2025-02-05-ps1o3",
        "text": {
          "en": "The action shown is optional",
          "nl": "De getoonde actie is optioneel",
          "ar": "الإجراء المعروض اختياري"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps1o1",
    "explanation": {
      "en": "Red circular signs with diagonal lines are prohibitory signs. They indicate that the action or vehicle type shown is prohibited. You must not do what the sign prohibits.",
      "nl": "Rode ronde borden met diagonale lijnen zijn verbodsborden. Ze geven aan dat de actie of het voertuigtype dat wordt weergegeven verboden is. Je mag niet doen wat het bord verbiedt.",
      "ar": "تشير العلامات الدائرية الحمراء ذات الخطوط المائلة إلى أنها علامات ممنوعة. إنها تشير إلى أن الإجراء أو نوع المركبة المعروض محظور. يجب ألا تفعل ما يمنعه العلامة."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps2",
    "text": {
      "en": "You see a \"No Entry\" sign. What does this mean?",
      "nl": "Je ziet een \"Geen Toegang\" bord. Wat betekent dit?",
      "ar": "ترى علامة \"ممنوع الدخول\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps2o1",
        "text": {
          "en": "You must not enter this road",
          "nl": "Je mag deze weg niet betreden",
          "ar": "يجب ألا تدخل هذا الطريق"
        }
      },
      {
        "id": "real-2025-02-05-ps2o2",
        "text": {
          "en": "Entry is allowed with caution",
          "nl": "Toegang is toegestaan met voorzichtigheid",
          "ar": "الدخول مسموح به بحذر"
        }
      },
      {
        "id": "real-2025-02-05-ps2o3",
        "text": {
          "en": "Entry is allowed for residents only",
          "nl": "Toegang is alleen toegestaan voor bewoners",
          "ar": "الدخول مسموح به للسكان فقط"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps2o1",
    "explanation": {
      "en": "A \"No Entry\" sign means you must not enter this road. This is a strict prohibition that applies to all vehicles unless specifically exempted.",
      "nl": "Een \"Geen Toegang\" bord betekent dat je deze weg niet mag betreden. Dit is een strikte verboden die van toepassing is op alle voertuigen, tenzij specifiek vrijgesteld.",
      "ar": "تعني علامة \"ممنوع الدخول\" أنه يجب عليك عدم دخول هذا الطريق. هذا هو حظر صارم ينطبق على جميع المركبات ما لم يتم إعفاؤها بشكل محدد."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps3",
    "text": {
      "en": "You see a \"No Overtaking\" sign. When does this restriction end?",
      "nl": "Je ziet een \"Geen Inhalen\" bord. Wanneer eindigt deze beperking?",
      "ar": "ترى علامة \"ممنوع التجاوز\". متى تنتهي هذه القيود؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps3o1",
        "text": {
          "en": "When you see an \"End of No Overtaking\" sign",
          "nl": "Wanneer je een \"Einde van Geen Inhalen\" bord ziet",
          "ar": "عندما ترى علامة \"نهاية ممنوع التجاوز\""
        }
      },
      {
        "id": "real-2025-02-05-ps3o2",
        "text": {
          "en": "After 100 meters",
          "nl": "Na 100 meter",
          "ar": "بعد 100 متر"
        }
      },
      {
        "id": "real-2025-02-05-ps3o3",
        "text": {
          "en": "At the next junction",
          "nl": "Bij het volgende kruispunt",
          "ar": "عند التقاطع التالي"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps3o1",
    "explanation": {
      "en": "A \"No Overtaking\" restriction applies until you see an \"End of No Overtaking\" sign. The restriction does not end automatically at a distance or junction.",
      "nl": "Een \"Geen Inhalen\" beperking geldt totdat je een \"Einde van Geen Inhalen\" bord ziet. De beperking eindigt niet automatisch bij een afstand of kruispunt.",
      "ar": "تنطبق قيود \"ممنوع التجاوز\" حتى ترى علامة \"نهاية ممنوع التجاوز\". لا تنتهي القيود تلقائيًا عند مسافة أو تقاطع."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps4",
    "text": {
      "en": "You see a \"No Parking\" sign. What does this mean?",
      "nl": "U ziet een \"Geen Parkeren\" bord. Wat betekent dit?",
      "ar": "ترى علامة \"ممنوع الوقوف\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps4o1",
        "text": {
          "en": "Parking is prohibited at all times",
          "nl": "Parkeren is te allen tijde verboden",
          "ar": "الوقوف محظور في جميع الأوقات"
        }
      },
      {
        "id": "real-2025-02-05-ps4o2",
        "text": {
          "en": "Parking is allowed for short periods",
          "nl": "Parkeren is toegestaan voor korte periodes",
          "ar": "الوقوف مسموح لفترات قصيرة"
        }
      },
      {
        "id": "real-2025-02-05-ps4o3",
        "text": {
          "en": "Parking is allowed at night",
          "nl": "Parkeren is toegestaan 's nachts",
          "ar": "الوقوف مسموح في الليل"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps4o1",
    "explanation": {
      "en": "A \"No Parking\" sign means parking is prohibited at all times. This is different from \"No Stopping\" signs, which also prohibit stopping.",
      "nl": "Een \"Geen Parkeren\" bord betekent dat parkeren te allen tijde verboden is. Dit is anders dan \"Geen Stoppen\" borden, die ook het stoppen verbieden.",
      "ar": "علامة \"ممنوع الوقوف\" تعني أن الوقوف محظور في جميع الأوقات. هذا يختلف عن علامات \"ممنوع التوقف\"، التي تحظر أيضًا التوقف."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps5",
    "text": {
      "en": "You see a \"No Stopping\" sign. What does this mean?",
      "nl": "U ziet een \"Geen Stoppen\" bord. Wat betekent dit?",
      "ar": "ترى علامة \"ممنوع التوقف\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps5o1",
        "text": {
          "en": "Stopping is prohibited, even briefly",
          "nl": "Stoppen is verboden, zelfs kort",
          "ar": "التوقف محظور، حتى لفترة قصيرة"
        }
      },
      {
        "id": "real-2025-02-05-ps5o2",
        "text": {
          "en": "Stopping is allowed for loading",
          "nl": "Stoppen is toegestaan voor laden",
          "ar": "التوقف مسموح للتحميل"
        }
      },
      {
        "id": "real-2025-02-05-ps5o3",
        "text": {
          "en": "Stopping is allowed for passengers",
          "nl": "Stoppen is toegestaan voor passagiers",
          "ar": "التوقف مسموح للركاب"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps5o1",
    "explanation": {
      "en": "A \"No Stopping\" sign means stopping is prohibited, even briefly. This is stricter than \"No Parking\" and applies to all stopping, not just parking.",
      "nl": "Een \"Geen Stoppen\" bord betekent dat stoppen verboden is, zelfs kort. Dit is strenger dan \"Geen Parkeren\" en geldt voor alle stoppen, niet alleen parkeren.",
      "ar": "علامة \"ممنوع التوقف\" تعني أن التوقف محظور، حتى لفترة قصيرة. هذا أكثر صرامة من \"ممنوع الوقوف\" وينطبق على جميع التوقفات، وليس فقط الوقوف."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps6",
    "text": {
      "en": "You see a prohibitory sign showing a specific vehicle type. What does this mean?",
      "nl": "U ziet een verbodsbord met een specifiek voertuigtype. Wat betekent dit?",
      "ar": "ترى علامة تحظر نوعًا معينًا من المركبات. ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps6o1",
        "text": {
          "en": "That vehicle type is prohibited from this road",
          "nl": "Dat voertuigtype is verboden op deze weg",
          "ar": "هذا النوع من المركبات محظور على هذه الطريق"
        }
      },
      {
        "id": "real-2025-02-05-ps6o2",
        "text": {
          "en": "All vehicles are prohibited",
          "nl": "Alle voertuigen zijn verboden",
          "ar": "جميع المركبات محظورة"
        }
      },
      {
        "id": "real-2025-02-05-ps6o3",
        "text": {
          "en": "Only that vehicle type is allowed",
          "nl": "Alleen dat voertuigtype is toegestaan",
          "ar": "يسمح فقط بهذا النوع من المركبات"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps6o1",
    "explanation": {
      "en": "Prohibitory signs showing a specific vehicle type mean that vehicle type is prohibited from this road. Other vehicle types may still use the road.",
      "nl": "Verbodsborden die een specifiek voertuigtype tonen, betekenen dat dat voertuigtype verboden is op deze weg. Andere voertuigtypes mogen de weg nog steeds gebruiken.",
      "ar": "تشير العلامات التحذيرية التي تظهر نوعًا معينًا من المركبات إلى أن هذا النوع من المركبات محظور على هذه الطريق. قد لا تزال أنواع المركبات الأخرى تستخدم الطريق."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps7",
    "text": {
      "en": "You see a \"No U-Turn\" sign. What does this mean?",
      "nl": "Je ziet een \"Geen U-bocht\" bord. Wat betekent dit?",
      "ar": "تشاهد علامة \"لا U-turn\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps7o1",
        "text": {
          "en": "U-turns are prohibited",
          "nl": "U-bochten zijn verboden",
          "ar": "U-turns محظورة"
        }
      },
      {
        "id": "real-2025-02-05-ps7o2",
        "text": {
          "en": "U-turns are allowed with caution",
          "nl": "U-bochten zijn toegestaan met voorzichtigheid",
          "ar": "U-turns مسموح بها بحذر"
        }
      },
      {
        "id": "real-2025-02-05-ps7o3",
        "text": {
          "en": "U-turns are allowed at night",
          "nl": "U-bochten zijn toegestaan 's nachts",
          "ar": "U-turns مسموح بها في الليل"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps7o1",
    "explanation": {
      "en": "A \"No U-Turn\" sign means U-turns are prohibited. You must not make a U-turn at this location, regardless of traffic conditions.",
      "nl": "Een \"Geen U-bocht\" bord betekent dat U-bochten verboden zijn. Je mag op deze locatie geen U-bocht maken, ongeacht de verkeersomstandigheden.",
      "ar": "علامة \"لا U-turn\" تعني أن U-turns محظورة. يجب عليك عدم القيام بـ U-turn في هذا الموقع، بغض النظر عن ظروف المرور."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-ps8",
    "text": {
      "en": "You see an \"End of Prohibition\" sign. What does this mean?",
      "nl": "Je ziet een \"Einde van de Verbod\" bord. Wat betekent dit?",
      "ar": "تشاهد علامة \"نهاية الحظر\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-ps8o1",
        "text": {
          "en": "The previous prohibition no longer applies",
          "nl": "Het vorige verbod is niet meer van toepassing",
          "ar": "الحظر السابق لم يعد ساريًا"
        }
      },
      {
        "id": "real-2025-02-05-ps8o2",
        "text": {
          "en": "All prohibitions are lifted",
          "nl": "Alle verboden zijn opgeheven",
          "ar": "تم رفع جميع الحظورات"
        }
      },
      {
        "id": "real-2025-02-05-ps8o3",
        "text": {
          "en": "The prohibition continues",
          "nl": "Het verbod blijft van kracht",
          "ar": "يستمر الحظر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-ps8o1",
    "explanation": {
      "en": "An \"End of Prohibition\" sign means the previous prohibition no longer applies. You may now do what was previously prohibited, subject to other traffic rules.",
      "nl": "Een \"Einde van de Verbod\" bord betekent dat het vorige verbod niet meer van toepassing is. Je mag nu doen wat eerder verboden was, onder voorbehoud van andere verkeersregels.",
      "ar": "علامة \"نهاية الحظر\" تعني أن الحظر السابق لم يعد ساريًا. يمكنك الآن القيام بما كان محظورًا سابقًا، مع مراعاة قواعد المرور الأخرى."
    },
    "subject": "Prohibitory Signs"
  },
  {
    "id": "real-2025-02-05-add1",
    "text": {
      "en": "You are driving and see a \"Yield\" sign. What should you do?",
      "nl": "Je rijdt en ziet een \"Voorrang\" bord. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى علامة \"أعطِ الأولوية\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add1o1",
        "text": {
          "en": "Slow down and give way to traffic on the priority road",
          "nl": "Afremmen en voorrang geven aan het verkeer op de voorrangsweg",
          "ar": "تباطأ وأعطِ الأولوية لحركة المرور على الطريق ذو الأولوية"
        }
      },
      {
        "id": "real-2025-02-05-add1o2",
        "text": {
          "en": "Stop completely",
          "nl": "Volledig stoppen",
          "ar": "التوقف تماما"
        }
      },
      {
        "id": "real-2025-02-05-add1o3",
        "text": {
          "en": "You have priority",
          "nl": "U hebt voorrang",
          "ar": "لديك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add1o1",
    "explanation": {
      "en": "A \"Yield\" sign (Give Way sign) means you must slow down and give way to traffic on the priority road. You do not need to stop completely unless necessary.",
      "nl": "Een \"Voorrang\" bord (Geef Voorrang bord) betekent dat je moet afremmen en voorrang moet geven aan het verkeer op de voorrangsweg. Je hoeft niet volledig te stoppen, tenzij nodig.",
      "ar": "علامة \"أعطِ الأولوية\" (علامة إعطاء الأولوية) تعني أنه يجب عليك التباطؤ وإعطاء الأولوية لحركة المرور على الطريق ذو الأولوية. لا تحتاج إلى التوقف تمامًا ما لم يكن ذلك ضروريًا."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-02-05-add2",
    "text": {
      "en": "You are driving and see a \"Stop\" sign. What must you do?",
      "nl": "Je rijdt en ziet een \"Stop\" bord. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى علامة \"توقف\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add2o1",
        "text": {
          "en": "Stop completely and give way to all traffic",
          "nl": "Stop volledig en geef voorrang aan al het verkeer",
          "ar": "توقف تمامًا وامنح الأولوية لجميع المركبات"
        }
      },
      {
        "id": "real-2025-02-05-add2o2",
        "text": {
          "en": "Slow down only",
          "nl": "Vertraag alleen",
          "ar": "تباطأ فقط"
        }
      },
      {
        "id": "real-2025-02-05-add2o3",
        "text": {
          "en": "Continue if no other traffic",
          "nl": "Doorgaan als er geen ander verkeer is",
          "ar": "تابع إذا لم تكن هناك حركة مرور أخرى"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add2o1",
    "explanation": {
      "en": "A \"Stop\" sign requires you to stop completely at the stop line and give way to all traffic on the priority road before proceeding.",
      "nl": "Een \"Stop\" bord vereist dat je volledig stopt bij de stoplijn en voorrang geeft aan al het verkeer op de voorrangsweg voordat je verder gaat.",
      "ar": "علامة \"توقف\" تتطلب منك التوقف تمامًا عند خط التوقف وإعطاء الأولوية لجميع المركبات على الطريق الرئيسي قبل المتابعة."
    },
    "subject": "Priority Rules"
  },
  {
    "id": "real-2025-02-05-add3",
    "text": {
      "en": "You are driving and see a \"One Way\" sign. What does this mean?",
      "nl": "Je rijdt en ziet een \"Eenrichtingsverkeer\" bord. Wat betekent dit?",
      "ar": "أنت تقود السيارة وترى علامة \"اتجاه واحد\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add3o1",
        "text": {
          "en": "You may only drive in the direction indicated",
          "nl": "Je mag alleen rijden in de aangegeven richting",
          "ar": "يمكنك القيادة فقط في الاتجاه المحدد"
        }
      },
      {
        "id": "real-2025-02-05-add3o2",
        "text": {
          "en": "You may drive in either direction",
          "nl": "Je mag in beide richtingen rijden",
          "ar": "يمكنك القيادة في أي اتجاه"
        }
      },
      {
        "id": "real-2025-02-05-add3o3",
        "text": {
          "en": "Only one lane is available",
          "nl": "Er is maar één rijstrook beschikbaar",
          "ar": "يوجد ممر واحد فقط متاح"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add3o1",
    "explanation": {
      "en": "A \"One Way\" sign means you may only drive in the direction indicated by the sign. Driving in the opposite direction is prohibited and dangerous.",
      "nl": "Een \"Eenrichtingsverkeer\" bord betekent dat je alleen in de richting mag rijden die door het bord wordt aangegeven. Rijden in de tegenovergestelde richting is verboden en gevaarlijk.",
      "ar": "علامة \"اتجاه واحد\" تعني أنه يمكنك القيادة فقط في الاتجاه المحدد بواسطة العلامة. القيادة في الاتجاه المعاكس محظورة وخطيرة."
    },
    "subject": "Traffic Signs"
  },
  {
    "id": "real-2025-02-05-add4",
    "text": {
      "en": "You are driving and see a \"Bus Lane\" sign. What does this mean?",
      "nl": "Je rijdt en ziet een \"Busbaan\" bord. Wat betekent dit?",
      "ar": "أنت تقود السيارة وترى علامة \"ممر الحافلات\". ماذا يعني هذا؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add4o1",
        "text": {
          "en": "Only buses and authorized vehicles may use this lane",
          "nl": "Alleen bussen en geautoriseerde voertuigen mogen deze rijstrook gebruiken",
          "ar": "يمكن فقط للحافلات والمركبات المصرح بها استخدام هذا الممر"
        }
      },
      {
        "id": "real-2025-02-05-add4o2",
        "text": {
          "en": "All vehicles may use this lane",
          "nl": "Alle voertuigen mogen deze rijstrook gebruiken",
          "ar": "يمكن لجميع المركبات استخدام هذا الممر"
        }
      },
      {
        "id": "real-2025-02-05-add4o3",
        "text": {
          "en": "Buses are prohibited from this lane",
          "nl": "Bussen zijn verboden op deze rijstrook",
          "ar": "يُحظر على الحافلات استخدام هذا الممر"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add4o1",
    "explanation": {
      "en": "A \"Bus Lane\" sign means only buses and authorized vehicles (as indicated by signs) may use this lane. Other vehicles must not use bus lanes during operating hours.",
      "nl": "Een \"Busbaan\" bord betekent dat alleen bussen en geautoriseerde voertuigen (zoals aangegeven door borden) deze rijstrook mogen gebruiken. Andere voertuigen mogen de busbanen niet gebruiken tijdens de openingstijden.",
      "ar": "علامة \"ممر الحافلات\" تعني أن الحافلات والمركبات المصرح بها فقط (كما هو موضح في العلامات) يمكنها استخدام هذا الممر. يجب ألا تستخدم المركبات الأخرى ممرات الحافلات خلال ساعات العمل."
    },
    "subject": "Traffic Signs"
  },
  {
    "id": "real-2025-02-05-add5",
    "text": {
      "en": "You are driving and see a \"Cycle Lane\" sign. What should you do?",
      "nl": "Je rijdt en ziet een \"Fietspad\" bord. Wat moet je doen?",
      "ar": "أنت تقود السيارة وترى علامة \"ممر الدراجات\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add5o1",
        "text": {
          "en": "Give way to cyclists and do not drive in the cycle lane",
          "nl": "Geef voorrang aan fietsers en rij niet in het fietspad",
          "ar": "أعطِ الأولوية للدراجين ولا تقم بالقيادة في ممر الدراجات"
        }
      },
      {
        "id": "real-2025-02-05-add5o2",
        "text": {
          "en": "You may drive in the cycle lane",
          "nl": "U mag in het fietspad rijden",
          "ar": "يمكنك القيادة في ممر الدراجات"
        }
      },
      {
        "id": "real-2025-02-05-add5o3",
        "text": {
          "en": "Cyclists must give way to you",
          "nl": "Fietsers moeten u voorrang geven",
          "ar": "يجب على الدراجين إعطائك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add5o1",
    "explanation": {
      "en": "Cycle lanes are for cyclists only. You must give way to cyclists in cycle lanes and must not drive in them. When turning across a cycle lane, give way to cyclists.",
      "nl": "Fietspaden zijn alleen voor fietsers. U moet fietsers op fietspaden voorrang geven en mag er niet in rijden. Bij het afslaan over een fietspad moet u fietsers voorrang geven.",
      "ar": "ممرات الدراجات مخصصة فقط للدراجين. يجب عليك إعطاء الأولوية للدراجين في ممرات الدراجات ولا يجب عليك القيادة فيها. عند الانعطاف عبر ممر للدراجات، يجب عليك إعطاء الأولوية للدراجين."
    },
    "subject": "Bicycle Interactions"
  },
  {
    "id": "real-2025-02-05-add6",
    "text": {
      "en": "You are driving and see a \"Tram Lane\" sign. What should you do?",
      "nl": "U rijdt en ziet een bord \"Tram Lane\". Wat moet u doen?",
      "ar": "أنت تقود السيارة وترى علامة \"ممر الترام\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add6o1",
        "text": {
          "en": "Do not drive in the tram lane, give way to trams",
          "nl": "Rijd niet in het tramspoor, geef voorrang aan trams",
          "ar": "لا تقم بالقيادة في ممر الترام، أعطِ الأولوية للترام"
        }
      },
      {
        "id": "real-2025-02-05-add6o2",
        "text": {
          "en": "You may drive in the tram lane",
          "nl": "U mag in het tramspoor rijden",
          "ar": "يمكنك القيادة في ممر الترام"
        }
      },
      {
        "id": "real-2025-02-05-add6o3",
        "text": {
          "en": "Trams must give way to you",
          "nl": "Trams moeten u voorrang geven",
          "ar": "يجب على الترام إعطائك الأولوية"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add6o1",
    "explanation": {
      "en": "Tram lanes are for trams only. You must not drive in tram lanes and must give way to trams. Trams have priority over other vehicles.",
      "nl": "Tramwegen zijn alleen voor trams. U mag niet in tramwegen rijden en moet trams voorrang geven. Trams hebben voorrang op andere voertuigen.",
      "ar": "ممرات الترام مخصصة فقط للترام. يجب عليك عدم القيادة في ممرات الترام ويجب عليك إعطاء الأولوية للترام. الترام له أولوية على المركبات الأخرى."
    },
    "subject": "Tram Interactions"
  },
  {
    "id": "real-2025-02-05-add7",
    "text": {
      "en": "You are driving and see a \"Residential Area\" sign. What should you do?",
      "nl": "U rijdt en ziet een bord \"Woongebied\". Wat moet u doen?",
      "ar": "أنت تقود السيارة وترى علامة \"منطقة سكنية\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add7o1",
        "text": {
          "en": "Reduce speed and be extra cautious for pedestrians and children",
          "nl": "Verminder snelheid en wees extra voorzichtig voor voetgangers en kinderen",
          "ar": "قلل السرعة وكن أكثر حذرًا تجاه المشاة والأطفال"
        }
      },
      {
        "id": "real-2025-02-05-add7o2",
        "text": {
          "en": "Continue at normal speed",
          "nl": "Ga door met normale snelheid",
          "ar": "استمر بسرعة طبيعية"
        }
      },
      {
        "id": "real-2025-02-05-add7o3",
        "text": {
          "en": "Increase speed to pass through quickly",
          "nl": "Verhoog de snelheid om snel door te rijden",
          "ar": "زد السرعة للمرور بسرعة"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add7o1",
    "explanation": {
      "en": "Residential areas require you to reduce speed and be extra cautious for pedestrians and children who may be playing or crossing. The speed limit is typically 30 km/h.",
      "nl": "Woongebieden vereisen dat u uw snelheid vermindert en extra voorzichtig bent voor voetgangers en kinderen die mogelijk aan het spelen zijn of oversteken. De snelheidslimiet is meestal 30 km/u.",
      "ar": "تتطلب المناطق السكنية منك تقليل السرعة وأن تكون أكثر حذرًا تجاه المشاة والأطفال الذين قد يكونون يلعبون أو يعبرون. الحد الأقصى للسرعة عادةً 30 كم/س."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "real-2025-02-05-add8",
    "text": {
      "en": "You are driving and see a \"Playground\" sign. What should you do?",
      "nl": "U rijdt en ziet een bord \"Speeltuin\". Wat moet u doen?",
      "ar": "أنت تقود السيارة وترى علامة \"ملعب\". ماذا يجب أن تفعل؟"
    },
    "options": [
      {
        "id": "real-2025-02-05-add8o1",
        "text": {
          "en": "Reduce speed and be extra cautious for children",
          "nl": "Verminder snelheid en wees extra voorzichtig voor kinderen",
          "ar": "قلل السرعة وكن أكثر حذرًا من الأطفال"
        }
      },
      {
        "id": "real-2025-02-05-add8o2",
        "text": {
          "en": "Continue at the same speed",
          "nl": "Ga verder met dezelfde snelheid",
          "ar": "تابع بنفس السرعة"
        }
      },
      {
        "id": "real-2025-02-05-add8o3",
        "text": {
          "en": "Sound your horn to warn children",
          "nl": "Toet je claxon om kinderen te waarschuwen",
          "ar": "استخدم بوق سيارتك لتحذير الأطفال"
        }
      }
    ],
    "correctAnswerId": "real-2025-02-05-add8o1",
    "explanation": {
      "en": "Playground signs require you to reduce speed and be extra cautious for children who may be playing nearby. Children may run onto the road unexpectedly.",
      "nl": "Bordjes bij speelplaatsen vereisen dat je je snelheid vermindert en extra voorzichtig bent voor kinderen die in de buurt kunnen spelen. Kinderen kunnen onverwachts de weg op rennen.",
      "ar": "تتطلب علامات الملعب منك تقليل السرعة وأن تكون أكثر حذرًا من الأطفال الذين قد يلعبون بالقرب. قد يركض الأطفال إلى الطريق بشكل غير متوقع."
    },
    "subject": "Safety Rules"
  },
  {
    "id": "mock-warn-1",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-warn-1o1",
        "text": {
          "en": "Warning for traffic jams",
          "nl": "Waarschuwing voor verkeersopstoppingen",
          "ar": "تحذير من الازدحام المروري"
        }
      },
      {
        "id": "mock-warn-1o2",
        "text": {
          "en": "No overtaking",
          "nl": "Inhalen verboden",
          "ar": "ممنوع التجاوز"
        }
      },
      {
        "id": "mock-warn-1o3",
        "text": {
          "en": "End of motorway",
          "nl": "Einde autosnelweg",
          "ar": "نهاية الطريق السريع"
        }
      }
    ],
    "correctAnswerId": "mock-warn-1o1",
    "explanation": {
      "en": "This sign warns drivers of potential traffic jams ahead.",
      "nl": "Dit bord waarschuwt bestuurders voor mogelijke verkeersopstoppingen voor zich.",
      "ar": "تحذر هذه العلامة السائقين من احتمال حدوث ازدحام مروري أمامهم."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-1.jpg",
    "imageHint": "traffic jams warning",
    "questionType": "hotspot"
  },
  {
    "id": "mock-warn-2",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-warn-2o1",
        "text": {
          "en": "Pedestrian crossing",
          "nl": "Zebrapad",
          "ar": "معبر المشاة"
        }
      },
      {
        "id": "mock-warn-2o2",
        "text": {
          "en": "No entry for trains",
          "nl": "Geen toegang voor treinen",
          "ar": "ممنوع الدخول للقطارات"
        }
      },
      {
        "id": "mock-warn-2o3",
        "text": {
          "en": "Railroad crossing ahead with barriers",
          "nl": "Spoorwegovergang voor met hekken",
          "ar": "معبر سكة حديد أمامك مزود بحواجز"
        }
      }
    ],
    "correctAnswerId": "mock-warn-2o3",
    "explanation": {
      "en": "This sign indicates a railroad crossing ahead that is equipped with barriers.",
      "nl": "Dit bord geeft aan dat er een spoorwegovergang voor zich is die is uitgerust met hekken.",
      "ar": "تشير هذه العلامة إلى وجود معبر سكة حديد أمامك مزود بحواجز."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-2.jpg",
    "imageHint": "railroad barriers",
    "questionType": "hotspot"
  },
  {
    "id": "mock-warn-3",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-warn-3o1",
        "text": {
          "en": "Tramway crossing",
          "nl": "Tramovergang",
          "ar": "معبر الترام"
        }
      },
      {
        "id": "mock-warn-3o2",
        "text": {
          "en": "Rail crossing ahead with 1 railway",
          "nl": "Spoorwegovergang met 1 spoor",
          "ar": "معبر السكك الحديدية مع سكة واحدة"
        }
      },
      {
        "id": "mock-warn-3o3",
        "text": {
          "en": "Multiple railway tracks",
          "nl": "Meerdere spoorlijnen",
          "ar": "مسارات السكك الحديدية المتعددة"
        }
      }
    ],
    "correctAnswerId": "mock-warn-3o2",
    "explanation": {
      "en": "This sign (St. Andrew's cross) indicates a rail crossing ahead with a single railway track.",
      "nl": "Dit bord (Andreas kruis) geeft aan dat er een spoorwegovergang voor zich is met één spoor.",
      "ar": "تشير هذه العلامة (صليب القديس أندرو) إلى وجود معبر سكة حديد أمامك مع سكة واحدة."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-3.jpg",
    "imageHint": "single railway crossing",
    "questionType": "hotspot"
  },
  {
    "id": "mock-warn-4",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-warn-4o1",
        "text": {
          "en": "Two-way traffic ahead",
          "nl": "Tweerichtingsverkeer voor",
          "ar": "حركة مرور في اتجاهين أمامك"
        }
      },
      {
        "id": "mock-warn-4o2",
        "text": {
          "en": "One-way street",
          "nl": "straat met eenrichtingsverkeer",
          "ar": "طريق أحادي الاتجاه"
        }
      },
      {
        "id": "mock-warn-4o3",
        "text": {
          "en": "Overtaking permitted",
          "nl": "Inhalen toegestaan",
          "ar": "تجاوز مسموح"
        }
      }
    ],
    "correctAnswerId": "mock-warn-4o1",
    "explanation": {
      "en": "This sign warns that the road ahead carries two-way traffic, often encountered when leaving a one-way system.",
      "nl": "Dit bord waarschuwt dat de weg voor je tweerichtingsverkeer heeft, vaak te vinden bij het verlaten van een eenrichtingsverkeer.",
      "ar": "هذا العلام يحذر من أن الطريق أمامك يحتوي على حركة مرور في اتجاهين، وغالبًا ما يتم مواجهته عند مغادرة نظام اتجاه واحد."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-4.jpg",
    "imageHint": "two way traffic",
    "questionType": "hotspot"
  },
  {
    "id": "mock-warn-5",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-warn-5o1",
        "text": {
          "en": "Sharp right turn",
          "nl": "Steile bocht naar rechts",
          "ar": "منعطف حاد إلى اليمين"
        }
      },
      {
        "id": "mock-warn-5o2",
        "text": {
          "en": "Winding road for 1km",
          "nl": "Bochtige weg voor 1 km",
          "ar": "طريق متعرج لمسافة 1 كم"
        }
      },
      {
        "id": "mock-warn-5o3",
        "text": {
          "en": "Double curve ahead, to the left then to the right",
          "nl": "Dubbele bocht voor, eerst naar links dan naar rechts",
          "ar": "منحنى مزدوج أمامك، أولاً إلى اليسار ثم إلى اليمين"
        }
      }
    ],
    "correctAnswerId": "mock-warn-5o3",
    "explanation": {
      "en": "This sign warns of a double curve ahead, the first to the left, followed by a curve to the right.",
      "nl": "Dit bord waarschuwt voor een dubbele bocht voor je, de eerste naar links, gevolgd door een bocht naar rechts.",
      "ar": "هذا العلام يحذر من وجود منحنى مزدوج أمامك، الأول إلى اليسار، يليه منحنى إلى اليمين."
    },
    "subject": "Warning Signs",
    "imageUrl": "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/warning/q-new-warn-5.jpg",
    "imageHint": "double curve left right",
    "questionType": "hotspot"
  },
  {
    "id": "mock-prohibit-1",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-prohibit-1o1",
        "text": {
          "en": "Maximum speed 50 km/h",
          "nl": "Maximale snelheid 50 km/u",
          "ar": "السرعة القصوى 50 كم/ساعة"
        }
      },
      {
        "id": "mock-prohibit-1o2",
        "text": {
          "en": "Speed limit ends",
          "nl": "Einde snelheidslimiet",
          "ar": "نهاية حد السرعة"
        }
      },
      {
        "id": "mock-prohibit-1o3",
        "text": {
          "en": "Minimum speed 50 km/h",
          "nl": "Minimale snelheid 50 km/u",
          "ar": "السرعة الدنيا 50 كم/ساعة"
        }
      }
    ],
    "correctAnswerId": "mock-prohibit-1o2",
    "explanation": {
      "en": "This sign indicates the end of a previously imposed 50 km/h speed limit. National or other posted speed limits now apply.",
      "nl": "Dit bord geeft het einde aan van een eerder opgelegde snelheidslimiet van 50 km/u. Nationale of andere aangegeven snelheidslimieten zijn nu van toepassing.",
      "ar": "هذا العلام يشير إلى نهاية حد السرعة المفروض سابقًا 50 كم/ساعة. الآن تنطبق حدود السرعة الوطنية أو الأخرى المعلنة."
    },
    "subject": "Prohibitory Signs",
    "imageHint": "speed limit ends"
  },
  {
    "id": "mock-prohibit-2",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-prohibit-2o1",
        "text": {
          "en": "Vehicles weighing heavier than indicated forbidden",
          "nl": "Voertuigen zwaarder dan aangegeven verboden",
          "ar": "ممنوع دخول المركبات التي تزن أكثر من المحدد"
        }
      },
      {
        "id": "mock-prohibit-2o2",
        "text": {
          "en": "No entry for lorries",
          "nl": "Geen toegang voor vrachtwagens",
          "ar": "ممنوع الدخول للشاحنات"
        }
      },
      {
        "id": "mock-prohibit-2o3",
        "text": {
          "en": "Axle weight limit 5,4t",
          "nl": "Aslastlimiet 5,4t",
          "ar": "حد وزن المحور 5.4 طن"
        }
      }
    ],
    "correctAnswerId": "mock-prohibit-2o1",
    "explanation": {
      "en": "This sign prohibits vehicles with an actual weight exceeding 5,4 tonnes from proceeding.",
      "nl": "Dit bord verbiedt voertuigen met een werkelijke massa van meer dan 5,4 ton om door te rijden.",
      "ar": "هذا العلام يمنع المركبات التي يتجاوز وزنها الفعلي 5.4 طن من المتابعة."
    },
    "subject": "Prohibitory Signs",
    "imageHint": "weight limit 5.4t"
  },
  {
    "id": "mock-prohibit-3",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-prohibit-3o1",
        "text": {
          "en": "Agricultural vehicles route",
          "nl": "Route voor landbouwvoertuigen",
          "ar": "مسار المركبات الزراعية"
        }
      },
      {
        "id": "mock-prohibit-3o2",
        "text": {
          "en": "No entry for slow vehicles",
          "nl": "Geen toegang voor langzame voertuigen",
          "ar": "ممنوع الدخول للمركبات البطيئة"
        }
      },
      {
        "id": "mock-prohibit-3o3",
        "text": {
          "en": "Tractors prohibited",
          "nl": "Tractoren verboden",
          "ar": "ممنوع دخول الجرارات"
        }
      }
    ],
    "correctAnswerId": "mock-prohibit-3o3",
    "explanation": {
      "en": "This sign indicates that tractors and other specified agricultural vehicles are prohibited from this road.",
      "nl": "Dit bord geeft aan dat tractoren en andere gespecificeerde landbouwvoertuigen verboden zijn op deze weg.",
      "ar": "تشير هذه العلامة إلى أن الجرارات وغيرها من المركبات الزراعية المحددة ممنوعة من هذه الطريق."
    },
    "subject": "Prohibitory Signs",
    "imageHint": "no tractors"
  },
  {
    "id": "mock-prohibit-4",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-prohibit-4o1",
        "text": {
          "en": "Cyclists not permitted",
          "nl": "Fietsers niet toegestaan",
          "ar": "غير مسموح بالدراجين"
        }
      },
      {
        "id": "mock-prohibit-4o2",
        "text": {
          "en": "Cycle route ahead",
          "nl": "Fietspad voor",
          "ar": "مسار الدراجات أمامك"
        }
      },
      {
        "id": "mock-prohibit-4o3",
        "text": {
          "en": "Shared path for pedestrians and cyclists",
          "nl": "Gedeeld pad voor voetgangers en fietsers",
          "ar": "مسار مشترك للمشاة وراكبي الدراجات"
        }
      }
    ],
    "correctAnswerId": "mock-prohibit-4o1",
    "explanation": {
      "en": "This sign means no entry for bicycles. Cyclists must find an alternative route.",
      "nl": "Dit bord betekent geen toegang voor fietsen. Fietsers moeten een alternatieve route vinden.",
      "ar": "تشير هذه العلامة إلى أنه ممنوع دخول الدراجات. يجب على راكبي الدراجات العثور على مسار بديل."
    },
    "subject": "Prohibitory Signs",
    "imageHint": "no cyclists"
  },
  {
    "id": "mock-prohibit-5",
    "text": {
      "en": "Identify the road sign:",
      "nl": "Identificeer het verkeersbord:",
      "ar": "حدد علامة الطريق:"
    },
    "options": [
      {
        "id": "mock-prohibit-5o1",
        "text": {
          "en": "No parking zone",
          "nl": "Parkeerverbod",
          "ar": "منطقة ممنوع فيها الوقوف"
        }
      },
      {
        "id": "mock-prohibit-5o2",
        "text": {
          "en": "Stopping and parking forbidden",
          "nl": "Stoppen en parkeren verboden",
          "ar": "ممنوع التوقف والركن"
        }
      },
      {
        "id": "mock-prohibit-5o3",
        "text": {
          "en": "Clearway, no stopping on carriageway",
          "nl": "Vrije doorgang, niet stoppen op de rijbaan",
          "ar": "طريق خالٍ، لا توقف على الطريق"
        }
      }
    ],
    "correctAnswerId": "mock-prohibit-5o2",
    "explanation": {
      "en": "This sign indicates that stopping and parking are forbidden along this section of road.",
      "nl": "Dit bord geeft aan dat stoppen en parkeren verboden zijn langs dit gedeelte van de weg.",
      "ar": "تشير هذه العلامة إلى أن التوقف والركن ممنوعان على طول هذا الجزء من الطريق."
    },
    "subject": "Prohibitory Signs",
    "imageHint": "no stopping parking"
  }
];
